import { ether, matic, ChainType, invariant, failure, success, Kind, erc20, Amount, assertNever, never, CausedError, BigDecimal, Deferred, DateUtils, InvariantError, assertError, nonNullable, Denomination, getID, hasAtLeastOne } from '@lens-protocol/shared-kernel';
export { Amount, ChainType, Denomination, erc20, ether, matic, usd } from '@lens-protocol/shared-kernel';
import React, { useContext, useState, useCallback, useEffect, useMemo, useRef } from 'react';
import { CredentialsExpiredError, Bootstrap } from '@lens-protocol/domain/use-cases/lifecycle';
import { FollowPolicyType, ActiveProfileLoader, SwitchActiveProfile, DuplicatedHandleError, CreateProfile, UpdateProfileImage, isPaidFollowRequest, isProfileOwnerFollowRequest, FollowProfiles, UnfollowProfile, UpdateDispatcherConfig, UpdateFollowPolicy, UpdateProfileDetails } from '@lens-protocol/domain/use-cases/profile';
export { DuplicatedHandleError, FollowPolicyType } from '@lens-protocol/domain/use-cases/profile';
import { makeVar, useReactiveVar } from '@apollo/client';
import { GetAllProfilesByOwnerAddressDocument, GetProfileDocument, omitTypename, CreateSetFollowModuleTypedDataDocument, BroadcastProtocolCallDocument, CommentFragmentDoc, PostFragmentDoc, MirrorFragmentDoc, recentTransactionsVar, TxStatus, isMirrorPublication, isContentPublication, PublicationByTxHashDocument, isPostPublication, PublicationMainFocus, ProfileFragmentDoc, HasTxHashBeenIndexedDocument, ProxyActionStatusDocument, ProxyActionStatusTypes, TransactionErrorReasons, AuthChallengeDocument, AuthAuthenticateDocument, AuthRefreshDocument, createAnonymousApolloClient, createApolloClient, UnspecifiedError, useCommentsQuery, usePublicationQuery, usePublicationsQuery, useSearchPublicationsQuery, PublicationSortCriteria, useExplorePublicationsQuery, AddReactionDocument, getApiReactionType, ValidationError, RemoveReactionDocument, getDomainReactionType, useWhoReactedPublicationQuery, ReportPublicationDocument, PublicationReportingReason, PublicationReportingSpamSubreason, PublicationReportingSensitiveSubreason, PublicationReportingFraudSubreason, PublicationReportingIllegalSubreason, HidePublicationDocument, useWhoCollectedPublicationQuery, useGetAllProfilesByWhoMirroredPublicationQuery, useProfilePublicationsForSaleQuery, isGatedPublication, FeedEventItemType as FeedEventItemType$1, useFeedQuery, useEnabledModuleCurrenciesQuery, useEnabledModulesQuery, useGetProfileQuery, isProfileOwnedByMe, RelayErrorReasons, CreateProfileDocument, useWaitUntilTransactionSettled, useProfilesToFollowQuery, useProfileFollowersQuery, useProfileFollowingQuery, useExploreProfilesQuery, useSearchProfilesQuery, useWalletCollectedPublicationsQuery, useMutualFollowersProfilesQuery, CreateSetProfileImageUriTypedDataDocument, CreateSetProfileImageUriViaDispatcherDocument, useGetAllProfilesByOwnerAddressQuery, useProfileFollowRevenueQuery, usePublicationRevenueQuery, useProfilePublicationRevenueQuery, ProxyActionDocument, CreateCollectTypedDataDocument, createCollectRequest, CreateCommentTypedDataDocument, CreateCommentViaDispatcherDocument, PublicationMetadataDisplayTypes, CreatePostTypedDataDocument, CreatePostViaDispatcherDocument, ContractType, ScalarOperator, PublicationsDocument, CreateMirrorTypedDataDocument, CreateMirrorViaDispatcherDocument, CreateFollowTypedDataDocument, moduleFeeAmountParams, useHasPendingTransaction, isUnfollowTransactionFor, useRecentTransactionsVar, CreateUnfollowTypedDataDocument, isFollowTransactionFor, CreateSetDispatcherTypedDataDocument, CreateSetProfileMetadataTypedDataDocument, CreateSetProfileMetadataViaDispatcherDocument, useUnreadNotificationCountQuery, useNotificationsQuery } from '@lens-protocol/api-bindings';
export { CollectState, PublicationSortCriteria, PublicationTypes, TxStatus, isCommentPublication, isContentPublication, isMirrorPublication, isPostPublication, isProfileOwnedByMe, isPublicationOwnedByMe, isValidHandle } from '@lens-protocol/api-bindings';
import { Profile, Wallet, UserRejectedError, SignedProtocolCall, PendingSigningRequestError, InsufficientGasError, TransactionKind, ProxyActionStatus, MetaTransaction, NativeTransaction, ProxyTransaction, TransactionError, TransactionErrorReason, TransactionEvent, WalletConnectionError, WalletConnectionErrorReason, ReactionType, ReportReason, UnsignedTransaction, DecryptionCriteriaType, NftContractType, Erc20ComparisonOperator } from '@lens-protocol/domain/entities';
export { DecryptionCriteriaType, Erc20ComparisonOperator, InsufficientGasError, NftContractType, PendingSigningRequestError, ReactionType, ReportReason, TransactionError, TransactionErrorReason, UserRejectedError, WalletConnectionError, WalletConnectionErrorReason } from '@lens-protocol/domain/entities';
import { TransactionQueue, ProtocolCallUseCase, SignlessProtocolCallUseCase } from '@lens-protocol/domain/use-cases/transactions';
import { TokenAllowanceLimit, ActiveWallet, TokenAvailability, WalletLogin, WalletLogout, LogoutReason, TokenAllowance } from '@lens-protocol/domain/use-cases/wallets';
export { TokenAllowanceLimit } from '@lens-protocol/domain/use-cases/wallets';
import { z } from 'zod';
import { BaseStorageSchema, Storage } from '@lens-protocol/storage';
import { errors, utils, constants } from 'ethers';
import { NftAttributeDisplayType, CollectPolicyType, SupportedFileType, ReferencePolicyType, ContentFocus, CollectType, Reaction, ReportPublication, HidePublication, CollectPublication, CreateComment, CreatePost, CreateMirror } from '@lens-protocol/domain/use-cases/publications';
export { AudioType, CollectPolicyType, ContentFocus, ImageType, NftAttributeDisplayType, ReferencePolicyType, SupportedFileType, VideoType } from '@lens-protocol/domain/use-cases/publications';
import { erc20 as erc20$1, isTheSameAddress, bigNumber } from '@lens-protocol/blockchain-bindings';
import jwtDecode from 'jwt-decode';
import isObject from 'lodash/isObject.js';
import { JsonRpcProvider } from '@ethersproject/providers';
import { jsx } from 'react/jsx-runtime';
import differenceBy from 'lodash/differenceBy.js';
import { v4 } from 'uuid';
import { InvariantError as InvariantError$1 } from '@apollo/client/utilities/globals';
import * as GatedContent from '@lens-protocol/gated-content';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var mainnet = {
  chainId: 1,
  name: 'Ethereum',
  rpcUrl: 'https://mainnet.infura.io/v3',
  blockExplorer: 'https://etherscan.io/',
  nativeCurrency: ether()
};
var goerli = {
  chainId: 5,
  name: 'Goerli',
  rpcUrl: 'https://goerli.infura.io/v3',
  blockExplorer: 'https://goerli.etherscan.io/',
  nativeCurrency: ether()
};
var polygon = {
  chainId: 137,
  name: 'Polygon Mainnet',
  rpcUrl: 'https://polygon-rpc.com/',
  blockExplorer: 'https://polygonscan.com/',
  nativeCurrency: matic()
};
var mumbai = {
  chainId: 80001,
  name: 'Polygon Testnet Mumbai',
  rpcUrl: 'https://rpc-mumbai.maticvigil.com/',
  blockExplorer: 'https://mumbai.polygonscan.com/',
  nativeCurrency: matic()
};

var _chains, _chains2;
var production = {
  backend: 'https://api.lens.dev',
  chains: (_chains = {}, _defineProperty(_chains, ChainType.ETHEREUM, mainnet), _defineProperty(_chains, ChainType.POLYGON, polygon), _chains),
  timings: {
    pollingInterval: 3000,
    maxIndexingWaitTime: 120000,
    maxMiningWaitTime: 60000
  },
  handleResolver: function handleResolver(handle) {
    return "".concat(handle, ".lens");
  }
};
var staging = {
  backend: 'https://api-mumbai.lens.dev',
  chains: (_chains2 = {}, _defineProperty(_chains2, ChainType.ETHEREUM, goerli), _defineProperty(_chains2, ChainType.POLYGON, mumbai), _chains2),
  timings: {
    pollingInterval: 3000,
    maxIndexingWaitTime: 240000,
    maxMiningWaitTime: 120000
  },
  handleResolver: function handleResolver(handle) {
    return "".concat(handle, ".test");
  }
};

var DEFAULT_PAGINATED_QUERY_LIMIT = 10;
function appId(value) {
  // for now just asserts the type, in future it will enforce a format
  return value;
}

var sources = {
  lenster: appId('lenster'),
  orb: appId('orb')
};

function validateConfig(config) {
  var _config$sources;
  invariant(!(config.appId && config.sources && !((_config$sources = config.sources) !== null && _config$sources !== void 0 && _config$sources.includes(config.appId))), "LensProvider config: \"sources\" don't include your \"appId\"");
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var ApplicationsState;
(function (ApplicationsState) {
  ApplicationsState["LOADING"] = "LOADING";
  ApplicationsState["READY"] = "READY";
})(ApplicationsState || (ApplicationsState = {}));
var applicationState = makeVar(ApplicationsState.LOADING);
var ApplicationPresenter = /*#__PURE__*/function () {
  function ApplicationPresenter() {
    _classCallCheck(this, ApplicationPresenter);
  }
  _createClass(ApplicationPresenter, [{
    key: "signalReady",
    value: function signalReady() {
      applicationState(ApplicationsState.READY);
    }
  }]);
  return ApplicationPresenter;
}();
function useAppState() {
  return useReactiveVar(applicationState);
}

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var activeProfileIdentifierVar = makeVar(null);
var ActiveProfilePresenter = /*#__PURE__*/function () {
  function ActiveProfilePresenter() {
    _classCallCheck(this, ActiveProfilePresenter);
  }
  _createClass(ActiveProfilePresenter, [{
    key: "presentActiveProfile",
    value: function () {
      var _presentActiveProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(profileIdentifier) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              activeProfileIdentifierVar(profileIdentifier);
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function presentActiveProfile(_x) {
        return _presentActiveProfile.apply(this, arguments);
      }
      return presentActiveProfile;
    }()
  }]);
  return ActiveProfilePresenter;
}();
function useActiveProfileIdentifierVar() {
  return useReactiveVar(activeProfileIdentifierVar);
}

function useActiveProfileIdentifier() {
  var state = useAppState();
  var identifier = useActiveProfileIdentifierVar();
  if (state !== ApplicationsState.READY) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  return {
    data: identifier,
    error: undefined,
    loading: false
  };
}

/* eslint-disable no-console */

var ConsoleLogger = /*#__PURE__*/function () {
  function ConsoleLogger() {
    _classCallCheck(this, ConsoleLogger);
  }
  _createClass(ConsoleLogger, [{
    key: "info",
    value: function info(message, data) {
      console.info(message, data);
    }
  }, {
    key: "debug",
    value: function debug(message, data) {
      console.info(message, data);
    }
  }, {
    key: "warn",
    value: function warn(message, data) {
      console.error(message, data);
    }
  }, {
    key: "error",
    value: function error(_error, message, data) {
      console.error(message, _error, data);
    }
  }, {
    key: "fatal",
    value: function fatal(error, message, data) {
      console.error(message, error, data);
    }
  }]);
  return ConsoleLogger;
}();

var StoredActiveProfileData = z.object({
  id: z.string(),
  handle: z.string()
});
var ActiveProfileGateway = /*#__PURE__*/function () {
  function ActiveProfileGateway(activeProfileStorage) {
    _classCallCheck(this, ActiveProfileGateway);
    this.activeProfileStorage = activeProfileStorage;
  }
  _createClass(ActiveProfileGateway, [{
    key: "setActiveProfile",
    value: function () {
      var _setActiveProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(profile) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.activeProfileStorage.set(profile);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setActiveProfile(_x) {
        return _setActiveProfile.apply(this, arguments);
      }
      return setActiveProfile;
    }()
  }, {
    key: "getActiveProfile",
    value: function () {
      var _getActiveProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.activeProfileStorage.get();
            case 2:
              data = _context2.sent;
              if (data) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", null);
            case 5:
              return _context2.abrupt("return", data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getActiveProfile() {
        return _getActiveProfile.apply(this, arguments);
      }
      return getActiveProfile;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.activeProfileStorage.reset();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }]);
  return ActiveProfileGateway;
}();

var ProfileGateway = /*#__PURE__*/function () {
  function ProfileGateway(apolloClient) {
    _classCallCheck(this, ProfileGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(ProfileGateway, [{
    key: "getAllProfilesByOwnerAddress",
    value: function () {
      var _getAllProfilesByOwnerAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(address) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.query({
                query: GetAllProfilesByOwnerAddressDocument,
                // 'sources' and 'observerId' are not needed. We just use 'id' and 'handle' for now.
                variables: {
                  address: address,
                  limit: 10
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              return _context.abrupt("return", data.result.items.map(function (_ref) {
                var id = _ref.id,
                  handle = _ref.handle;
                return Profile.create({
                  id: id,
                  handle: handle
                });
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAllProfilesByOwnerAddress(_x) {
        return _getAllProfilesByOwnerAddress.apply(this, arguments);
      }
      return getAllProfilesByOwnerAddress;
    }()
  }, {
    key: "getProfileByHandle",
    value: function () {
      var _getProfileByHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.apolloClient.query({
                query: GetProfileDocument,
                // 'sources' and 'observerId' are not needed. We just use 'id' and 'handle' for now.
                variables: {
                  request: {
                    handle: handle
                  }
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context2.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result === null)) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return", null);
            case 6:
              return _context2.abrupt("return", Profile.create({
                id: data.result.id,
                handle: data.result.handle
              }));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProfileByHandle(_x2) {
        return _getProfileByHandle.apply(this, arguments);
      }
      return getProfileByHandle;
    }()
  }, {
    key: "getProfileById",
    value: function () {
      var _getProfileById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(profileId) {
        var _yield$this$apolloCli3, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.query({
                query: GetProfileDocument,
                // 'sources' and 'observerId' are not needed. We just use 'id' and 'handle' for now.
                variables: {
                  request: {
                    profileId: profileId
                  }
                }
              });
            case 2:
              _yield$this$apolloCli3 = _context3.sent;
              data = _yield$this$apolloCli3.data;
              if (!(data.result === null)) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", null);
            case 6:
              return _context3.abrupt("return", Profile.create({
                id: data.result.id,
                handle: data.result.handle
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProfileById(_x3) {
        return _getProfileById.apply(this, arguments);
      }
      return getProfileById;
    }()
  }]);
  return ProfileGateway;
}();

var ActiveProfileStorageDataSchema = new BaseStorageSchema('lens.activeProfile', StoredActiveProfileData);
function createActiveProfileStorage(storageProvider) {
  return Storage.createForSchema(ActiveProfileStorageDataSchema, storageProvider);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

function assertErrorObjectWithCode(error) {
  if (!Object.prototype.hasOwnProperty.call(error, 'code')) {
    throw error;
  }
}

var WalletDataSchema = z.object({
  address: z.string()
});
var UnsignedLensProtocolCall = /*#__PURE__*/function () {
  function UnsignedLensProtocolCall(id, request, typedData) {
    _classCallCheck(this, UnsignedLensProtocolCall);
    this.id = id;
    this.request = request;
    this.typedData = typedData;
  }
  _createClass(UnsignedLensProtocolCall, [{
    key: "nonce",
    get: function get() {
      return this.typedData.value.nonce;
    }
  }]);
  return UnsignedLensProtocolCall;
}();
var ConcreteWallet = /*#__PURE__*/function (_Wallet) {
  _inherits(ConcreteWallet, _Wallet);
  var _super = _createSuper(ConcreteWallet);
  function ConcreteWallet(data, signerFactory, transactionFactory) {
    var _this;
    _classCallCheck(this, ConcreteWallet);
    _this = _super.call(this, data.address);
    _defineProperty(_assertThisInitialized(_this), "signingInProgress", false);
    _this.signerFactory = signerFactory;
    _this.transactionFactory = transactionFactory;
    return _this;
  }
  _createClass(ConcreteWallet, [{
    key: "signProtocolCall",
    value: function () {
      var _signProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(unsignedCall) {
        var result, signer, signature, signedCall;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.signerFactory.createSigner({
                address: this.address
              });
            case 2:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return", failure(result.error));
            case 5:
              if (!this.signingInProgress) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", failure(new PendingSigningRequestError()));
            case 7:
              this.signingInProgress = true;
              signer = result.value;
              _context.prev = 9;
              _context.next = 12;
              return signer._signTypedData(unsignedCall.typedData.domain, unsignedCall.typedData.types, unsignedCall.typedData.value);
            case 12:
              signature = _context.sent;
              signedCall = SignedProtocolCall.create({
                id: unsignedCall.id,
                request: unsignedCall.request,
                signature: signature,
                nonce: unsignedCall.nonce
              });
              return _context.abrupt("return", success(signedCall));
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](9);
              assertErrorObjectWithCode(_context.t0);
              if (!(_context.t0.code === errors.ACTION_REJECTED)) {
                _context.next = 22;
                break;
              }
              return _context.abrupt("return", failure(new UserRejectedError()));
            case 22:
              throw _context.t0;
            case 23:
              _context.prev = 23;
              this.signingInProgress = false;
              return _context.finish(23);
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[9, 17, 23, 26]]);
      }));
      function signProtocolCall(_x) {
        return _signProtocolCall.apply(this, arguments);
      }
      return signProtocolCall;
    }()
  }, {
    key: "signMessage",
    value: function () {
      var _signMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(message) {
        var result, signer;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.signerFactory.createSigner({
                address: this.address
              });
            case 2:
              result = _context2.sent;
              if (!result.isFailure()) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", failure(result.error));
            case 5:
              if (!this.signingInProgress) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", failure(new PendingSigningRequestError()));
            case 7:
              this.signingInProgress = true;
              signer = result.value;
              _context2.prev = 9;
              _context2.t0 = success;
              _context2.next = 13;
              return signer.signMessage(message);
            case 13:
              _context2.t1 = _context2.sent;
              return _context2.abrupt("return", (0, _context2.t0)(_context2.t1));
            case 17:
              _context2.prev = 17;
              _context2.t2 = _context2["catch"](9);
              assertErrorObjectWithCode(_context2.t2);
              if (!(_context2.t2.code === errors.ACTION_REJECTED)) {
                _context2.next = 22;
                break;
              }
              return _context2.abrupt("return", failure(new UserRejectedError()));
            case 22:
              throw _context2.t2;
            case 23:
              _context2.prev = 23;
              this.signingInProgress = false;
              return _context2.finish(23);
            case 26:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[9, 17, 23, 26]]);
      }));
      function signMessage(_x2) {
        return _signMessage.apply(this, arguments);
      }
      return signMessage;
    }()
  }, {
    key: "sendTransaction",
    value: function () {
      var _sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(unsignedTransaction) {
        var result, signer, response, transaction;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.signerFactory.createSigner({
                address: this.address,
                chainType: unsignedTransaction.chainType
              });
            case 2:
              result = _context3.sent;
              if (!result.isFailure()) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return", failure(result.error));
            case 5:
              if (!this.signingInProgress) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", failure(new PendingSigningRequestError()));
            case 7:
              this.signingInProgress = true;
              signer = result.value;
              _context3.prev = 9;
              _context3.next = 12;
              return signer.sendTransaction(unsignedTransaction.transactionRequest);
            case 12:
              response = _context3.sent;
              transaction = this.transactionFactory.createNativeTransaction({
                chainType: unsignedTransaction.chainType,
                id: unsignedTransaction.id,
                request: unsignedTransaction.request,
                txHash: response.hash
              });
              return _context3.abrupt("return", success(transaction));
            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3["catch"](9);
              assertErrorObjectWithCode(_context3.t0);
              _context3.t1 = _context3.t0.code;
              _context3.next = _context3.t1 === errors.ACTION_REJECTED ? 23 : _context3.t1 === errors.INSUFFICIENT_FUNDS ? 24 : 25;
              break;
            case 23:
              return _context3.abrupt("return", failure(new UserRejectedError(_context3.t0.message)));
            case 24:
              return _context3.abrupt("return", failure(new InsufficientGasError(matic())));
            case 25:
              throw _context3.t0;
            case 26:
              _context3.prev = 26;
              this.signingInProgress = false;
              return _context3.finish(26);
            case 29:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[9, 17, 26, 29]]);
      }));
      function sendTransaction(_x3) {
        return _sendTransaction.apply(this, arguments);
      }
      return sendTransaction;
    }()
  }, {
    key: "toWalletData",
    value: function toWalletData() {
      return {
        address: this.address
      };
    }
  }], [{
    key: "create",
    value: function create(data, signerFactory, transactionFactory) {
      return new ConcreteWallet(data, signerFactory, transactionFactory);
    }
  }]);
  return ConcreteWallet;
}(Wallet);

function buildFollowModuleRequest(request) {
  switch (request.policy.type) {
    case FollowPolicyType.CHARGE:
      return {
        feeFollowModule: {
          amount: {
            currency: request.policy.amount.asset.address,
            value: request.policy.amount.toSignificantDigits()
          },
          recipient: request.policy.recipient
        }
      };
    case FollowPolicyType.ANYONE:
      return {
        freeFollowModule: true
      };
    case FollowPolicyType.NO_ONE:
      return {
        revertFollowModule: true
      };
    case FollowPolicyType.ONLY_PROFILE_OWNERS:
      return {
        profileFollowModule: true
      };
  }
}
var FollowPolicyCallGateway = /*#__PURE__*/function () {
  function FollowPolicyCallGateway(apolloClient) {
    _classCallCheck(this, FollowPolicyCallGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(FollowPolicyCallGateway, [{
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetFollowModuleTypedDataDocument,
                variables: {
                  request: {
                    profileId: request.profileId,
                    followModule: buildFollowModuleRequest(request)
                  },
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              return _context.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createUnsignedProtocolCall(_x, _x2) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }]);
  return FollowPolicyCallGateway;
}();

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var Erc20Schema = z.object({
  kind: z.literal(Kind.ERC20),
  name: z.string(),
  decimals: z.number(),
  symbol: z.string(),
  address: z.string(),
  chainType: z.nativeEnum(ChainType)
}).transform(function (value) {
  return erc20(value);
});
var Erc20AmountSchema = z.object({
  asset: Erc20Schema,
  value: z.string()
}).transform(function (value) {
  return Amount.erc20(value.asset, value.value);
});

var TokenAllowanceRequestSchema = z.object({
  amount: Erc20AmountSchema,
  spender: z.string(),
  limit: z.nativeEnum(TokenAllowanceLimit),
  kind: z.literal(TransactionKind.APPROVE_MODULE)
});

var CreateProfileRequestSchema = z.object({
  handle: z.string(),
  kind: z.literal(TransactionKind.CREATE_PROFILE)
});
var FollowRequestFeeSchema = z.object({
  amount: Erc20AmountSchema,
  contractAddress: z.string(),
  recipient: z.string()
});
var UnconstrainedFollowRequestSchema = z.object({
  followerAddress: z.string(),
  profileId: z.string(),
  kind: z.literal(TransactionKind.FOLLOW_PROFILES)
});
var PaidFollowRequestSchema = z.object({
  followerAddress: z.string(),
  profileId: z.string(),
  kind: z.literal(TransactionKind.FOLLOW_PROFILES),
  fee: FollowRequestFeeSchema
});
var ProfileOwnerFollowRequestSchema = z.object({
  followerAddress: z.string(),
  profileId: z.string(),
  kind: z.literal(TransactionKind.FOLLOW_PROFILES),
  followerProfileId: z.string()
});
var UnfollowRequestSchema = z.object({
  profileId: z.string(),
  kind: z.literal(TransactionKind.UNFOLLOW_PROFILE)
});
var UpdateDispatcherConfigRequestSchema = z.object({
  profileId: z.string(),
  enabled: z["boolean"](),
  kind: z.literal(TransactionKind.UPDATE_DISPATCHER_CONFIG)
});
var ChargeFollowPolicySchema = z.object({
  type: z.literal(FollowPolicyType.CHARGE),
  amount: Erc20AmountSchema,
  recipient: z.string()
});
var NoFeeFollowPolicySchema = z.object({
  type: z.union([z.literal(FollowPolicyType.ANYONE), z.literal(FollowPolicyType.ONLY_PROFILE_OWNERS), z.literal(FollowPolicyType.NO_ONE)])
});
var UpdateFollowPolicyRequestSchema = z.object({
  profileId: z.string(),
  policy: z.union([ChargeFollowPolicySchema, NoFeeFollowPolicySchema]),
  kind: z.literal(TransactionKind.UPDATE_FOLLOW_POLICY)
});
var PartialAttributesUpdateSchema = z.record(z.union([z["boolean"](), z.date(), z.number(), z.string(), z["null"]()]));
var UpdateProfileDetailsRequestSchema = z.object({
  attributes: PartialAttributesUpdateSchema.optional(),
  bio: z.string().nullable().optional(),
  coverPicture: z.string().nullable().optional(),
  name: z.string(),
  profileId: z.string(),
  kind: z.literal(TransactionKind.UPDATE_PROFILE_DETAILS),
  delegate: z["boolean"]()
});
var NftOwnershipSignatureSchema = z.object({
  id: z.string(),
  signature: z.string()
});
var UpdateNftProfileImageRequestSchema = z.object({
  kind: z.literal(TransactionKind.UPDATE_PROFILE_IMAGE),
  profileId: z.string(),
  signature: NftOwnershipSignatureSchema,
  delegate: z["boolean"]()
});
var UpdateOffChainProfileImageRequestSchema = z.object({
  url: z.string(),
  kind: z.literal(TransactionKind.UPDATE_PROFILE_IMAGE),
  profileId: z.string(),
  delegate: z["boolean"]()
});

var NftAttributeSchema = z.union([z.object({
  displayType: z.literal(NftAttributeDisplayType.Date),
  value: z.date(),
  traitType: z.string()
}), z.object({
  displayType: z.literal(NftAttributeDisplayType.Number),
  value: z.number(),
  traitType: z.string()
}), z.object({
  displayType: z.literal(NftAttributeDisplayType.String),
  value: z.string(),
  traitType: z.string()
})]);
var NftMetadataSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
  attributes: z.array(NftAttributeSchema)
});
var ChargeCollectPolicySchema = z.object({
  type: z.literal(CollectPolicyType.CHARGE),
  fee: Erc20AmountSchema,
  recipient: z.string(),
  metadata: NftMetadataSchema,
  mirrorReward: z.number(),
  collectLimit: z.number().optional(),
  timeLimited: z["boolean"](),
  followersOnly: z["boolean"]()
});
var FreeCollectPolicySchema = z.object({
  type: z.literal(CollectPolicyType.FREE),
  metadata: NftMetadataSchema,
  followersOnly: z["boolean"]()
});
var NoCollectPolicySchema = z.object({
  type: z.literal(CollectPolicyType.NO_COLLECT)
});
var CollectPolicySchema = z.union([ChargeCollectPolicySchema, FreeCollectPolicySchema, NoCollectPolicySchema]);
var MediaSchema = z.object({
  altTag: z.string().optional(),
  cover: z.string().optional(),
  mimeType: z.nativeEnum(SupportedFileType),
  url: z.string()
});
var AnyoneReferencePolicySchema = z.object({
  type: z.literal(ReferencePolicyType.ANYONE)
});
var DegreesOfSeparationReferencePolicySchema = z.object({
  type: z.literal(ReferencePolicyType.DEGREES_OF_SEPARATION),
  params: z.object({
    commentsRestricted: z["boolean"](),
    mirrorsRestricted: z["boolean"](),
    degreesOfSeparation: z.number()
  })
});
var FollowersOnlyReferencePolicySchema = z.object({
  type: z.literal(ReferencePolicyType.FOLLOWERS_ONLY)
});
var ReferencePolicyConfigSchema = z.union([AnyoneReferencePolicySchema, DegreesOfSeparationReferencePolicySchema, FollowersOnlyReferencePolicySchema]);
var CreatePostRequestSchema = z.object({
  appId: z.string().transform(appId).optional(),
  content: z.string().optional(),
  contentFocus: z.nativeEnum(ContentFocus),
  media: z.array(MediaSchema).optional(),
  reference: ReferencePolicyConfigSchema,
  collect: CollectPolicySchema,
  profileId: z.string(),
  kind: z.literal(TransactionKind.CREATE_POST),
  locale: z.string(),
  delegate: z["boolean"]()
});
var CreateCommentRequestSchema = z.object({
  appId: z.string().transform(appId).optional(),
  publicationId: z.string(),
  content: z.string().optional(),
  contentFocus: z.nativeEnum(ContentFocus),
  media: z.array(MediaSchema).optional(),
  reference: ReferencePolicyConfigSchema,
  collect: CollectPolicySchema,
  profileId: z.string(),
  kind: z.literal(TransactionKind.CREATE_COMMENT),
  locale: z.string(),
  delegate: z["boolean"]()
});
var CreateMirrorRequestSchema = z.object({
  profileId: z.string(),
  publicationId: z.string(),
  kind: z.literal(TransactionKind.MIRROR_PUBLICATION),
  delegate: z["boolean"]()
});
var FreeCollectRequestSchema = z.object({
  profileId: z.string(),
  type: z.literal(CollectType.FREE),
  publicationId: z.string(),
  kind: z.literal(TransactionKind.COLLECT_PUBLICATION)
});
var CollectFeeSchema = z.object({
  amount: Erc20AmountSchema,
  contractAddress: z.string()
});
var PaidCollectRequestSchema = z.object({
  profileId: z.string(),
  type: z.literal(CollectType.PAID),
  publicationId: z.string(),
  fee: CollectFeeSchema,
  kind: z.literal(TransactionKind.COLLECT_PUBLICATION)
});

var SupportedRequestModelSchema = z.union([
// CollectRequest schemas
FreeCollectRequestSchema, PaidCollectRequestSchema,
// FollowRequest schemas
UnconstrainedFollowRequestSchema, PaidFollowRequestSchema, ProfileOwnerFollowRequestSchema, CreatePostRequestSchema, CreateCommentRequestSchema, CreateMirrorRequestSchema, CreateProfileRequestSchema, TokenAllowanceRequestSchema, UnfollowRequestSchema, UpdateDispatcherConfigRequestSchema, UpdateFollowPolicyRequestSchema, UpdateProfileDetailsRequestSchema,
// UpdateProfileImageRequest schemas
UpdateNftProfileImageRequestSchema, UpdateOffChainProfileImageRequestSchema]);
var TransactionType;
(function (TransactionType) {
  TransactionType[TransactionType["Native"] = 0] = "Native";
  TransactionType[TransactionType["Meta"] = 1] = "Meta";
  TransactionType[TransactionType["Proxy"] = 2] = "Proxy";
})(TransactionType || (TransactionType = {}));
var MetaTransactionSchema = z.object({
  type: z.literal(TransactionType.Meta),
  chainType: z.nativeEnum(ChainType),
  id: z.string(),
  indexingId: z.string(),
  txHash: z.string(),
  nonce: z.number(),
  request: SupportedRequestModelSchema
});
var NativeTransactionSchema = z.object({
  type: z.literal(TransactionType.Native),
  chainType: z.nativeEnum(ChainType),
  id: z.string(),
  indexingId: z.string().optional(),
  txHash: z.string(),
  request: SupportedRequestModelSchema
});
var ProxyTransactionSchema = z.object({
  type: z.literal(TransactionType.Proxy),
  chainType: z.nativeEnum(ChainType),
  id: z.string(),
  proxyId: z.string(),
  txHash: z.string().optional(),
  status: z.nativeEnum(ProxyActionStatus).optional(),
  request: SupportedRequestModelSchema
});
var TransactionSchema = z.union([MetaTransactionSchema, NativeTransactionSchema, ProxyTransactionSchema]);
var TransactionStorageSchema = z.array(TransactionSchema);

var _transactionKindToFil;
var lensHubTransactionKinds = [TransactionKind.COLLECT_PUBLICATION, TransactionKind.CREATE_COMMENT, TransactionKind.CREATE_POST, TransactionKind.FOLLOW_PROFILES, TransactionKind.MIRROR_PUBLICATION, TransactionKind.UPDATE_DISPATCHER_CONFIG, TransactionKind.UPDATE_PROFILE_IMAGE, TransactionKind.UPDATE_FOLLOW_POLICY];
var lensPeripheryTransactionKinds = [TransactionKind.UPDATE_PROFILE_DETAILS];
var transactionKindToFilterGroup = (_transactionKindToFil = {}, _defineProperty(_transactionKindToFil, TransactionKind.COLLECT_PUBLICATION, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.CREATE_COMMENT, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.CREATE_POST, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.FOLLOW_PROFILES, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.MIRROR_PUBLICATION, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.UPDATE_DISPATCHER_CONFIG, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.UPDATE_PROFILE_IMAGE, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.UPDATE_FOLLOW_POLICY, lensHubTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.UPDATE_PROFILE_DETAILS, lensPeripheryTransactionKinds), _defineProperty(_transactionKindToFil, TransactionKind.APPROVE_MODULE, []), _defineProperty(_transactionKindToFil, TransactionKind.CREATE_PROFILE, []), _defineProperty(_transactionKindToFil, TransactionKind.UNFOLLOW_PROFILE, []), _transactionKindToFil);
function isSerializableMetaTransaction(tx) {
  return tx instanceof MetaTransaction;
}
function toTransactionSchema(tx) {
  if (tx instanceof MetaTransaction) {
    var data = tx.toTransactionData();
    if (data === null) {
      return null;
    }
    return _objectSpread2({
      type: TransactionType.Meta
    }, data);
  }
  if (tx instanceof NativeTransaction) {
    var _data = tx.toTransactionData();
    if (_data === null) {
      return null;
    }
    return _objectSpread2({
      type: TransactionType.Native
    }, _data);
  }
  if (tx instanceof ProxyTransaction) {
    var _data2 = tx.toTransactionData();
    if (_data2 === null) {
      return null;
    }
    return _objectSpread2({
      type: TransactionType.Proxy
    }, _data2);
  }
  assertNever(tx, 'Transaction type not supported');
}
var PendingTransactionGateway = /*#__PURE__*/function () {
  function PendingTransactionGateway(storage, transactionFactory) {
    _classCallCheck(this, PendingTransactionGateway);
    this.storage = storage;
    this.transactionFactory = transactionFactory;
  }
  _createClass(PendingTransactionGateway, [{
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(tx) {
        var transactions, newTransactions, idx, expectedNonce;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getAll();
            case 2:
              transactions = _context.sent;
              newTransactions = _toConsumableArray(transactions);
              idx = transactions.findIndex(function (entry) {
                return entry.id === tx.id;
              });
              if (!(idx > -1)) {
                _context.next = 10;
                break;
              }
              newTransactions.splice(idx, 1, tx);
              _context.next = 9;
              return this.update(newTransactions);
            case 9:
              return _context.abrupt("return");
            case 10:
              if (!(tx instanceof MetaTransaction)) {
                _context.next = 15;
                break;
              }
              _context.next = 13;
              return this.getNextMetaTransactionNonceFor(tx.request.kind);
            case 13:
              expectedNonce = _context.sent;
              if (expectedNonce) {
                invariant(expectedNonce === tx.nonce, "Nonce mismatch, was expecting ".concat(expectedNonce, ", got ").concat(tx.nonce));
              }
            case 15:
              newTransactions.unshift(tx);
              _context.next = 18;
              return this.update(newTransactions);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function save(_x) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
        var transactions;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getAll();
            case 2:
              transactions = _context2.sent;
              _context2.next = 5;
              return this.update(transactions.filter(function (tx) {
                return tx.id !== id;
              }));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function remove(_x2) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this = this;
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.cache) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return", this.cache.slice());
            case 2:
              _context3.next = 4;
              return this.storage.get();
            case 4:
              data = _context3.sent;
              if (!(data === null)) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", []);
            case 7:
              return _context3.abrupt("return", data.map(function (entry) {
                return _this.toEntity(entry);
              }));
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAll() {
        return _getAll.apply(this, arguments);
      }
      return getAll;
    }()
  }, {
    key: "getNextMetaTransactionNonceFor",
    value: function () {
      var _getNextMetaTransactionNonceFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(kind) {
        var all, metaTransactions, filter, firstOfKind;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getAll();
            case 2:
              all = _context4.sent;
              if (!(all.length === 0)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 5:
              metaTransactions = all.filter(isSerializableMetaTransaction);
              if (!(metaTransactions.length === 0)) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return", undefined);
            case 8:
              if (!(kind in transactionKindToFilterGroup)) {
                _context4.next = 12;
                break;
              }
              filter = transactionKindToFilterGroup[kind];
              firstOfKind = metaTransactions.find(function (tx) {
                return filter.includes(tx.request.kind);
              });
              return _context4.abrupt("return", firstOfKind ? firstOfKind.nonce + 1 : undefined);
            case 12:
              return _context4.abrupt("return", undefined);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getNextMetaTransactionNonceFor(_x3) {
        return _getNextMetaTransactionNonceFor.apply(this, arguments);
      }
      return getNextMetaTransactionNonceFor;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(subscriber) {
      var _this2 = this;
      this.storage.subscribe( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(newData, oldData) {
          var _oldData$map;
          var updatedTransactions, previousTransactions, newTransaction;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                if (!(newData === null)) {
                  _context5.next = 2;
                  break;
                }
                return _context5.abrupt("return");
              case 2:
                updatedTransactions = newData.map(function (entry) {
                  return _this2.toEntity(entry);
                });
                previousTransactions = (_oldData$map = oldData === null || oldData === void 0 ? void 0 : oldData.map(function (entry) {
                  return _this2.toEntity(entry);
                })) !== null && _oldData$map !== void 0 ? _oldData$map : [];
                newTransaction = differenceBy(updatedTransactions, previousTransactions, function (tx) {
                  return tx.id;
                });
                if (newTransaction.length > 0) {
                  subscriber(newTransaction);
                }
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x4, _x5) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(transactions) {
        var data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.cache = transactions;
              data = transactions.map(toTransactionSchema).filter(function (v) {
                return v !== null;
              });
              _context6.next = 4;
              return this.storage.set(data);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function update(_x6) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "toEntity",
    value: function toEntity(data) {
      switch (data.type) {
        case TransactionType.Meta:
          return this.transactionFactory.createMetaTransaction(data);
        case TransactionType.Native:
          return this.transactionFactory.createNativeTransaction(data);
        case TransactionType.Proxy:
          return this.transactionFactory.createProxyTransaction(data);
        default:
          assertNever(data, 'Transaction type not supported');
      }
    }
  }]);
  return PendingTransactionGateway;
}();

var ProtocolCallRelayer = /*#__PURE__*/function () {
  function ProtocolCallRelayer(apolloClient, factory, logger) {
    _classCallCheck(this, ProtocolCallRelayer);
    this.apolloClient = apolloClient;
    this.factory = factory;
    this.logger = logger;
  }
  _createClass(ProtocolCallRelayer, [{
    key: "relayProtocolCall",
    value: function () {
      var _relayProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signedCall) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.factory.createMetaTransaction({
                chainType: ChainType.POLYGON,
                signedCall: signedCall,
                asyncRelayReceipt: this.broadcast(signedCall)
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function relayProtocolCall(_x) {
        return _relayProtocolCall.apply(this, arguments);
      }
      return relayProtocolCall;
    }()
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(signedCall) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.apolloClient.mutate({
                mutation: BroadcastProtocolCallDocument,
                variables: {
                  request: {
                    id: signedCall.id,
                    signature: signedCall.signature
                  }
                }
              });
            case 3:
              _yield$this$apolloCli = _context2.sent;
              data = _yield$this$apolloCli.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 7:
              return _context2.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              this.logger.error(_context2.t0, "It was not possible to relay the transaction for ".concat(signedCall.id));
              return _context2.abrupt("return", failure(new TransactionError(TransactionErrorReason.CANNOT_EXECUTE)));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 10]]);
      }));
      function broadcast(_x2) {
        return _broadcast.apply(this, arguments);
      }
      return broadcast;
    }()
  }]);
  return ProtocolCallRelayer;
}();

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}

var FragmentNotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(FragmentNotFoundError, _Error);
  var _super = _createSuper(FragmentNotFoundError);
  function FragmentNotFoundError() {
    var _this;
    _classCallCheck(this, FragmentNotFoundError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'FragmentNotFoundError');
    return _this;
  }
  return _createClass(FragmentNotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var getFragmentDoc = function getFragmentDoc(publication) {
  switch (publication.__typename) {
    case 'Mirror':
      return MirrorFragmentDoc;
    case 'Post':
      return PostFragmentDoc;
    case 'Comment':
      return CommentFragmentDoc;
    default:
      never("Can't infer fragment document");
  }
};
var PublicationCacheManager = /*#__PURE__*/function () {
  function PublicationCacheManager(cache) {
    _classCallCheck(this, PublicationCacheManager);
    this.cache = cache;
  }
  _createClass(PublicationCacheManager, [{
    key: "write",
    value: function write(publication) {
      this.cache.writeFragment({
        id: this.cache.identify({
          __typename: publication.__typename,
          id: publication.id
        }),
        fragmentName: publication.__typename,
        fragment: getFragmentDoc(publication),
        data: publication
      });
    }
  }, {
    key: "read",
    value: function read(publicationId) {
      var resolvedTypeResult = this.resolveExactPublicationType(publicationId);
      if (resolvedTypeResult.isFailure()) {
        return failure(resolvedTypeResult.error);
      }
      var _resolvedTypeResult$u = resolvedTypeResult.unwrap(),
        id = _resolvedTypeResult$u.id,
        fragment = _resolvedTypeResult$u.fragment,
        fragmentName = _resolvedTypeResult$u.fragmentName;
      var publication = this.cache.readFragment({
        id: id,
        fragmentName: fragmentName,
        fragment: fragment
      });

      // can't really happen as `resolveExactPublicationType` makes sure cache exists
      invariant(publication, 'Fragment not found');
      return success(publication);
    }
  }, {
    key: "update",
    value: function update(publicationId, updateFn) {
      var resolvedTypeResult = this.resolveExactPublicationType(publicationId);
      if (resolvedTypeResult.isFailure()) {
        return failure(resolvedTypeResult.error);
      }
      var _resolvedTypeResult$u2 = resolvedTypeResult.unwrap(),
        id = _resolvedTypeResult$u2.id,
        fragment = _resolvedTypeResult$u2.fragment,
        fragmentName = _resolvedTypeResult$u2.fragmentName;
      this.cache.updateFragment({
        id: id,
        fragmentName: fragmentName,
        fragment: fragment
      }, function (data) {
        // can't really happen as `resolveExactPublicationType` makes sure cache exists
        invariant(data, 'Fragment not found');
        return updateFn(data);
      });
      return success();
    }
  }, {
    key: "resolveExactPublicationType",
    value: function resolveExactPublicationType(publicationId) {
      var _this$cache$identify, _this$cache$identify2, _this$cache$identify3;
      var postIdentifier = (_this$cache$identify = this.cache.identify({
        __typename: 'Post',
        id: publicationId
      })) !== null && _this$cache$identify !== void 0 ? _this$cache$identify : never('Post identifier not found');
      var postArgs = {
        id: postIdentifier,
        fragmentName: 'Post',
        fragment: PostFragmentDoc
      };
      if (this.isInCache(postArgs)) {
        return success(postArgs);
      }
      var commentIdentifier = (_this$cache$identify2 = this.cache.identify({
        __typename: 'Comment',
        id: publicationId
      })) !== null && _this$cache$identify2 !== void 0 ? _this$cache$identify2 : never('Comment identifier not found');
      var commentArgs = {
        id: commentIdentifier,
        fragmentName: 'Comment',
        fragment: CommentFragmentDoc
      };
      if (this.isInCache(commentArgs)) {
        return success(commentArgs);
      }
      var mirrorIdentifier = (_this$cache$identify3 = this.cache.identify({
        __typename: 'Mirror',
        id: publicationId
      })) !== null && _this$cache$identify3 !== void 0 ? _this$cache$identify3 : never('Mirror identifier not found');
      var mirrorArgs = {
        id: mirrorIdentifier,
        fragmentName: 'Mirror',
        fragment: MirrorFragmentDoc
      };
      if (this.isInCache(mirrorArgs)) {
        return success(mirrorArgs);
      }
      return failure(new FragmentNotFoundError());
    }
  }, {
    key: "isInCache",
    value: function isInCache(args) {
      return !!this.cache.readFragment(args);
    }
  }]);
  return PublicationCacheManager;
}();

var FailedTransactionError = /*#__PURE__*/function (_CausedError) {
  _inherits(FailedTransactionError, _CausedError);
  var _super = _createSuper(FailedTransactionError);
  function FailedTransactionError(cause, data) {
    var _this;
    _classCallCheck(this, FailedTransactionError);
    _this = _super.call(this, "Failed ".concat(data.request.kind, " transaction due to ").concat(cause.reason), {
      cause: cause
    });
    _this.data = data;
    return _this;
  }
  return _createClass(FailedTransactionError);
}(CausedError);
var TransactionQueuePresenter = /*#__PURE__*/function () {
  function TransactionQueuePresenter(errorHandler) {
    _classCallCheck(this, TransactionQueuePresenter);
    this.errorHandler = errorHandler;
  }
  _createClass(TransactionQueuePresenter, [{
    key: "clearRecent",
    value: function clearRecent() {
      var transactions = recentTransactionsVar();
      var filteredTransactions = transactions.filter(function (tx) {
        return tx.status !== TxStatus.FAILED && tx.status !== TxStatus.SETTLED;
      });
      recentTransactionsVar(filteredTransactions);
    }
  }, {
    key: "broadcasting",
    value: function broadcasting(data) {
      this.addTransaction({
        id: data.id,
        status: TxStatus.BROADCASTING,
        request: data.request
      });
    }
  }, {
    key: "mining",
    value: function mining(data) {
      if (recentTransactionsVar().find(function (_ref) {
        var id = _ref.id;
        return id === data.id;
      })) {
        this.updateById(data.id, _objectSpread2(_objectSpread2({}, data), {}, {
          status: TxStatus.MINING
        }));
      } else {
        this.addTransaction({
          id: data.id,
          status: TxStatus.MINING,
          request: data.request,
          txHash: data.txHash
        });
      }
    }
  }, {
    key: "settled",
    value: function settled(data) {
      this.updateById(data.id, {
        status: TxStatus.SETTLED
      });
    }
  }, {
    key: "failed",
    value: function failed(error, data) {
      this.errorHandler(new FailedTransactionError(error, data));
      this.updateById(data.id, {
        status: TxStatus.FAILED
      });
    }
  }, {
    key: "addTransaction",
    value: function addTransaction(data) {
      var transactions = recentTransactionsVar();
      recentTransactionsVar([data].concat(_toConsumableArray(transactions)));
    }
  }, {
    key: "updateById",
    value: function updateById(id, update) {
      var transactions = recentTransactionsVar();
      recentTransactionsVar(transactions.map(function (data) {
        if (id === data.id) {
          return _objectSpread2(_objectSpread2({}, data), update);
        }
        return data;
      }));
    }
  }]);
  return TransactionQueuePresenter;
}();

function optimisticUpdate(publication) {
  return _objectSpread2(_objectSpread2({}, publication), {}, {
    hasOptimisticCollectedByMe: true,
    stats: _objectSpread2(_objectSpread2({}, publication.stats), {}, {
      totalAmountOfCollects: publication.stats.totalAmountOfCollects + 1
    })
  });
}
function confirmUpdate(publication) {
  return _objectSpread2(_objectSpread2({}, publication), {}, {
    hasCollectedByMe: true,
    hasOptimisticCollectedByMe: false
  });
}
function revertUpdate(publication) {
  return _objectSpread2(_objectSpread2({}, publication), {}, {
    hasCollectedByMe: false,
    hasOptimisticCollectedByMe: false,
    stats: _objectSpread2(_objectSpread2({}, publication.stats), {}, {
      totalAmountOfCollects: publication.stats.totalAmountOfCollects - 1
    })
  });
}
var CollectPublicationResponder = /*#__PURE__*/function () {
  function CollectPublicationResponder(publicationCacheManager) {
    _classCallCheck(this, CollectPublicationResponder);
    _defineProperty(this, "typeToFragmentMap", {
      Post: PostFragmentDoc,
      Comment: CommentFragmentDoc,
      Mirror: MirrorFragmentDoc
    });
    this.publicationCacheManager = publicationCacheManager;
  }
  _createClass(CollectPublicationResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              this.publicationCacheManager.update(request.publicationId, function (current) {
                if (isMirrorPublication(current)) {
                  return _objectSpread2(_objectSpread2({}, current), {}, {
                    mirrorOf: optimisticUpdate(current.mirrorOf)
                  });
                }
                return optimisticUpdate(current);
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request;
              this.publicationCacheManager.update(request.publicationId, function (current) {
                if (isMirrorPublication(current)) {
                  return _objectSpread2(_objectSpread2({}, current), {}, {
                    mirrorOf: confirmUpdate(current.mirrorOf)
                  });
                }
                return confirmUpdate(current);
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              this.publicationCacheManager.update(request.publicationId, function (current) {
                if (isMirrorPublication(current)) {
                  return _objectSpread2(_objectSpread2({}, current), {}, {
                    mirrorOf: revertUpdate(current.mirrorOf)
                  });
                }
                return revertUpdate(current);
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return CollectPublicationResponder;
}();

var CreateMirrorResponder = /*#__PURE__*/function () {
  function CreateMirrorResponder(client, publicationCacheManager, sources) {
    _classCallCheck(this, CreateMirrorResponder);
    this.client = client;
    this.publicationCacheManager = publicationCacheManager;
    this.sources = sources;
  }
  _createClass(CreateMirrorResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              this.publicationCacheManager.update(request.publicationId, function (current) {
                invariant(isContentPublication(current), "Cannot mirror a ".concat(current.__typename));
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  isOptimisticMirroredByMe: true,
                  stats: _objectSpread2(_objectSpread2({}, current.stats), {}, {
                    totalAmountOfMirrors: current.stats.totalAmountOfMirrors + 1
                  })
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request, txHash;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request, txHash = _ref2.txHash;
              _context2.next = 3;
              return this.client.query({
                query: PublicationByTxHashDocument,
                variables: {
                  txHash: txHash,
                  observerId: request.profileId,
                  sources: this.sources
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              this.publicationCacheManager.update(request.publicationId, function (current) {
                invariant(isContentPublication(current), "Cannot mirror a ".concat(current.__typename));
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  isOptimisticMirroredByMe: false
                });
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              this.publicationCacheManager.update(request.publicationId, function (current) {
                invariant(isContentPublication(current), "Cannot mirror a ".concat(current.__typename));
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  isOptimisticMirroredByMe: false,
                  stats: _objectSpread2(_objectSpread2({}, current.stats), {}, {
                    totalAmountOfMirrors: current.stats.totalAmountOfMirrors - 1
                  })
                });
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return CreateMirrorResponder;
}();

function pendingPostFragment(_ref) {
  var _request$content, _request$media$map, _request$media;
  var id = _ref.id,
    author = _ref.author,
    request = _ref.request;
  return {
    __typename: 'PendingPost',
    id: id,
    profile: author,
    content: (_request$content = request.content) !== null && _request$content !== void 0 ? _request$content : null,
    mainContentFocus: PublicationMainFocus[request.contentFocus],
    media: (_request$media$map = (_request$media = request.media) === null || _request$media === void 0 ? void 0 : _request$media.map(function (media) {
      var _media$altTag, _media$cover;
      return {
        __typename: 'Media',
        altTag: (_media$altTag = media.altTag) !== null && _media$altTag !== void 0 ? _media$altTag : null,
        cover: (_media$cover = media.cover) !== null && _media$cover !== void 0 ? _media$cover : null,
        mimeType: media.mimeType,
        url: media.url
      };
    })) !== null && _request$media$map !== void 0 ? _request$media$map : null,
    locale: request.locale
  };
}
var recentPosts = makeVar([]);
var CreatePostResponder = /*#__PURE__*/function () {
  function CreatePostResponder(profileCacheManager, client, sources) {
    _classCallCheck(this, CreatePostResponder);
    this.profileCacheManager = profileCacheManager;
    this.client = client;
    this.sources = sources;
  }
  _createClass(CreatePostResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var id, request, author, pendingPost;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              id = _ref2.id, request = _ref2.request;
              _context.next = 3;
              return this.profileCacheManager.fetchProfile({
                id: request.profileId
              });
            case 3:
              author = _context.sent;
              invariant(author, 'Cannot find author profile');
              pendingPost = pendingPostFragment({
                id: id,
                author: author,
                request: request
              });
              recentPosts([pendingPost].concat(_toConsumableArray(recentPosts())));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref3) {
        var id, txHash, request, publicationResult, publication;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = _ref3.id, txHash = _ref3.txHash, request = _ref3.request;
              _context2.next = 3;
              return this.client.query({
                query: PublicationByTxHashDocument,
                variables: {
                  txHash: txHash,
                  observerId: request.profileId,
                  sources: this.sources
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              publicationResult = _context2.sent;
              publication = publicationResult.data.result;
              invariant(publication, 'Publication by hash query should return data');
              invariant(isPostPublication(publication), 'Publication should be a post');
              recentPosts(recentPosts().map(function (post) {
                if (post.id === id) {
                  return publication;
                }
                return post;
              }));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref4) {
        var id;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              id = _ref4.id;
              recentPosts(recentPosts().filter(function (post) {
                return post.id !== id;
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return CreatePostResponder;
}();

var recentProfilesVar = makeVar([]);
var CreateProfileResponder = /*#__PURE__*/function () {
  function CreateProfileResponder(profileCacheManager, handleResolver) {
    _classCallCheck(this, CreateProfileResponder);
    this.profileCacheManager = profileCacheManager;
    this.handleResolver = handleResolver;
  }
  _createClass(CreateProfileResponder, [{
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request, profile;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              _context.next = 3;
              return this.profileCacheManager.fetchProfile({
                handle: this.handleResolver(request.handle)
              });
            case 3:
              profile = _context.sent;
              if (profile) {
                recentProfilesVar([].concat(_toConsumableArray(recentProfilesVar()), [profile]));
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function commit(_x) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }]);
  return CreateProfileResponder;
}();
function useRecentProfiles() {
  return useReactiveVar(recentProfilesVar);
}

var FollowProfilesResponder = /*#__PURE__*/function () {
  function FollowProfilesResponder(apolloCache) {
    _classCallCheck(this, FollowProfilesResponder);
    this.apolloCache = apolloCache;
  }
  _createClass(FollowProfilesResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request, profileIdentifier, snapshot;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              profileIdentifier = this.apolloCache.identify({
                __typename: 'Profile',
                id: request.profileId
              });
              snapshot = this.apolloCache.readFragment({
                id: profileIdentifier,
                fragmentName: 'Profile',
                fragment: ProfileFragmentDoc
              });
              if (snapshot) {
                this.apolloCache.writeFragment({
                  id: profileIdentifier,
                  fragmentName: 'Profile',
                  fragment: ProfileFragmentDoc,
                  data: _objectSpread2(_objectSpread2({}, snapshot), {}, {
                    stats: _objectSpread2(_objectSpread2({}, snapshot.stats), {}, {
                      totalFollowers: snapshot.stats.totalFollowers + 1
                    })
                  })
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request, profileIdentifier, snapshot;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request;
              profileIdentifier = this.apolloCache.identify({
                __typename: 'Profile',
                id: request.profileId
              });
              snapshot = this.apolloCache.readFragment({
                id: profileIdentifier,
                fragmentName: 'Profile',
                fragment: ProfileFragmentDoc
              });
              if (snapshot) {
                this.apolloCache.writeFragment({
                  id: profileIdentifier,
                  fragmentName: 'Profile',
                  fragment: ProfileFragmentDoc,
                  data: _objectSpread2(_objectSpread2({}, snapshot), {}, {
                    __isFollowedByMe: true,
                    stats: _objectSpread2(_objectSpread2({}, snapshot.stats), {}, {
                      totalFollowers: snapshot.stats.totalFollowers + 1
                    })
                  })
                });
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request, profileIdentifier, snapshot;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              profileIdentifier = this.apolloCache.identify({
                __typename: 'Profile',
                id: request.profileId
              });
              snapshot = this.apolloCache.readFragment({
                id: profileIdentifier,
                fragmentName: 'Profile',
                fragment: ProfileFragmentDoc
              });
              if (snapshot) {
                this.apolloCache.writeFragment({
                  id: profileIdentifier,
                  fragmentName: 'Profile',
                  fragment: ProfileFragmentDoc,
                  data: _objectSpread2(_objectSpread2({}, snapshot), {}, {
                    stats: _objectSpread2(_objectSpread2({}, snapshot.stats), {}, {
                      totalFollowers: snapshot.stats.totalFollowers - 1
                    })
                  })
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return FollowProfilesResponder;
}();

var NoopResponder = /*#__PURE__*/function () {
  function NoopResponder() {
    _classCallCheck(this, NoopResponder);
  }
  _createClass(NoopResponder, [{
    key: "commit",
    value: // eslint-disable-next-line @typescript-eslint/no-empty-function
    function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function commit(_x) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }]);
  return NoopResponder;
}();

var UnfollowProfileResponder = /*#__PURE__*/function () {
  function UnfollowProfileResponder(apolloCache) {
    _classCallCheck(this, UnfollowProfileResponder);
    this.apolloCache = apolloCache;
  }
  _createClass(UnfollowProfileResponder, [{
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request, profileIdentifier;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              profileIdentifier = this.apolloCache.identify({
                __typename: 'Profile',
                id: request.profileId
              });
              this.apolloCache.modify({
                id: profileIdentifier,
                fields: {
                  isFollowedByMe: function isFollowedByMe() {
                    return false;
                  },
                  stats: function stats(oldStats) {
                    return _objectSpread2(_objectSpread2({}, oldStats), {}, {
                      totalFollowers: oldStats.totalFollowers - 1
                    });
                  }
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function commit(_x) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }]);
  return UnfollowProfileResponder;
}();

var UpdateDispatcherConfigResponder = /*#__PURE__*/function () {
  function UpdateDispatcherConfigResponder(profileCacheManager) {
    _classCallCheck(this, UpdateDispatcherConfigResponder);
    this.profileCacheManager = profileCacheManager;
  }
  _createClass(UpdateDispatcherConfigResponder, [{
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              _context.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function commit(_x) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }]);
  return UpdateDispatcherConfigResponder;
}();

var UpdateFollowPolicyResponder = /*#__PURE__*/function () {
  function UpdateFollowPolicyResponder(profileCacheManager) {
    _classCallCheck(this, UpdateFollowPolicyResponder);
    this.profileCacheManager = profileCacheManager;
  }
  _createClass(UpdateFollowPolicyResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              this.profileCacheManager.updateProfile(request.profileId, function (current) {
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  followPolicy: request.policy // TODO sort discrepancy with contractAddress missing from request model
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request;
              _context2.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              _context3.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return UpdateFollowPolicyResponder;
}();

function isUpdateOffChainProfileImageRequest(request) {
  return 'url' in request;
}
var UpdateProfileImageResponder = /*#__PURE__*/function () {
  function UpdateProfileImageResponder(profileCacheManager) {
    _classCallCheck(this, UpdateProfileImageResponder);
    this.profileCacheManager = profileCacheManager;
  }
  _createClass(UpdateProfileImageResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              if (isUpdateOffChainProfileImageRequest(request)) {
                this.profileCacheManager.updateProfile(request.profileId, function (current) {
                  return _objectSpread2(_objectSpread2({}, current), {}, {
                    picture: {
                      __typename: 'MediaSet',
                      original: {
                        __typename: 'Media',
                        url: request.url,
                        // we don't know the following (yet), not important for now
                        altTag: null,
                        cover: null,
                        mimeType: null
                      }
                    }
                  });
                });
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request;
              _context2.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function commit(_x2) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              _context3.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function rollback(_x3) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }]);
  return UpdateProfileImageResponder;
}();

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function newAttributeFragment(key, value) {
  if (value instanceof Date) {
    return {
      __typename: 'Attribute',
      key: key,
      value: value.toISOString(),
      displayType: 'date'
    };
  }
  return {
    __typename: 'Attribute',
    key: key,
    value: value.toString(),
    displayType: _typeof(value)
  };
}
function mergeAttributes(existing, update) {
  var acc = new Map();
  (existing !== null && existing !== void 0 ? existing : []).forEach(function (attr) {
    acc.set(attr.key, attr);
  });
  for (var _i = 0, _Object$entries = Object.entries(update); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (value === null) {
      acc["delete"](key);
    } else {
      acc.set(key, newAttributeFragment(key, value));
    }
  }
  return Array.from(acc.values());
}
var UpdateProfileMetadataResponder = /*#__PURE__*/function () {
  function UpdateProfileMetadataResponder(profileCacheManager) {
    _classCallCheck(this, UpdateProfileMetadataResponder);
    _defineProperty(this, "snapshots", new Map());
    this.profileCacheManager = profileCacheManager;
  }
  _createClass(UpdateProfileMetadataResponder, [{
    key: "prepare",
    value: function () {
      var _prepare = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var _this = this;
        var request;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              request = _ref.request;
              this.profileCacheManager.updateProfile(request.profileId, function (current) {
                var _request$bio;
                _this.snapshots.set(request, current);
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  name: request.name,
                  bio: (_request$bio = request.bio) !== null && _request$bio !== void 0 ? _request$bio : current.bio,
                  coverPicture: request.coverPicture ? {
                    __typename: 'MediaSet',
                    original: {
                      __typename: 'Media',
                      url: request.coverPicture,
                      // we don't know the following (yet), not important for now
                      height: null,
                      altTag: null,
                      cover: null,
                      mimeType: null
                    }
                  } : current.coverPicture,
                  __attributes: request.attributes ? mergeAttributes(current.__attributes, request.attributes) : current.__attributes
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function prepare(_x) {
        return _prepare.apply(this, arguments);
      }
      return prepare;
    }()
  }, {
    key: "rollback",
    value: function () {
      var _rollback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var request, snapshot;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              request = _ref2.request;
              snapshot = this.snapshots.get(request);
              if (snapshot) {
                this.profileCacheManager.updateProfile(request.profileId, function () {
                  return snapshot;
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function rollback(_x2) {
        return _rollback.apply(this, arguments);
      }
      return rollback;
    }()
  }, {
    key: "commit",
    value: function () {
      var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref3) {
        var request;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              request = _ref3.request;
              _context3.next = 3;
              return this.profileCacheManager.refreshProfile(request.profileId);
            case 3:
              this.snapshots["delete"](request);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function commit(_x3) {
        return _commit.apply(this, arguments);
      }
      return commit;
    }()
  }]);
  return UpdateProfileMetadataResponder;
}();

var ProfileCacheManager = /*#__PURE__*/function () {
  function ProfileCacheManager(client, sources) {
    _classCallCheck(this, ProfileCacheManager);
    this.client = client;
    this.sources = sources;
  }
  _createClass(ProfileCacheManager, [{
    key: "fetchProfile",
    value: function () {
      var _fetchProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.request(args, 'cache-first'));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchProfile(_x) {
        return _fetchProfile.apply(this, arguments);
      }
      return fetchProfile;
    }()
  }, {
    key: "refreshProfile",
    value: function () {
      var _refreshProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(id) {
        var profile;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.request({
                id: id
              }, 'network-only');
            case 2:
              profile = _context2.sent;
              return _context2.abrupt("return", profile !== null && profile !== void 0 ? profile : never());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function refreshProfile(_x2) {
        return _refreshProfile.apply(this, arguments);
      }
      return refreshProfile;
    }()
  }, {
    key: "request",
    value: function () {
      var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(args, fetchPolicy) {
        var activeProfile, _yield$this$client$qu, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              activeProfile = activeProfileIdentifierVar();
              _context3.next = 3;
              return this.client.query({
                query: GetProfileDocument,
                variables: {
                  request: {
                    profileId: args.id,
                    handle: args.handle
                  },
                  observerId: activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.id,
                  sources: this.sources
                },
                fetchPolicy: fetchPolicy
              });
            case 3:
              _yield$this$client$qu = _context3.sent;
              data = _yield$this$client$qu.data;
              return _context3.abrupt("return", data.result);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function request(_x3, _x4) {
        return _request.apply(this, arguments);
      }
      return request;
    }()
  }, {
    key: "updateProfile",
    value: function updateProfile(id, updateFn) {
      var _this$client$cache$id;
      var identifier = (_this$client$cache$id = this.client.cache.identify({
        __typename: 'Profile',
        id: id
      })) !== null && _this$client$cache$id !== void 0 ? _this$client$cache$id : never('Profile identifier not found');
      var profile = this.client.cache.readFragment({
        id: identifier,
        fragmentName: 'Profile',
        fragment: ProfileFragmentDoc
      });
      if (profile) {
        var updated = updateFn(profile);
        this.client.cache.writeFragment({
          id: identifier,
          fragmentName: 'Profile',
          fragment: ProfileFragmentDoc,
          data: updated
        });
      }
    }
  }]);
  return ProfileCacheManager;
}();

var SerializableMetaTransaction = /*#__PURE__*/function (_ref) {
  _inherits(SerializableMetaTransaction, _ref);
  var _super = _createSuper(SerializableMetaTransaction);
  function SerializableMetaTransaction(state, reduce) {
    var _this;
    _classCallCheck(this, SerializableMetaTransaction);
    _this = _super.call(this);
    _this.state = state;
    _this.reduce = reduce;
    return _this;
  }
  _createClass(SerializableMetaTransaction, [{
    key: "toTransactionData",
    value: function toTransactionData() {
      if (this.state.txHash && this.state.indexingId) {
        return {
          chainType: this.state.chainType,
          id: this.state.id,
          indexingId: this.state.indexingId,
          nonce: this.state.nonce,
          request: this.state.request,
          txHash: this.state.txHash
        };
      }
      return null;
    }
  }, {
    key: "chainType",
    get: function get() {
      return this.state.chainType;
    }
  }, {
    key: "id",
    get: function get() {
      return this.state.id;
    }
  }, {
    key: "request",
    get: function get() {
      return this.state.request;
    }
  }, {
    key: "nonce",
    get: function get() {
      return this.state.nonce;
    }
  }, {
    key: "hash",
    get: function get() {
      return this.state.txHash;
    }
  }, {
    key: "waitNextEvent",
    value: function () {
      var _waitNextEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.reduce(this.state);
            case 2:
              result = _context.sent;
              if (!result.isSuccess()) {
                _context.next = 6;
                break;
              }
              this.state = result.value.state;
              return _context.abrupt("return", success(result.value.event));
            case 6:
              return _context.abrupt("return", failure(result.error));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function waitNextEvent() {
        return _waitNextEvent.apply(this, arguments);
      }
      return waitNextEvent;
    }()
  }]);
  return SerializableMetaTransaction;
}(MetaTransaction);
var SerializableProxyTransaction = /*#__PURE__*/function (_ref2) {
  _inherits(SerializableProxyTransaction, _ref2);
  var _super2 = _createSuper(SerializableProxyTransaction);
  function SerializableProxyTransaction(state, reduce) {
    var _this2;
    _classCallCheck(this, SerializableProxyTransaction);
    _this2 = _super2.call(this);
    _this2.state = state;
    _this2.reduce = reduce;
    return _this2;
  }
  _createClass(SerializableProxyTransaction, [{
    key: "toTransactionData",
    value: function toTransactionData() {
      if (this.state.proxyId) {
        return {
          chainType: this.state.chainType,
          id: this.state.id,
          proxyId: this.state.proxyId,
          request: this.state.request,
          txHash: this.state.txHash,
          status: this.state.status
        };
      }
      return null;
    }
  }, {
    key: "chainType",
    get: function get() {
      return this.state.chainType;
    }
  }, {
    key: "id",
    get: function get() {
      return this.state.id;
    }
  }, {
    key: "request",
    get: function get() {
      return this.state.request;
    }
  }, {
    key: "hash",
    get: function get() {
      return this.state.txHash;
    }
  }, {
    key: "status",
    get: function get() {
      return this.state.status;
    }
  }, {
    key: "waitNextEvent",
    value: function () {
      var _waitNextEvent2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.reduce(this.state);
            case 2:
              result = _context2.sent;
              if (!result.isSuccess()) {
                _context2.next = 6;
                break;
              }
              this.state = result.value.state;
              return _context2.abrupt("return", success(result.value.event));
            case 6:
              return _context2.abrupt("return", failure(result.error));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function waitNextEvent() {
        return _waitNextEvent2.apply(this, arguments);
      }
      return waitNextEvent;
    }()
  }]);
  return SerializableProxyTransaction;
}(ProxyTransaction);
var SerializableNativeTransaction = /*#__PURE__*/function (_ref3) {
  _inherits(SerializableNativeTransaction, _ref3);
  var _super3 = _createSuper(SerializableNativeTransaction);
  function SerializableNativeTransaction(state, reduce) {
    var _this3;
    _classCallCheck(this, SerializableNativeTransaction);
    _this3 = _super3.call(this);
    _this3.state = state;
    _this3.reduce = reduce;
    return _this3;
  }
  _createClass(SerializableNativeTransaction, [{
    key: "toTransactionData",
    value: function toTransactionData() {
      if (this.state.txHash) {
        return {
          chainType: this.state.chainType,
          id: this.state.id,
          indexingId: this.state.indexingId,
          request: this.state.request,
          txHash: this.state.txHash
        };
      }
      return null;
    }
  }, {
    key: "nonce",
    get: function get() {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "chainType",
    get: function get() {
      return this.state.chainType;
    }
  }, {
    key: "id",
    get: function get() {
      return this.state.id;
    }
  }, {
    key: "request",
    get: function get() {
      return this.state.request;
    }
  }, {
    key: "hash",
    get: function get() {
      var _this$state;
      return (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.txHash;
    }
  }, {
    key: "waitNextEvent",
    value: function () {
      var _waitNextEvent3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.reduce(this.state);
            case 2:
              result = _context3.sent;
              if (!result.isSuccess()) {
                _context3.next = 6;
                break;
              }
              this.state = result.value.state;
              return _context3.abrupt("return", success(result.value.event));
            case 6:
              return _context3.abrupt("return", failure(result.error));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function waitNextEvent() {
        return _waitNextEvent3.apply(this, arguments);
      }
      return waitNextEvent;
    }()
  }]);
  return SerializableNativeTransaction;
}(NativeTransaction);
var TransactionFactory = /*#__PURE__*/function () {
  function TransactionFactory(transactionObserver) {
    _classCallCheck(this, TransactionFactory);
    this.transactionObserver = transactionObserver;
  }
  _createClass(TransactionFactory, [{
    key: "createMetaTransaction",
    value: function createMetaTransaction(init) {
      if ('asyncRelayReceipt' in init) {
        return new SerializableMetaTransaction({
          chainType: init.chainType,
          id: init.signedCall.id,
          nonce: init.signedCall.nonce,
          request: init.signedCall.request
        }, this.createProtocolCallStateReducer(init));
      }
      return new SerializableMetaTransaction({
        chainType: init.chainType,
        id: init.id,
        indexingId: init.indexingId,
        nonce: init.nonce,
        request: init.request,
        txHash: init.txHash
      }, this.createProtocolCallStateReducer(init));
    }
  }, {
    key: "createNativeTransaction",
    value: function createNativeTransaction(init) {
      if ('asyncRelayReceipt' in init) {
        return new SerializableNativeTransaction({
          chainType: init.chainType,
          id: init.id,
          request: init.request
        }, this.createProtocolCallStateReducer(init));
      }
      if (init.indexingId) {
        return new SerializableNativeTransaction({
          chainType: init.chainType,
          id: init.id,
          indexingId: init.indexingId,
          request: init.request,
          txHash: init.txHash
        }, this.createProtocolCallStateReducer(init));
      }
      return new SerializableNativeTransaction({
        chainType: init.chainType,
        id: init.id,
        request: init.request,
        txHash: init.txHash
      }, this.createPureBlockchainStateReducer(init));
    }
  }, {
    key: "createProxyTransaction",
    value: function createProxyTransaction(init) {
      return new SerializableProxyTransaction({
        chainType: init.chainType,
        id: init.id,
        proxyId: init.proxyId,
        request: init.request,
        txHash: init.txHash,
        status: init.status
      }, this.createProxyActionStateReducer(init));
    }
  }, {
    key: "createProtocolCallStateReducer",
    value: function createProtocolCallStateReducer(init) {
      var _this4 = this;
      return /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(state) {
          var relayReceiptResult, indexingEventResult;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                if (!('asyncRelayReceipt' in init)) {
                  _context4.next = 8;
                  break;
                }
                _context4.next = 3;
                return init.asyncRelayReceipt;
              case 3:
                relayReceiptResult = _context4.sent;
                if (!relayReceiptResult.isFailure()) {
                  _context4.next = 6;
                  break;
                }
                return _context4.abrupt("return", failure(relayReceiptResult.error));
              case 6:
                if (!(state.txHash === undefined)) {
                  _context4.next = 8;
                  break;
                }
                return _context4.abrupt("return", success({
                  event: TransactionEvent.BROADCASTED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    txHash: relayReceiptResult.value.txHash,
                    indexingId: relayReceiptResult.value.indexingId
                  })
                }));
              case 8:
                invariant(state.indexingId, 'indexingId is required');
                _context4.next = 11;
                return _this4.transactionObserver.waitForNextIndexingEvent(state.indexingId);
              case 11:
                indexingEventResult = _context4.sent;
                if (!indexingEventResult.isFailure()) {
                  _context4.next = 14;
                  break;
                }
                return _context4.abrupt("return", failure(indexingEventResult.error));
              case 14:
                if (!indexingEventResult.value.indexed) {
                  _context4.next = 16;
                  break;
                }
                return _context4.abrupt("return", success({
                  event: TransactionEvent.SETTLED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    txHash: indexingEventResult.value.txHash
                  })
                }));
              case 16:
                return _context4.abrupt("return", success({
                  event: TransactionEvent.UPGRADED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    txHash: indexingEventResult.value.txHash
                  })
                }));
              case 17:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x) {
          return _ref4.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "createPureBlockchainStateReducer",
    value: function createPureBlockchainStateReducer(init) {
      var _this5 = this;
      return /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(state) {
          var result;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this5.transactionObserver.waitForExecuted(init.txHash, init.chainType);
              case 2:
                result = _context5.sent;
                if (!result.isFailure()) {
                  _context5.next = 5;
                  break;
                }
                return _context5.abrupt("return", failure(result.error));
              case 5:
                return _context5.abrupt("return", success({
                  event: TransactionEvent.SETTLED,
                  state: state
                }));
              case 6:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }();
    }
  }, {
    key: "createProxyActionStateReducer",
    value: function createProxyActionStateReducer(init) {
      var _this6 = this;
      return /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(state) {
          var result;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this6.transactionObserver.waitForProxyTransactionStatus(init.proxyId);
              case 2:
                result = _context6.sent;
                if (!result.isFailure()) {
                  _context6.next = 5;
                  break;
                }
                return _context6.abrupt("return", failure(result.error));
              case 5:
                _context6.t0 = result.value.status;
                _context6.next = _context6.t0 === ProxyActionStatus.MINTING ? 8 : _context6.t0 === ProxyActionStatus.TRANSFERRING ? 9 : _context6.t0 === ProxyActionStatus.COMPLETE ? 10 : 11;
                break;
              case 8:
                return _context6.abrupt("return", success({
                  event: state.status === ProxyActionStatus.MINTING ? TransactionEvent.UPGRADED : TransactionEvent.BROADCASTED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    status: ProxyActionStatus.MINTING,
                    txHash: result.value.txHash
                  })
                }));
              case 9:
                return _context6.abrupt("return", success({
                  event: state.status === ProxyActionStatus.TRANSFERRING ? TransactionEvent.UPGRADED : TransactionEvent.BROADCASTED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    status: ProxyActionStatus.TRANSFERRING,
                    txHash: result.value.txHash
                  })
                }));
              case 10:
                return _context6.abrupt("return", success({
                  event: TransactionEvent.SETTLED,
                  state: _objectSpread2(_objectSpread2({}, state), {}, {
                    status: ProxyActionStatus.COMPLETE,
                    txHash: result.value.txHash
                  })
                }));
              case 11:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }();
    }
  }]);
  return TransactionFactory;
}();

var ONE_SECOND = 1000; // ms

function delay(waitInMs) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, waitInMs);
  });
}
function resolveTransactionErrorReason(reason) {
  switch (reason) {
    case TransactionErrorReasons.Reverted:
      return TransactionErrorReason.REVERTED;
    default:
      return TransactionErrorReason.UNKNOWN;
  }
}
var TransactionObserver = /*#__PURE__*/function () {
  function TransactionObserver(providerFactory, apolloClient, timings) {
    _classCallCheck(this, TransactionObserver);
    this.providerFactory = providerFactory;
    this.apolloClient = apolloClient;
    this.timings = timings;
  }
  _createClass(TransactionObserver, [{
    key: "waitForExecuted",
    value: function () {
      var _waitForExecuted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(txHash, chainType) {
        var provider, startedAt, txResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.providerFactory.createProvider({
                chainType: chainType
              });
            case 2:
              provider = _context.sent;
              startedAt = Date.now();
            case 4:
              if (!(Date.now() - startedAt <= this.timings.maxMiningWaitTime)) {
                _context.next = 25;
                break;
              }
              _context.next = 7;
              return provider.getTransaction(txHash);
            case 7:
              txResponse = _context.sent;
              if (!(txResponse === null)) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return delay(ONE_SECOND);
            case 11:
              return _context.abrupt("continue", 4);
            case 12:
              _context.prev = 12;
              _context.next = 15;
              return Promise.race([txResponse.wait(1), delay(this.timings.maxMiningWaitTime).then(function () {
                throw new TransactionError(TransactionErrorReason.MINING_TIMEOUT);
              })]);
            case 15:
              return _context.abrupt("return", success());
            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](12);
              if (!(_context.t0 instanceof TransactionError)) {
                _context.next = 22;
                break;
              }
              return _context.abrupt("return", failure(_context.t0));
            case 22:
              throw _context.t0;
            case 23:
              _context.next = 4;
              break;
            case 25:
              return _context.abrupt("return", failure(new TransactionError(TransactionErrorReason.MINING_TIMEOUT)));
            case 26:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[12, 18]]);
      }));
      function waitForExecuted(_x, _x2) {
        return _waitForExecuted.apply(this, arguments);
      }
      return waitForExecuted;
    }()
  }, {
    key: "waitForNextIndexingEvent",
    value: function () {
      var _waitForNextIndexingEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(indexingId) {
        var _this = this;
        var startedAt, observable, previousTxHash;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              startedAt = Date.now();
              observable = this.apolloClient.poll({
                query: HasTxHashBeenIndexedDocument,
                variables: {
                  request: {
                    txId: indexingId
                  }
                }
              });
              previousTxHash = null;
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var subscription = observable.subscribe({
                  next: function () {
                    var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref) {
                      var result;
                      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            result = _ref.result;
                            _context2.t0 = result.__typename;
                            _context2.next = _context2.t0 === 'TransactionIndexedResult' ? 4 : _context2.t0 === 'TransactionError' ? 10 : 12;
                            break;
                          case 4:
                            if (previousTxHash === null) {
                              previousTxHash = result.txHash;
                            }
                            if (!(previousTxHash !== result.txHash || result.indexed)) {
                              _context2.next = 9;
                              break;
                            }
                            subscription.unsubscribe();
                            resolve(success({
                              indexed: result.indexed,
                              txHash: result.txHash
                            }));
                            return _context2.abrupt("return");
                          case 9:
                            return _context2.abrupt("break", 12);
                          case 10:
                            subscription.unsubscribe();
                            resolve(failure(new TransactionError(resolveTransactionErrorReason(result.reason))));
                          case 12:
                            if (Date.now() - startedAt > _this.timings.maxIndexingWaitTime) {
                              subscription.unsubscribe();
                              resolve(failure(new TransactionError(TransactionErrorReason.INDEXING_TIMEOUT)));
                            }
                          case 13:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    function next(_x4) {
                      return _next.apply(this, arguments);
                    }
                    return next;
                  }(),
                  error: reject
                });
              }));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function waitForNextIndexingEvent(_x3) {
        return _waitForNextIndexingEvent.apply(this, arguments);
      }
      return waitForNextIndexingEvent;
    }()
  }, {
    key: "waitForProxyTransactionStatus",
    value: function () {
      var _waitForProxyTransactionStatus = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(proxyId) {
        var _this2 = this;
        var startedAt, observable, previousTxHash;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              startedAt = Date.now();
              observable = this.apolloClient.poll({
                query: ProxyActionStatusDocument,
                variables: {
                  proxyActionId: proxyId
                }
              });
              previousTxHash = null;
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                var subscription = observable.subscribe({
                  next: function () {
                    var _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref2) {
                      var result;
                      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                        while (1) switch (_context4.prev = _context4.next) {
                          case 0:
                            result = _ref2.result;
                            _context4.t0 = result.__typename;
                            _context4.next = _context4.t0 === 'ProxyActionStatusResult' ? 4 : _context4.t0 === 'ProxyActionError' ? 10 : 12;
                            break;
                          case 4:
                            if (previousTxHash === null) {
                              previousTxHash = result.txHash;
                            }
                            if (!(previousTxHash !== result.txHash || result.status === ProxyActionStatusTypes.Complete)) {
                              _context4.next = 9;
                              break;
                            }
                            subscription.unsubscribe();
                            resolve(success({
                              txHash: result.txHash,
                              status: ProxyActionStatus.COMPLETE
                            }));
                            return _context4.abrupt("return");
                          case 9:
                            return _context4.abrupt("break", 12);
                          case 10:
                            subscription.unsubscribe();
                            resolve(failure(new TransactionError(TransactionErrorReason.UNKNOWN)));
                          case 12:
                            // handle timeout as the last possible case, otherwise can fail with timeout on Complete tx
                            if (Date.now() - startedAt > _this2.timings.maxIndexingWaitTime) {
                              subscription.unsubscribe();
                              resolve(failure(new TransactionError(TransactionErrorReason.INDEXING_TIMEOUT)));
                            }
                          case 13:
                          case "end":
                            return _context4.stop();
                        }
                      }, _callee4);
                    }));
                    function next(_x6) {
                      return _next2.apply(this, arguments);
                    }
                    return next;
                  }(),
                  error: reject
                });
              }));
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function waitForProxyTransactionStatus(_x5) {
        return _waitForProxyTransactionStatus.apply(this, arguments);
      }
      return waitForProxyTransactionStatus;
    }()
  }]);
  return TransactionObserver;
}();

var schema = new BaseStorageSchema('lens.transactions', TransactionStorageSchema);
function createTransactionStorage(storageProvider) {
  return Storage.createForSchema(schema, storageProvider);
}

var activeWalletVar = makeVar(null);
var ActiveWalletPresenter = /*#__PURE__*/function () {
  function ActiveWalletPresenter() {
    _classCallCheck(this, ActiveWalletPresenter);
  }
  _createClass(ActiveWalletPresenter, [{
    key: "presentActiveWallet",
    value: function presentActiveWallet(wallet) {
      activeWalletVar(wallet);
    }
  }]);
  return ActiveWalletPresenter;
}();
function useActiveWalletVar() {
  return useReactiveVar(activeWalletVar);
}

var BalanceGateway = /*#__PURE__*/function () {
  function BalanceGateway(providerFactory) {
    _classCallCheck(this, BalanceGateway);
    this.providerFactory = providerFactory;
  }
  _createClass(BalanceGateway, [{
    key: "getBalanceFor",
    value: function () {
      var _getBalanceFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(wallet, asset) {
        var provider, contract, balance;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.providerFactory.createProvider({
                chainType: ChainType.POLYGON
              });
            case 2:
              provider = _context.sent;
              contract = erc20$1(asset.address, provider);
              _context.next = 6;
              return contract.balanceOf(wallet.address);
            case 6:
              balance = _context.sent;
              return _context.abrupt("return", Amount.erc20(asset, BigDecimal.rescale(BigDecimal.from(balance.toString()), -asset.decimals)));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getBalanceFor(_x, _x2) {
        return _getBalanceFor.apply(this, arguments);
      }
      return getBalanceFor;
    }()
  }]);
  return BalanceGateway;
}();

var CredentialsFactory = /*#__PURE__*/function () {
  function CredentialsFactory(auth) {
    _classCallCheck(this, CredentialsFactory);
    this.auth = auth;
  }
  _createClass(CredentialsFactory, [{
    key: "renewCredentials",
    value: function () {
      var _renewCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(credentials) {
        var newCredentials;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (credentials.canRefresh()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", failure(new CredentialsExpiredError()));
            case 2:
              _context.next = 4;
              return this.auth.refreshCredentials(credentials.refreshToken);
            case 4:
              newCredentials = _context.sent;
              return _context.abrupt("return", success(newCredentials));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function renewCredentials(_x) {
        return _renewCredentials.apply(this, arguments);
      }
      return renewCredentials;
    }()
  }, {
    key: "issueCredentials",
    value: function () {
      var _issueCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(wallet) {
        var challenge, signedChallengeResult, credentials;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.auth.generateChallenge(wallet.address);
            case 2:
              challenge = _context2.sent;
              _context2.next = 5;
              return wallet.signMessage(challenge);
            case 5:
              signedChallengeResult = _context2.sent;
              if (!signedChallengeResult.isFailure()) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", failure(signedChallengeResult.error));
            case 8:
              _context2.next = 10;
              return this.auth.generateCredentials(wallet.address, signedChallengeResult.value);
            case 10:
              credentials = _context2.sent;
              return _context2.abrupt("return", success(credentials));
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function issueCredentials(_x2) {
        return _issueCredentials.apply(this, arguments);
      }
      return issueCredentials;
    }()
  }]);
  return CredentialsFactory;
}();

var CredentialsGateway = /*#__PURE__*/function () {
  function CredentialsGateway(credentialsStorage) {
    _classCallCheck(this, CredentialsGateway);
    this.credentialsStorage = credentialsStorage;
  }
  _createClass(CredentialsGateway, [{
    key: "getCredentials",
    value: function () {
      var _getCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.credentialsStorage.get());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getCredentials() {
        return _getCredentials.apply(this, arguments);
      }
      return getCredentials;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(credentials) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.credentialsStorage.set(credentials);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function save(_x) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "invalidate",
    value: function () {
      var _invalidate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.credentialsStorage.reset();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function invalidate() {
        return _invalidate.apply(this, arguments);
      }
      return invalidate;
    }()
  }]);
  return CredentialsGateway;
}();

var TokenGateway = /*#__PURE__*/function () {
  function TokenGateway(providerFactory) {
    _classCallCheck(this, TokenGateway);
    this.providerFactory = providerFactory;
  }
  _createClass(TokenGateway, [{
    key: "getTransferAllowanceFor",
    value: function () {
      var _getTransferAllowanceFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(asset, owner, spender) {
        var provider, contract, allowance;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.providerFactory.createProvider({
                chainType: ChainType.POLYGON
              });
            case 2:
              provider = _context.sent;
              contract = erc20$1(asset.address, provider);
              _context.next = 6;
              return contract.allowance(owner.address, spender);
            case 6:
              allowance = _context.sent;
              return _context.abrupt("return", Amount.erc20(asset, BigDecimal.rescale(BigDecimal.from(allowance.toString()), -asset.decimals)));
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getTransferAllowanceFor(_x, _x2, _x3) {
        return _getTransferAllowanceFor.apply(this, arguments);
      }
      return getTransferAllowanceFor;
    }()
  }]);
  return TokenGateway;
}();

var WalletFactory = /*#__PURE__*/function () {
  function WalletFactory(signerFactory, transactionFactory) {
    _classCallCheck(this, WalletFactory);
    this.signerFactory = signerFactory;
    this.transactionFactory = transactionFactory;
  }
  _createClass(WalletFactory, [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", ConcreteWallet.create(request, this.signerFactory, this.transactionFactory));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function create(_x) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "rehydrate",
    value: function rehydrate(data) {
      return ConcreteWallet.create(data, this.signerFactory, this.transactionFactory);
    }
  }]);
  return WalletFactory;
}();

var WalletStorageSchema = z.array(WalletDataSchema);
var WalletGateway = /*#__PURE__*/function () {
  function WalletGateway(storage, factory) {
    _classCallCheck(this, WalletGateway);
    _defineProperty(this, "inMemoryCache", {});
    this.storage = storage;
    this.factory = factory;
  }
  _createClass(WalletGateway, [{
    key: "getByAddress",
    value: function () {
      var _getByAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(address) {
        var _wallets$find;
        var _this$inMemoryCache$a, wallets, wallet;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.inMemoryCache[address]) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", (_this$inMemoryCache$a = this.inMemoryCache[address]) !== null && _this$inMemoryCache$a !== void 0 ? _this$inMemoryCache$a : never());
            case 2:
              _context.next = 4;
              return this.getAll();
            case 4:
              wallets = _context.sent;
              wallet = (_wallets$find = wallets.find(function (w) {
                return w.address === address;
              })) !== null && _wallets$find !== void 0 ? _wallets$find : null;
              if (wallet) {
                this.inMemoryCache[address] = wallet;
              }
              return _context.abrupt("return", wallet);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getByAddress(_x) {
        return _getByAddress.apply(this, arguments);
      }
      return getByAddress;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.storage.set([]);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(wallet) {
        var wallets;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.getAll();
            case 2:
              wallets = _context3.sent;
              this.inMemoryCache[wallet.address] = wallet;
              _context3.next = 6;
              return this.storage.set(wallets.concat([wallet]).map(function (w) {
                return w.toWalletData();
              }));
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function save(_x2) {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "getAll",
    value: function () {
      var _getAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this = this;
        var data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.storage.get();
            case 2:
              data = _context4.sent;
              if (!(data === null)) {
                _context4.next = 5;
                break;
              }
              return _context4.abrupt("return", []);
            case 5:
              return _context4.abrupt("return", data.map(function (d) {
                return _this.factory.rehydrate(d);
              }));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAll() {
        return _getAll.apply(this, arguments);
      }
      return getAll;
    }()
  }]);
  return WalletGateway;
}();

var AccessTokenStorage = /*#__PURE__*/function () {
  function AccessTokenStorage(authApi, credentialsStorage) {
    _classCallCheck(this, AccessTokenStorage);
    _defineProperty(this, "isRefreshing", false);
    _defineProperty(this, "pendingRequests", []);
    _defineProperty(this, "listeners", new Set());
    this.authApi = authApi;
    this.credentialsStorage = credentialsStorage;
  }
  _createClass(AccessTokenStorage, [{
    key: "onExpiry",
    value: function onExpiry(callback) {
      var _this = this;
      this.listeners.add(callback);
      return function () {
        return _this.listeners["delete"](callback);
      };
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.credentialsStorage.getAccessToken();
    }
  }, {
    key: "refreshToken",
    value: function () {
      var _refreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var deferredPromise, credentials;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.isRefreshing) {
                _context.next = 4;
                break;
              }
              deferredPromise = new Deferred();
              this.pendingRequests.push(deferredPromise);
              return _context.abrupt("return", deferredPromise.promise);
            case 4:
              this.isRefreshing = true;
              _context.next = 7;
              return this.credentialsStorage.get();
            case 7:
              credentials = _context.sent;
              if (!(credentials && credentials.canRefresh())) {
                _context.next = 13;
                break;
              }
              _context.next = 11;
              return this.refreshCredentials(credentials);
            case 11:
              this.isRefreshing = false;
              return _context.abrupt("return");
            case 13:
              this.rejectPendingRequests();
              this.isRefreshing = false;
              this.emitExpiryEvent();
              throw new CredentialsExpiredError();
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function refreshToken() {
        return _refreshToken.apply(this, arguments);
      }
      return refreshToken;
    }()
  }, {
    key: "refreshCredentials",
    value: function () {
      var _refreshCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(credentials) {
        var newCredentials;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.authApi.refreshCredentials(credentials.refreshToken);
            case 2:
              newCredentials = _context2.sent;
              _context2.next = 5;
              return this.credentialsStorage.set(newCredentials);
            case 5:
              this.pendingRequests.map(function (request) {
                return request.resolve();
              });
              this.pendingRequests = [];
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function refreshCredentials(_x) {
        return _refreshCredentials.apply(this, arguments);
      }
      return refreshCredentials;
    }()
  }, {
    key: "rejectPendingRequests",
    value: function rejectPendingRequests() {
      this.pendingRequests.map(function (request) {
        return request.reject(new CredentialsExpiredError());
      });
      this.pendingRequests = [];
    }
  }, {
    key: "emitExpiryEvent",
    value: function emitExpiryEvent() {
      this.listeners.forEach(function (callback) {
        return callback();
      });
    }
  }]);
  return AccessTokenStorage;
}();

function assertIdInJwt(decodedJwt) {
  if (isObject(decodedJwt) && !('id' in decodedJwt)) {
    throw new InvariantError('Invalid JWT format.');
  }
}

// Threshold in seconds that will mark token as expired even it's still valid
// Adds some time for all communications that's required to refresh tokens
var TOKEN_EXP_THRESHOLD = DateUtils.secondsToMs(3);
var Credentials = /*#__PURE__*/function () {
  function Credentials(accessToken, refreshToken) {
    _classCallCheck(this, Credentials);
    this.accessToken = accessToken;
    this.refreshToken = refreshToken;
    var decodedRefreshToken = jwtDecode(refreshToken);
    assertIdInJwt(decodedRefreshToken);
    this.address = decodedRefreshToken.id;
  }
  _createClass(Credentials, [{
    key: "canRefresh",
    value: function canRefresh() {
      var now = Date.now();
      var tokenExpDate = this.getTokenExpDate(this.refreshToken);
      return now < tokenExpDate - TOKEN_EXP_THRESHOLD;
    }
  }, {
    key: "isExpired",
    value: function isExpired() {
      var accessToken = this.accessToken;
      if (!accessToken) {
        return true;
      }
      var now = Date.now();
      var tokenExpDate = this.getTokenExpDate(accessToken);
      return now >= tokenExpDate - TOKEN_EXP_THRESHOLD;
    }
  }, {
    key: "getAccessTokenExpDate",
    value: function getAccessTokenExpDate() {
      var accessToken = this.accessToken;
      if (!accessToken) {
        return null;
      }
      return this.getTokenExpDate(accessToken);
    }
  }, {
    key: "getTokenExpDate",
    value: function getTokenExpDate(token) {
      var decodedToken = jwtDecode(token);
      invariant(decodedToken.exp, 'Exp date should be provided by JWT token');
      return DateUtils.secondsToMs(decodedToken.exp);
    }
  }]);
  return Credentials;
}();

var AuthApi = /*#__PURE__*/function () {
  function AuthApi(apolloClient) {
    _classCallCheck(this, AuthApi);
    this.apolloClient = apolloClient;
  }
  _createClass(AuthApi, [{
    key: "generateChallenge",
    value: function () {
      var _generateChallenge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(address) {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.query({
                query: AuthChallengeDocument,
                variables: {
                  address: address
                },
                // challenge to sign should be always a new one
                fetchPolicy: 'network-only'
              });
            case 2:
              result = _context.sent;
              return _context.abrupt("return", result.data.result.text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function generateChallenge(_x) {
        return _generateChallenge.apply(this, arguments);
      }
      return generateChallenge;
    }()
  }, {
    key: "generateCredentials",
    value: function () {
      var _generateCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(address, signature) {
        var result, _result$data$result, accessToken, refreshToken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.apolloClient.mutate({
                mutation: AuthAuthenticateDocument,
                variables: {
                  address: address,
                  signature: signature
                }
              });
            case 2:
              result = _context2.sent;
              _result$data$result = result.data.result, accessToken = _result$data$result.accessToken, refreshToken = _result$data$result.refreshToken;
              return _context2.abrupt("return", new Credentials(accessToken, refreshToken));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function generateCredentials(_x2, _x3) {
        return _generateCredentials.apply(this, arguments);
      }
      return generateCredentials;
    }()
  }, {
    key: "refreshCredentials",
    value: function () {
      var _refreshCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(refreshToken) {
        var result, _result$data$result2, newAccessToken, newRefreshToken;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: AuthRefreshDocument,
                variables: {
                  refreshToken: refreshToken
                }
              });
            case 2:
              result = _context3.sent;
              _result$data$result2 = result.data.result, newAccessToken = _result$data$result2.accessToken, newRefreshToken = _result$data$result2.refreshToken;
              return _context3.abrupt("return", new Credentials(newAccessToken, newRefreshToken));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function refreshCredentials(_x4) {
        return _refreshCredentials.apply(this, arguments);
      }
      return refreshCredentials;
    }()
  }]);
  return AuthApi;
}();

var AuthData = z.object({
  refreshToken: z.string()
});
var authStorageSchema = new BaseStorageSchema('lens.credentials', AuthData);

/**
 * Stores auth credentials.
 * Access token is kept in memory.
 * Refresh token is persisted permanently.
 */
var CredentialsStorage = /*#__PURE__*/function () {
  function CredentialsStorage(storageProvider) {
    _classCallCheck(this, CredentialsStorage);
    _defineProperty(this, "accessToken", null);
    this.refreshTokenStorage = Storage.createForSchema(authStorageSchema, storageProvider);
  }
  _createClass(CredentialsStorage, [{
    key: "set",
    value: function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var accessToken, refreshToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              accessToken = _ref.accessToken, refreshToken = _ref.refreshToken;
              this.accessToken = accessToken;
              _context.next = 4;
              return this.refreshTokenStorage.set({
                refreshToken: refreshToken
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function set(_x) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var refreshToken, accessToken;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getRefreshToken();
            case 2:
              refreshToken = _context2.sent;
              if (refreshToken) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", null);
            case 5:
              accessToken = this.getAccessToken();
              return _context2.abrupt("return", new Credentials(accessToken, refreshToken));
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function get() {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.accessToken = null;
              _context3.next = 3;
              return this.refreshTokenStorage.reset();
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function reset() {
        return _reset.apply(this, arguments);
      }
      return reset;
    }()
  }, {
    key: "subscribe",
    value: function subscribe(_) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return this.accessToken;
    }
  }, {
    key: "getRefreshToken",
    value: function () {
      var _getRefreshToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _result$refreshToken;
        var result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.refreshTokenStorage.get();
            case 2:
              result = _context4.sent;
              return _context4.abrupt("return", (_result$refreshToken = result === null || result === void 0 ? void 0 : result.refreshToken) !== null && _result$refreshToken !== void 0 ? _result$refreshToken : null);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getRefreshToken() {
        return _getRefreshToken.apply(this, arguments);
      }
      return getRefreshToken;
    }()
  }]);
  return CredentialsStorage;
}();

var UnreadNotificationsData = z.object({
  totalReadNotificationsCount: z.number().nullable()
});
var notificationStorageDataSchema = new BaseStorageSchema('lens.notifications', UnreadNotificationsData);
function createNotificationStorage(storageProvider) {
  return Storage.createForSchema(notificationStorageDataSchema, storageProvider);
}

var ProviderFactory = /*#__PURE__*/function () {
  function ProviderFactory(bindings, chains) {
    _classCallCheck(this, ProviderFactory);
    this.bindings = bindings;
    this.chains = chains;
  }
  _createClass(ProviderFactory, [{
    key: "createProvider",
    value: function () {
      var _createProvider = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
        var chainId, provider, network;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              chainId = this.chains[config.chainType].chainId;
              _context.next = 3;
              return this.bindings.getProvider({
                chainId: chainId
              });
            case 3:
              provider = _context.sent;
              _context.next = 6;
              return provider.getNetwork();
            case 6:
              network = _context.sent;
              invariant(network.chainId === chainId, "Invalid chainId. Expected ".concat(chainId, " but got ").concat(network.chainId));
              return _context.abrupt("return", provider);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createProvider(_x) {
        return _createProvider.apply(this, arguments);
      }
      return createProvider;
    }()
  }]);
  return ProviderFactory;
}();

var SignerFactory = /*#__PURE__*/function () {
  function SignerFactory(bindings, chains) {
    _classCallCheck(this, SignerFactory);
    this.bindings = bindings;
    this.chains = chains;
  }
  _createClass(SignerFactory, [{
    key: "createSigner",
    value: function () {
      var _createSigner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var address, chainType, chainId, signer, signerAddress, signerChainId, chainConfig, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              address = _ref.address, chainType = _ref.chainType;
              chainId = chainType ? this.chains[chainType].chainId : undefined;
              _context.next = 4;
              return this.bindings.getSigner({
                chainId: chainId
              });
            case 4:
              signer = _context.sent;
              _context.next = 7;
              return signer.getAddress();
            case 7:
              signerAddress = _context.sent;
              if (isTheSameAddress(address, signerAddress)) {
                _context.next = 10;
                break;
              }
              return _context.abrupt("return", failure(new WalletConnectionError(WalletConnectionErrorReason.WRONG_ACCOUNT)));
            case 10:
              if (!chainType) {
                _context.next = 31;
                break;
              }
              _context.prev = 11;
              _context.next = 14;
              return signer.getChainId();
            case 14:
              signerChainId = _context.sent;
              if (!(signerChainId !== chainId)) {
                _context.next = 24;
                break;
              }
              chainConfig = this.createAddEthereumChainParameter(chainType);
              _context.next = 19;
              return this.addChain(signer, chainConfig);
            case 19:
              _context.next = 21;
              return this.switchChain(signer, chainConfig);
            case 21:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 24;
                break;
              }
              return _context.abrupt("return", failure(result.error));
            case 24:
              _context.next = 31;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](11);
              assertErrorObjectWithCode(_context.t0);
              if (!(_context.t0.code === errors.UNSUPPORTED_OPERATION)) {
                _context.next = 31;
                break;
              }
              return _context.abrupt("return", failure(new WalletConnectionError(WalletConnectionErrorReason.INCORRECT_CHAIN)));
            case 31:
              return _context.abrupt("return", success(signer));
            case 32:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[11, 26]]);
      }));
      function createSigner(_x) {
        return _createSigner.apply(this, arguments);
      }
      return createSigner;
    }()
  }, {
    key: "createAddEthereumChainParameter",
    value: function createAddEthereumChainParameter(chainType) {
      var chainConfig = this.chains[chainType];
      return {
        chainId: utils.hexValue(chainConfig.chainId),
        chainName: chainConfig.name,
        nativeCurrency: {
          name: chainConfig.nativeCurrency.name,
          symbol: chainConfig.nativeCurrency.symbol,
          decimals: chainConfig.nativeCurrency.decimals
        },
        rpcUrls: [chainConfig.rpcUrl],
        blockExplorerUrls: [chainConfig.blockExplorer]
      };
    }
  }, {
    key: "addChain",
    value: function () {
      var _addChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(signer, chainConfig) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!(signer.provider && signer.provider instanceof JsonRpcProvider)) {
                _context2.next = 4;
                break;
              }
              _context2.next = 4;
              return signer.provider.send('wallet_addEthereumChain', [chainConfig]);
            case 4:
              _context2.next = 8;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 6]]);
      }));
      function addChain(_x2, _x3) {
        return _addChain.apply(this, arguments);
      }
      return addChain;
    }()
  }, {
    key: "switchChain",
    value: function () {
      var _switchChain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(signer, chainConfig) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              if (!(signer.provider && signer.provider instanceof JsonRpcProvider)) {
                _context3.next = 5;
                break;
              }
              _context3.next = 4;
              return signer.provider.send('wallet_switchEthereumChain', [{
                chainId: chainConfig.chainId
              }]);
            case 4:
              return _context3.abrupt("return", success());
            case 5:
              _context3.next = 9;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](0);
            case 9:
              return _context3.abrupt("return", failure(new WalletConnectionError(WalletConnectionErrorReason.INCORRECT_CHAIN)));
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 7]]);
      }));
      function switchChain(_x4, _x5) {
        return _switchChain.apply(this, arguments);
      }
      return switchChain;
    }()
  }]);
  return SignerFactory;
}();

var walletStorageDataSchema = new BaseStorageSchema('lens.wallets', WalletStorageSchema);
function createWalletStorage(storageProvider) {
  return Storage.createForSchema(walletStorageDataSchema, storageProvider);
}

function createSharedDependencies(config, _ref) {
  var _ref2, _config$logger, _responders;
  var onLogout = _ref.onLogout,
    onError = _ref.onError;
  var sources = (_ref2 = config.sources) !== null && _ref2 !== void 0 ? _ref2 : [];
  var logger = (_config$logger = config.logger) !== null && _config$logger !== void 0 ? _config$logger : new ConsoleLogger();

  // storages
  var activeProfileStorage = createActiveProfileStorage(config.storage);
  var credentialsStorage = new CredentialsStorage(config.storage);
  var walletStorage = createWalletStorage(config.storage);
  var notificationStorage = createNotificationStorage(config.storage);
  var transactionStorage = createTransactionStorage(config.storage);

  // apollo client
  var anonymousApolloClient = createAnonymousApolloClient({
    backendURL: config.environment.backend,
    activeWalletVar: activeWalletVar
  });
  var authApi = new AuthApi(anonymousApolloClient);
  var accessTokenStorage = new AccessTokenStorage(authApi, credentialsStorage);
  var apolloClient = createApolloClient({
    backendURL: config.environment.backend,
    accessTokenStorage: accessTokenStorage,
    activeWalletVar: activeWalletVar,
    pollingInterval: config.environment.timings.pollingInterval
  });
  var publicationCacheManager = new PublicationCacheManager(apolloClient.cache);
  var profileCacheManager = new ProfileCacheManager(apolloClient, sources);

  // adapters
  var providerFactory = new ProviderFactory(config.bindings, config.environment.chains);
  var transactionObserver = new TransactionObserver(providerFactory, apolloClient, config.environment.timings);
  var transactionFactory = new TransactionFactory(transactionObserver);
  var transactionGateway = new PendingTransactionGateway(transactionStorage, transactionFactory);
  var signerFactory = new SignerFactory(config.bindings, config.environment.chains);
  var credentialsFactory = new CredentialsFactory(authApi);
  var credentialsGateway = new CredentialsGateway(credentialsStorage);
  var walletFactory = new WalletFactory(signerFactory, transactionFactory);
  var walletGateway = new WalletGateway(walletStorage, walletFactory);
  var balanceGateway = new BalanceGateway(providerFactory);
  var tokenGateway = new TokenGateway(providerFactory);
  var followPolicyCallGateway = new FollowPolicyCallGateway(apolloClient);
  var profileGateway = new ProfileGateway(apolloClient);
  var activeProfileGateway = new ActiveProfileGateway(activeProfileStorage);
  var activeProfilePresenter = new ActiveProfilePresenter();
  var activeWallet = new ActiveWallet(credentialsGateway, walletGateway);
  var responders = (_responders = {}, _defineProperty(_responders, TransactionKind.APPROVE_MODULE, new NoopResponder()), _defineProperty(_responders, TransactionKind.COLLECT_PUBLICATION, new CollectPublicationResponder(publicationCacheManager)), _defineProperty(_responders, TransactionKind.CREATE_COMMENT, new NoopResponder()), _defineProperty(_responders, TransactionKind.CREATE_POST, new CreatePostResponder(profileCacheManager, apolloClient, sources)), _defineProperty(_responders, TransactionKind.CREATE_PROFILE, new CreateProfileResponder(profileCacheManager, config.environment.handleResolver)), _defineProperty(_responders, TransactionKind.FOLLOW_PROFILES, new FollowProfilesResponder(apolloClient.cache)), _defineProperty(_responders, TransactionKind.MIRROR_PUBLICATION, new CreateMirrorResponder(apolloClient, publicationCacheManager, sources)), _defineProperty(_responders, TransactionKind.UNFOLLOW_PROFILE, new UnfollowProfileResponder(apolloClient.cache)), _defineProperty(_responders, TransactionKind.UPDATE_DISPATCHER_CONFIG, new UpdateDispatcherConfigResponder(profileCacheManager)), _defineProperty(_responders, TransactionKind.UPDATE_FOLLOW_POLICY, new UpdateFollowPolicyResponder(profileCacheManager)), _defineProperty(_responders, TransactionKind.UPDATE_PROFILE_DETAILS, new UpdateProfileMetadataResponder(profileCacheManager)), _defineProperty(_responders, TransactionKind.UPDATE_PROFILE_IMAGE, new UpdateProfileImageResponder(profileCacheManager)), _responders);
  var transactionQueuePresenter = new TransactionQueuePresenter(onError);
  var protocolCallRelayer = new ProtocolCallRelayer(apolloClient, transactionFactory, logger);

  // common interactors
  var transactionQueue = new TransactionQueue(responders, transactionGateway, transactionQueuePresenter);
  var tokenAvailability = new TokenAvailability(balanceGateway, tokenGateway, activeWallet);
  return {
    appId: config.appId,
    activeProfileGateway: activeProfileGateway,
    activeProfilePresenter: activeProfilePresenter,
    activeWallet: activeWallet,
    apolloClient: apolloClient,
    authApi: authApi,
    bindings: config.bindings,
    credentialsFactory: credentialsFactory,
    credentialsGateway: credentialsGateway,
    environment: config.environment,
    followPolicyCallGateway: followPolicyCallGateway,
    logger: logger,
    notificationStorage: notificationStorage,
    onError: onError,
    onLogout: onLogout,
    profileGateway: profileGateway,
    protocolCallRelayer: protocolCallRelayer,
    publicationCacheManager: publicationCacheManager,
    sources: sources,
    storageProvider: config.storage,
    tokenAvailability: tokenAvailability,
    transactionFactory: transactionFactory,
    transactionGateway: transactionGateway,
    transactionQueue: transactionQueue,
    walletFactory: walletFactory,
    walletGateway: walletGateway,
    providerFactory: providerFactory
  };
}
var SharedDependenciesContext = /*#__PURE__*/React.createContext(null);
function SharedDependenciesProvider(_ref3) {
  var children = _ref3.children,
    context = _ref3.dependencies;
  return /*#__PURE__*/jsx(SharedDependenciesContext.Provider, {
    value: context,
    children: children
  });
}
function useSharedDependencies() {
  var context = useContext(SharedDependenciesContext);
  invariant(context, 'Could not find Lens SDK context, ensure your code is wrapped in a <LensProvider>');
  return context;
}

var _excluded$7 = ["skip", "variables"];
function useLensApolloClient() {
  var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useSharedDependencie = useSharedDependencies(),
    client = _useSharedDependencie.apolloClient;
  return _objectSpread2(_objectSpread2({}, args), {}, {
    client: client
  });
}
function useActiveProfileAsDefaultObserver(_ref) {
  var _ref2, _variables$observerId;
  var skip = _ref.skip,
    variables = _ref.variables,
    others = _objectWithoutProperties(_ref, _excluded$7);
  var _useActiveProfileIden = useActiveProfileIdentifier(),
    activeProfile = _useActiveProfileIden.data,
    bootstrapping = _useActiveProfileIden.loading;
  return _objectSpread2(_objectSpread2({}, others), {}, {
    variables: _objectSpread2(_objectSpread2({}, variables), {}, {
      observerId: (_ref2 = (_variables$observerId = variables.observerId) !== null && _variables$observerId !== void 0 ? _variables$observerId : activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.id) !== null && _ref2 !== void 0 ? _ref2 : null
    }),
    skip: skip || bootstrapping
  });
}
function useSourcesFromConfig(variables) {
  var _useSharedDependencie2 = useSharedDependencies(),
    sources = _useSharedDependencie2.sources;
  return _objectSpread2(_objectSpread2({}, variables), {}, {
    sources: sources
  });
}

function buildReadResult(data, loading, error) {
  if (data !== undefined && !loading) {
    return {
      data: data,
      error: undefined,
      loading: false
    };
  }
  if (error) {
    return {
      data: undefined,
      error: new UnspecifiedError(error),
      loading: false
    };
  }
  return {
    data: undefined,
    error: undefined,
    loading: true
  };
}
function useReadResult(_ref) {
  var error = _ref.error,
    data = _ref.data,
    loading = _ref.loading;
  return buildReadResult(data === null || data === void 0 ? void 0 : data.result, loading, error);
}
function usePaginatedReadResult(_ref2) {
  var error = _ref2.error,
    data = _ref2.data,
    loading = _ref2.loading,
    fetchMore = _ref2.fetchMore;
  return _objectSpread2(_objectSpread2({}, buildReadResult(data === null || data === void 0 ? void 0 : data.result.items, loading, error)), {}, {
    hasMore: data !== null && data !== void 0 && data.result.pageInfo.next ? true : false,
    next: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(data !== null && data !== void 0 && data.result.pageInfo.next)) {
                _context.next = 3;
                break;
              }
              _context.next = 3;
              return fetchMore({
                variables: {
                  cursor: data === null || data === void 0 ? void 0 : data.result.pageInfo.next
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  });
}

function createPublicationMetadataFilters(filters) {
  var _filters$showPublicat;
  if (!filters) {
    return undefined;
  }
  return _objectSpread2({
    locale: filters.restrictPublicationLocaleTo,
    mainContentFocus: filters.restrictPublicationMainFocusTo,
    tags: filters.restrictPublicationTagsTo
  }, !!((_filters$showPublicat = filters.showPublicationsWithContentWarnings) !== null && _filters$showPublicat !== void 0 && _filters$showPublicat.oneOf) && {
    contentWarnings: {
      includeOneOf: filters.showPublicationsWithContentWarnings.oneOf
    }
  });
}

function useComments(_ref) {
  var metadataFilter = _ref.metadataFilter,
    commentsOf = _ref.commentsOf,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId;
  return usePaginatedReadResult(useCommentsQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      metadata: createPublicationMetadataFilters(metadataFilter),
      commentsOf: commentsOf,
      limit: limit,
      observerId: observerId
    })
  }))));
}

var NotFoundError = /*#__PURE__*/function (_Error) {
  _inherits(NotFoundError, _Error);
  var _super = _createSuper(NotFoundError);
  function NotFoundError(message) {
    var _this;
    _classCallCheck(this, NotFoundError);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "name", 'NotFoundError');
    return _this;
  }
  return _createClass(NotFoundError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

function usePublication(_ref) {
  var publicationId = _ref.publicationId,
    observerId = _ref.observerId;
  var _useReadResult = useReadResult(usePublicationQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
      variables: useSourcesFromConfig({
        publicationId: publicationId,
        observerId: observerId
      })
    })))),
    data = _useReadResult.data,
    error = _useReadResult.error,
    loading = _useReadResult.loading;
  if (loading) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: error,
      loading: false
    };
  }
  if (data === null) {
    return {
      data: undefined,
      error: new NotFoundError("Publication with id: ".concat(publicationId)),
      loading: false
    };
  }
  return {
    data: data,
    error: undefined,
    loading: false
  };
}

function usePublications(_ref) {
  var profileId = _ref.profileId,
    metadataFilter = _ref.metadataFilter,
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(usePublicationsQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      profileId: profileId,
      observerId: observerId,
      limit: limit,
      metadata: createPublicationMetadataFilters(metadataFilter)
    })
  }))));
}

function useSearchPublications(_ref) {
  var query = _ref.query,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId;
  return usePaginatedReadResult(useSearchPublicationsQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      query: query,
      limit: limit,
      observerId: observerId
    })
  }))));
}

function useExplorePublications() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    _ref$sortCriteria = _ref.sortCriteria,
    sortCriteria = _ref$sortCriteria === void 0 ? PublicationSortCriteria.Latest : _ref$sortCriteria,
    timestamp = _ref.timestamp,
    publicationTypes = _ref.publicationTypes,
    excludeProfileIds = _ref.excludeProfileIds,
    metadataFilter = _ref.metadataFilter;
  return usePaginatedReadResult(useExplorePublicationsQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      excludeProfileIds: excludeProfileIds,
      limit: limit,
      metadata: createPublicationMetadataFilters(metadataFilter),
      publicationTypes: publicationTypes,
      sortCriteria: sortCriteria,
      timestamp: timestamp,
      observerId: observerId
    })
  }))));
}

var ReactionGateway = /*#__PURE__*/function () {
  function ReactionGateway(apolloClient) {
    _classCallCheck(this, ReactionGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(ReactionGateway, [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var profileId, publicationId, reactionType;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              profileId = _ref.profileId, publicationId = _ref.publicationId, reactionType = _ref.reactionType;
              _context.next = 3;
              return this.apolloClient.mutate({
                mutation: AddReactionDocument,
                variables: {
                  publicationId: publicationId,
                  profileId: profileId,
                  reaction: getApiReactionType(reactionType)
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function add(_x) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
        var profileId, publicationId, reactionType;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              profileId = _ref2.profileId, publicationId = _ref2.publicationId, reactionType = _ref2.reactionType;
              _context2.prev = 1;
              _context2.next = 4;
              return this.apolloClient.mutate({
                mutation: RemoveReactionDocument,
                variables: {
                  publicationId: publicationId,
                  profileId: profileId,
                  reaction: getApiReactionType(reactionType)
                }
              });
            case 4:
              _context2.next = 12;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](1);
              assertError(_context2.t0);
              if (!(_context2.t0 instanceof ValidationError)) {
                _context2.next = 11;
                break;
              }
              return _context2.abrupt("return");
            case 11:
              throw _context2.t0;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 6]]);
      }));
      function remove(_x2) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }]);
  return ReactionGateway;
}();

var getReactionStatKey = function getReactionStatKey(reactionType) {
  if (reactionType === ReactionType.UPVOTE) {
    return 'totalUpvotes';
  } else if (reactionType === ReactionType.DOWNVOTE) {
    return 'totalDownvotes';
  }
  never('Unknown reaction type');
};
var ReactionPresenter = /*#__PURE__*/function () {
  function ReactionPresenter(publicationCacheManager) {
    _classCallCheck(this, ReactionPresenter);
    this.publicationCacheManager = publicationCacheManager;
  }
  _createClass(ReactionPresenter, [{
    key: "add",
    value: function () {
      var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.publicationCacheManager.update(request.publicationId, function (current) {
                invariant(isContentPublication(current), "Reactions are not supported on ".concat(current.__typename));
                var removedStatKey = current.reaction ? getReactionStatKey(getDomainReactionType(current.reaction)) : undefined;
                var currentStatsValue = current.stats[getReactionStatKey(request.reactionType)];
                invariant(typeof currentStatsValue === 'number', 'Invalid stats value');
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  stats: _objectSpread2(_objectSpread2(_objectSpread2({}, current.stats), removedStatKey && _defineProperty({}, removedStatKey, current.stats[removedStatKey] - 1)), {}, _defineProperty({}, getReactionStatKey(request.reactionType), currentStatsValue + 1)),
                  reaction: getApiReactionType(request.reactionType)
                });
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function add(_x) {
        return _add.apply(this, arguments);
      }
      return add;
    }()
  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
        var statKey;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              statKey = getReactionStatKey(request.reactionType);
              this.publicationCacheManager.update(request.publicationId, function (current) {
                invariant(isContentPublication(current), "Reactions are not supported on ".concat(current.__typename));
                return _objectSpread2(_objectSpread2({}, current), {}, {
                  stats: _objectSpread2(_objectSpread2({}, current.stats), {}, _defineProperty({}, statKey, current.stats[statKey] - 1)),
                  reaction: null
                });
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function remove(_x2) {
        return _remove.apply(this, arguments);
      }
      return remove;
    }()
  }]);
  return ReactionPresenter;
}();

function useReactionController() {
  var _useSharedDependencie = useSharedDependencies(),
    apolloClient = _useSharedDependencie.apolloClient,
    publicationCacheManager = _useSharedDependencie.publicationCacheManager;
  var add = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, gateway, reaction;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new ReactionPresenter(publicationCacheManager);
            gateway = new ReactionGateway(apolloClient);
            reaction = new Reaction(gateway, presenter);
            _context.next = 5;
            return reaction.add(request);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function add(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var remove = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
      var presenter, gateway, reaction;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            presenter = new ReactionPresenter(publicationCacheManager);
            gateway = new ReactionGateway(apolloClient);
            reaction = new Reaction(gateway, presenter);
            _context2.next = 5;
            return reaction.remove(request);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function remove(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    add: add,
    remove: remove
  };
}

function useReaction(_ref) {
  var profileId = _ref.profileId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPending = _useState2[0],
    setIsPending = _useState2[1];
  var _useReactionControlle = useReactionController(),
    add = _useReactionControlle.add,
    remove = _useReactionControlle.remove;
  var addReaction = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsPending(true);
            _context.prev = 1;
            _context.next = 4;
            return add({
              publicationId: args.publication.id,
              reactionType: args.reactionType,
              profileId: profileId
            });
          case 4:
            _context.prev = 4;
            setIsPending(false);
            return _context.finish(4);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1,, 4, 7]]);
    }));
    return function addReaction(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var removeReaction = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(args) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setIsPending(true);
            _context2.prev = 1;
            _context2.next = 4;
            return remove({
              publicationId: args.publication.id,
              reactionType: args.reactionType,
              profileId: profileId
            });
          case 4:
            _context2.prev = 4;
            setIsPending(false);
            return _context2.finish(4);
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1,, 4, 7]]);
    }));
    return function removeReaction(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var hasReaction = function hasReaction(_ref4) {
    var publication = _ref4.publication,
      reactionType = _ref4.reactionType;
    return publication.reaction === getApiReactionType(reactionType);
  };
  return {
    addReaction: addReaction,
    removeReaction: removeReaction,
    hasReaction: hasReaction,
    isPending: isPending
  };
}

function useWhoReacted(args) {
  var _args$limit;
  return usePaginatedReadResult(useWhoReactedPublicationQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      publicationId: args.publicationId,
      observerId: args === null || args === void 0 ? void 0 : args.observerId,
      limit: (_args$limit = args === null || args === void 0 ? void 0 : args.limit) !== null && _args$limit !== void 0 ? _args$limit : 10
    })
  }))));
}

function useOperation(handler) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPending = _useState2[0],
    setIsPending = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  return {
    error: error,
    execute: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setError(undefined);
              setIsPending(true);
              _context.prev = 2;
              _context.next = 5;
              return handler.apply(void 0, _args);
            case 5:
              result = _context.sent;
              if (result.isFailure()) {
                setError(result.error);
              }
              return _context.abrupt("return", result);
            case 8:
              _context.prev = 8;
              setIsPending(false);
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 8, 11]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }(),
    isPending: isPending
  };
}

var PromiseResultPresenter = /*#__PURE__*/function () {
  function PromiseResultPresenter() {
    _classCallCheck(this, PromiseResultPresenter);
    _defineProperty(this, "deferredResult", new Deferred());
  }
  _createClass(PromiseResultPresenter, [{
    key: "present",
    value: function present(result) {
      this.deferredResult.resolve(result);
    }
  }, {
    key: "asResult",
    value: function asResult() {
      return this.deferredResult.promise;
    }
  }]);
  return PromiseResultPresenter;
}();

var mapReportReasonToInput = function mapReportReasonToInput(reason) {
  switch (reason) {
    case ReportReason.VIOLENCE:
      return {
        illegalReason: {
          reason: PublicationReportingReason.Illegal,
          subreason: PublicationReportingIllegalSubreason.Violence
        }
      };
    case ReportReason.SELF_HARM:
      return {
        illegalReason: {
          reason: PublicationReportingReason.Illegal,
          subreason: PublicationReportingIllegalSubreason.ThreatIndividual
        }
      };
    case ReportReason.DIRECT_THREAT:
      return {
        illegalReason: {
          reason: PublicationReportingReason.Illegal,
          subreason: PublicationReportingIllegalSubreason.DirectThreat
        }
      };
    case ReportReason.HARASSMENT:
    case ReportReason.HATE_SPEECH:
      return {
        illegalReason: {
          reason: PublicationReportingReason.Illegal,
          subreason: PublicationReportingIllegalSubreason.HumanAbuse
        }
      };
    case ReportReason.ANIMAL_ABUSE:
      return {
        illegalReason: {
          reason: PublicationReportingReason.Illegal,
          subreason: PublicationReportingIllegalSubreason.AnimalAbuse
        }
      };
    case ReportReason.SCAM:
    case ReportReason.UNAUTHORIZED_SALE:
      return {
        fraudReason: {
          reason: PublicationReportingReason.Fraud,
          subreason: PublicationReportingFraudSubreason.Scam
        }
      };
    case ReportReason.IMPERSONATION:
      return {
        fraudReason: {
          reason: PublicationReportingReason.Fraud,
          subreason: PublicationReportingFraudSubreason.Impersonation
        }
      };
    case ReportReason.NUDITY:
      return {
        sensitiveReason: {
          reason: PublicationReportingReason.Sensitive,
          subreason: PublicationReportingSensitiveSubreason.Nsfw
        }
      };
    case ReportReason.OFFENSIVE:
      return {
        sensitiveReason: {
          reason: PublicationReportingReason.Sensitive,
          subreason: PublicationReportingSensitiveSubreason.Offensive
        }
      };
    case ReportReason.MISLEADING:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.Misleading
        }
      };
    case ReportReason.MISUSE_HASHTAGS:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.MisuseHashtags
        }
      };
    case ReportReason.UNRELATED:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.Unrelated
        }
      };
    case ReportReason.REPETITIVE:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.Repetitive
        }
      };
    case ReportReason.FAKE_ENGAGEMENT:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.FakeEngagement
        }
      };
    case ReportReason.MANIPULATION_ALGO:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.ManipulationAlgo
        }
      };
    case ReportReason.SOMETHING_ELSE:
      return {
        spamReason: {
          reason: PublicationReportingReason.Spam,
          subreason: PublicationReportingSpamSubreason.SomethingElse
        }
      };
    default:
      assertNever(reason, "Unknown report type");
  }
};
var ReportPublicationGateway = /*#__PURE__*/function () {
  function ReportPublicationGateway(apolloClient) {
    _classCallCheck(this, ReportPublicationGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(ReportPublicationGateway, [{
    key: "report",
    value: function () {
      var _report = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
        var additionalComments, publicationId, reason;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              additionalComments = _ref.additionalComments, publicationId = _ref.publicationId, reason = _ref.reason;
              _context.next = 3;
              return this.apolloClient.mutate({
                mutation: ReportPublicationDocument,
                variables: {
                  publicationId: publicationId,
                  additionalComments: additionalComments,
                  reason: _objectSpread2({}, mapReportReasonToInput(reason))
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function report(_x) {
        return _report.apply(this, arguments);
      }
      return report;
    }()
  }]);
  return ReportPublicationGateway;
}();

function useReportPublicationController() {
  var _useSharedDependencie = useSharedDependencies(),
    apolloClient = _useSharedDependencie.apolloClient;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var gateway, presenter, reportPublication;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            gateway = new ReportPublicationGateway(apolloClient);
            presenter = new PromiseResultPresenter();
            reportPublication = new ReportPublication(gateway, presenter);
            _context.next = 5;
            return reportPublication.report(request);
          case 5:
            return _context.abrupt("return", presenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useReportPublication(_ref) {
  var publication = _ref.publication;
  var reportPublication = useReportPublicationController();
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var additionalComments, reason;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            additionalComments = _ref2.additionalComments, reason = _ref2.reason;
            return _context.abrupt("return", reportPublication({
              additionalComments: additionalComments,
              reason: reason,
              publicationId: publication.id
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

var HidePublicationGateway = /*#__PURE__*/function () {
  function HidePublicationGateway(apolloClient) {
    _classCallCheck(this, HidePublicationGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(HidePublicationGateway, [{
    key: "hide",
    value: function () {
      var _hide = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: HidePublicationDocument,
                variables: {
                  publicationId: request.publicationId
                }
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function hide(_x) {
        return _hide.apply(this, arguments);
      }
      return hide;
    }()
  }]);
  return HidePublicationGateway;
}();

var HidePublicationPresenter = /*#__PURE__*/function () {
  function HidePublicationPresenter(publicationCacheManager) {
    _classCallCheck(this, HidePublicationPresenter);
    this.publicationCacheManager = publicationCacheManager;
  }
  _createClass(HidePublicationPresenter, [{
    key: "present",
    value: function present(publicationId) {
      this.publicationCacheManager.update(publicationId, function (current) {
        return _objectSpread2(_objectSpread2({}, current), {}, {
          hidden: true
        });
      });
    }
  }]);
  return HidePublicationPresenter;
}();

function useHidePublicationController() {
  var _useSharedDependencie = useSharedDependencies(),
    apolloClient = _useSharedDependencie.apolloClient,
    publicationCacheManager = _useSharedDependencie.publicationCacheManager;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var publicationId, presenter, gateway, hidePublication;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            publicationId = _ref.publicationId;
            presenter = new HidePublicationPresenter(publicationCacheManager);
            gateway = new HidePublicationGateway(apolloClient);
            hidePublication = new HidePublication(gateway, presenter);
            _context.next = 6;
            return hidePublication.hide({
              publicationId: publicationId
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function useHidePublication(_ref) {
  var publication = _ref.publication;
  var hide = useHidePublicationController();
  return useOperation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          invariant(publication.profile.ownedByMe, 'Publication not owned by the active wallet. Make sure that publication is owned by the wallet (for .e.g. by calling `isPublicationOwnedByMe`) before trying to hide it?');
          _context.next = 3;
          return hide({
            publicationId: publication.id
          });
        case 3:
          return _context.abrupt("return", success());
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}

function useWhoCollectedPublication(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId,
    publicationId = _ref.publicationId;
  return usePaginatedReadResult(useWhoCollectedPublicationQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      limit: limit,
      publicationId: publicationId,
      observerId: observerId
    })
  }))));
}

function useWhoMirroredPublication(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    publicationId = _ref.publicationId,
    observerId = _ref.observerId;
  return usePaginatedReadResult(useGetAllProfilesByWhoMirroredPublicationQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      publicationId: publicationId,
      observerId: observerId,
      limit: limit
    })
  }))));
}

function useProfilePublicationsForSale(_ref) {
  var profileId = _ref.profileId,
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(useProfilePublicationsForSaleQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      profileId: profileId,
      observerId: observerId,
      limit: limit
    })
  }))));
}

function resolveGatedEnvironment(environment) {
  switch (environment) {
    case production:
      return GatedContent.production;
    case staging:
      return GatedContent.staging;
  }
  throw new InvariantError$1("Unknown new environment");
}
function createGatedClient(_ref) {
  var config = _ref.config,
    signer = _ref.signer,
    environment = _ref.environment,
    encryptionProvider = _ref.encryptionProvider,
    storageProvider = _ref.storageProvider;
  return new GatedContent.GatedClient({
    authentication: config,
    signer: signer,
    environment: resolveGatedEnvironment(environment),
    encryptionProvider: encryptionProvider,
    storageProvider: storageProvider
  });
}

function useActiveWallet() {
  var state = useAppState();
  var wallet = useActiveWalletVar();
  if (state === ApplicationsState.LOADING) {
    return {
      data: undefined,
      loading: true
    };
  }
  if (!wallet) {
    return {
      data: null,
      loading: false
    };
  }
  return {
    data: wallet,
    loading: false
  };
}

function useActiveWalletSigner() {
  var _useState = useState({
      signer: null,
      signerLoading: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _useState2[0],
    signer = _useState2$.signer,
    signerLoading = _useState2$.signerLoading,
    setSigner = _useState2[1];
  var _useSharedDependencie = useSharedDependencies(),
    bindings = _useSharedDependencie.bindings;
  var _useActiveWallet = useActiveWallet(),
    wallet = _useActiveWallet.data,
    walletLoading = _useActiveWallet.loading;
  var retrieveSigner = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          setSigner({
            signer: null,
            signerLoading: true
          });
          _context.prev = 1;
          _context.t0 = setSigner;
          _context.next = 5;
          return bindings.getSigner({});
        case 5:
          _context.t1 = _context.sent;
          _context.t2 = {
            signer: _context.t1,
            signerLoading: false
          };
          (0, _context.t0)(_context.t2);
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t3 = _context["catch"](1);
          setSigner({
            signer: null,
            signerLoading: true
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  })), [bindings]);
  useEffect(function () {
    if (wallet) {
      void retrieveSigner();
    }
  }, [wallet, retrieveSigner]);
  if (walletLoading || signerLoading) {
    return {
      data: undefined,
      loading: true
    };
  }
  return {
    data: signer,
    loading: false
  };
}

function useWalletLoginController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeProfileGateway = _useSharedDependencie.activeProfileGateway,
    activeProfilePresenter = _useSharedDependencie.activeProfilePresenter,
    credentialsFactory = _useSharedDependencie.credentialsFactory,
    credentialsGateway = _useSharedDependencie.credentialsGateway,
    profileGateway = _useSharedDependencie.profileGateway,
    walletFactory = _useSharedDependencie.walletFactory,
    walletGateway = _useSharedDependencie.walletGateway;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var activeWalletPresenter, loginPresenter, activeProfileLoader, walletLogin;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activeWalletPresenter = new ActiveWalletPresenter();
            loginPresenter = new PromiseResultPresenter();
            activeProfileLoader = new ActiveProfileLoader(profileGateway, activeProfileGateway, activeProfilePresenter);
            walletLogin = new WalletLogin(walletFactory, walletGateway, credentialsFactory, credentialsGateway, activeWalletPresenter, loginPresenter, activeProfileLoader);
            _context.next = 6;
            return walletLogin.login(request);
          case 6:
            return _context.abrupt("return", loginPresenter.asResult());
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useWalletLogin() {
  var loginWallet = useWalletLoginController();
  return useOperation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(signer, handle) {
      var address;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return signer.getAddress();
          case 2:
            address = _context.sent;
            return _context.abrupt("return", loginWallet({
              address: address,
              handle: handle
            }));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }
  return object;
}

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get.bind();
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);
      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }
      return desc.value;
    };
  }
  return _get.apply(this, arguments);
}

var LogoutPresenter = /*#__PURE__*/function (_ref) {
  _inherits(LogoutPresenter, _ref);
  var _super = _createSuper(LogoutPresenter);
  function LogoutPresenter(logoutHandler) {
    var _this;
    _classCallCheck(this, LogoutPresenter);
    _this = _super.call(this);
    _this.logoutHandler = logoutHandler;
    return _this;
  }
  _createClass(LogoutPresenter, [{
    key: "present",
    value: function present(data) {
      invariant(data.isSuccess(), 'Unknown error received while presenting logging out result. This is likely a `@lens-protocol/react` bug.');
      this.logoutHandler(data.unwrap());
      _get(_getPrototypeOf(LogoutPresenter.prototype), "present", this).call(this, data);
    }
  }]);
  return LogoutPresenter;
}(PromiseResultPresenter);

function useWalletLogoutController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    activeProfileGateway = _useSharedDependencie.activeProfileGateway,
    activeProfilePresenter = _useSharedDependencie.activeProfilePresenter,
    credentialsGateway = _useSharedDependencie.credentialsGateway,
    onLogout = _useSharedDependencie.onLogout,
    walletGateway = _useSharedDependencie.walletGateway;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reason) {
      var activeWalletPresenter, logoutPresenter, walletLogout;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activeWalletPresenter = new ActiveWalletPresenter();
            logoutPresenter = new LogoutPresenter(onLogout);
            walletLogout = new WalletLogout(walletGateway, credentialsGateway, activeWallet, activeProfileGateway, activeProfilePresenter, activeWalletPresenter, logoutPresenter);
            _context.next = 5;
            return walletLogout.logout(reason);
          case 5:
            return _context.abrupt("return", logoutPresenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useWalletLogout() {
  var logout = useWalletLogoutController();
  return useOperation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", logout(LogoutReason.USER_INITIATED));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}

var DecryptionError = /*#__PURE__*/function (_Error) {
  _inherits(DecryptionError, _Error);
  var _super = _createSuper(DecryptionError);
  function DecryptionError(message) {
    var _this;
    _classCallCheck(this, DecryptionError);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "name", 'DecryptionError');
    _this.message = message;
    return _this;
  }
  return _createClass(DecryptionError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function updateMetadata(publication, metadata) {
  return Object.assign({}, publication, {
    metadata: metadata
  });
}
function useEncryptedPublication(_ref) {
  var encryption = _ref.encryption,
    publication = _ref.publication;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    shouldDecrypt = _useState2[0],
    signalDecryptionIntent = _useState2[1];
  var _useState3 = useState(publication.metadata),
    _useState4 = _slicedToArray(_useState3, 2),
    metadata = _useState4[0],
    setMetadata = _useState4[1];

  // Although publication Metadata is to be considered immutable,
  // there are other things that can change (e.g. the publication could be deleted).
  // useMemo keeps the immutability paradigm of Apollo Normalized Cache objects so no
  // unnecessary downstream re-renderings are triggered.
  var data = useMemo(function () {
    return updateMetadata(publication, metadata);
  }, [publication, metadata]);
  var _useSharedDependencie = useSharedDependencies(),
    environment = _useSharedDependencie.environment,
    storageProvider = _useSharedDependencie.storageProvider;
  var _useActiveWalletSigne = useActiveWalletSigner(),
    signer = _useActiveWalletSigne.data;
  var _useOperation = useOperation(useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _publication$canObser, _publication$canObser2, client, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            invariant(isGatedPublication(publication), 'Publication is not gated');
            invariant(signer, "Cannot find the Active Wallet Signer");
            if (publication.canObserverDecrypt.result) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return", failure(new DecryptionError("Publication cannot be decrypted by the observer because: ".concat((_publication$canObser = (_publication$canObser2 = publication.canObserverDecrypt.reasons) === null || _publication$canObser2 === void 0 ? void 0 : _publication$canObser2.join(', ')) !== null && _publication$canObser !== void 0 ? _publication$canObser : 'unknown reason(s)', ")}. Make sure to check if canObserverDecrypt.result is true before calling decrypt()."))));
          case 4:
            client = createGatedClient({
              config: encryption.authentication,
              signer: signer,
              encryptionProvider: encryption.provider,
              environment: environment,
              storageProvider: storageProvider
            });
            _context.next = 7;
            return client.decryptPublication(publication.metadata, publication.metadata.__encryptionParams);
          case 7:
            result = _context.sent;
            if (!result.isFailure()) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", failure(new UnspecifiedError(result.error)));
          case 10:
            setMetadata(result.value);
            return _context.abrupt("return", success());
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), [encryption.authentication, encryption.provider, environment, publication, signer, storageProvider])),
    error = _useOperation.error,
    execute = _useOperation.execute,
    isPending = _useOperation.isPending;
  useEffect(function () {
    if (signer && isGatedPublication(publication) && shouldDecrypt) {
      void execute();
    }
  }, [shouldDecrypt, execute, publication, signer]);
  return {
    isPending: isPending,
    decrypt: function decrypt() {
      signalDecryptionIntent(true);
    },
    error: error,
    data: data
  };
}

var FeedEventItemType;
(function (FeedEventItemType) {
  FeedEventItemType[FeedEventItemType["Comment"] = FeedEventItemType$1.Comment] = "Comment";
  FeedEventItemType[FeedEventItemType["Post"] = FeedEventItemType$1.Post] = "Post";
  FeedEventItemType[FeedEventItemType["Mirror"] = FeedEventItemType$1.Mirror] = "Mirror";
  FeedEventItemType[FeedEventItemType["CollectComment"] = FeedEventItemType$1.CollectComment] = "CollectComment";
  FeedEventItemType[FeedEventItemType["CollectPost"] = FeedEventItemType$1.CollectPost] = "CollectPost";
})(FeedEventItemType || (FeedEventItemType = {}));

var _SupportedFeedEvenTyp;
var SupportedFeedEvenTypesMap = (_SupportedFeedEvenTyp = {}, _defineProperty(_SupportedFeedEvenTyp, FeedEventItemType.Comment, FeedEventItemType$1.Comment), _defineProperty(_SupportedFeedEvenTyp, FeedEventItemType.Post, FeedEventItemType$1.Post), _defineProperty(_SupportedFeedEvenTyp, FeedEventItemType.Mirror, FeedEventItemType$1.Mirror), _defineProperty(_SupportedFeedEvenTyp, FeedEventItemType.CollectComment, FeedEventItemType$1.CollectComment), _defineProperty(_SupportedFeedEvenTyp, FeedEventItemType.CollectPost, FeedEventItemType$1.CollectPost), _SupportedFeedEvenTyp);
var mapRestrictEventTypesToLensTypes = function mapRestrictEventTypesToLensTypes(restrictEventTypesTo) {
  return restrictEventTypesTo === null || restrictEventTypesTo === void 0 ? void 0 : restrictEventTypesTo.map(function (type) {
    return nonNullable(SupportedFeedEvenTypesMap[type], "Can't map the feed event type");
  });
};

// feed limit is higher than others to get good aggregation of feed items
var FEED_LIMIT = 50;
function useFeed(_ref) {
  var metadataFilter = _ref.metadataFilter,
    restrictEventTypesTo = _ref.restrictEventTypesTo,
    observerId = _ref.observerId,
    profileId = _ref.profileId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? FEED_LIMIT : _ref$limit;
  return usePaginatedReadResult(useFeedQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      metadata: createPublicationMetadataFilters(metadataFilter),
      restrictEventTypesTo: mapRestrictEventTypesToLensTypes(restrictEventTypesTo),
      profileId: profileId,
      observerId: observerId,
      limit: limit
    })
  }))));
}

function useBootstrapController(_ref) {
  var activeProfileGateway = _ref.activeProfileGateway,
    activeProfilePresenter = _ref.activeProfilePresenter,
    activeWallet = _ref.activeWallet,
    credentialsFactory = _ref.credentialsFactory,
    credentialsGateway = _ref.credentialsGateway,
    onLogout = _ref.onLogout,
    profileGateway = _ref.profileGateway,
    transactionQueue = _ref.transactionQueue;
  return useCallback(function () {
    var activeWalletPresenter = new ActiveWalletPresenter();
    var logoutPresenter = new LogoutPresenter(onLogout);
    var applicationPresenter = new ApplicationPresenter();
    var activeProfileLoader = new ActiveProfileLoader(profileGateway, activeProfileGateway, activeProfilePresenter);
    var bootstrap = new Bootstrap(activeWallet, credentialsGateway, credentialsFactory, activeWalletPresenter, applicationPresenter, logoutPresenter, activeProfileLoader, transactionQueue, activeProfileGateway);
    void bootstrap.start();
  }, [activeProfileGateway, activeProfilePresenter, activeWallet, credentialsFactory, credentialsGateway, onLogout, profileGateway, transactionQueue]);
}

var _excluded$6 = ["children"];
function noop() {}
function LensProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var isStartedRef = useRef(false);
  var initialProps = useRef(props).current;
  validateConfig(props.config);
  var _useState = useState(function () {
      var _props$onLogout, _props$onError;
      return createSharedDependencies(props.config, {
        onLogout: (_props$onLogout = props.onLogout) !== null && _props$onLogout !== void 0 ? _props$onLogout : noop,
        onError: (_props$onError = props.onError) !== null && _props$onError !== void 0 ? _props$onError : noop
      });
    }),
    _useState2 = _slicedToArray(_useState, 1),
    sharedDependencies = _useState2[0];
  useEffect(function () {
    invariant(initialProps.config === props.config, 'LensProvider: config cannot be changed');
    invariant(initialProps.onLogout === props.onLogout, 'LensProvider: onLogout cannot be changed');
    invariant(initialProps.onError === props.onError, 'LensProvider: onError cannot be changed');
  }, [initialProps, props]);
  var start = useBootstrapController(sharedDependencies);
  useEffect(function () {
    // Protects again multiple calls to start (quite likely from `useEffect` hook in concurrent mode (or in strict mode))
    if (isStartedRef.current) {
      return;
    }
    isStartedRef.current = true;
    start();
  }, [start]);
  return /*#__PURE__*/jsx(SharedDependenciesProvider, {
    dependencies: sharedDependencies,
    children: children
  });
}

function useCurrencies() {
  var _useReadResult = useReadResult(useEnabledModuleCurrenciesQuery(useLensApolloClient())),
    data = _useReadResult.data,
    error = _useReadResult.error,
    loading = _useReadResult.loading;
  if (loading) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: error,
      loading: false
    };
  }
  return {
    data: (data !== null && data !== void 0 ? data : []).map(function (currency) {
      return erc20(_objectSpread2(_objectSpread2({}, currency), {}, {
        chainType: ChainType.POLYGON
      }));
    }),
    error: undefined,
    loading: false
  };
}

function useEnabledModules() {
  return useReadResult(useEnabledModulesQuery(useLensApolloClient()));
}

function useActiveProfile() {
  var _useActiveProfileIden = useActiveProfileIdentifier(),
    identifier = _useActiveProfileIden.data,
    bootstrapping = _useActiveProfileIden.loading;
  var _useGetProfileQuery = useGetProfileQuery(useLensApolloClient({
      variables: useSourcesFromConfig({
        request: {
          profileId: identifier === null || identifier === void 0 ? void 0 : identifier.id
        }
      }),
      fetchPolicy: 'cache-first',
      skip: bootstrapping || identifier === null
    })),
    data = _useGetProfileQuery.data,
    error = _useGetProfileQuery.error,
    loading = _useGetProfileQuery.loading;
  if (bootstrapping) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (identifier === null) {
    return {
      data: null,
      error: undefined,
      loading: false
    };
  }
  if (loading || data === undefined) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: new UnspecifiedError(error),
      loading: false
    };
  }
  invariant(data.result, 'Profile not found.');
  invariant(isProfileOwnedByMe(data.result), 'Profile not owned by the active wallet.');
  return {
    data: data.result,
    error: undefined,
    loading: false
  };
}

function useSwitchActiveProfileController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeProfileGateway = _useSharedDependencie.activeProfileGateway,
    activeProfilePresenter = _useSharedDependencie.activeProfilePresenter,
    profileGateway = _useSharedDependencie.profileGateway;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var activeProfileLoader;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            activeProfileLoader = new SwitchActiveProfile(profileGateway, activeProfileGateway, activeProfilePresenter);
            _context.next = 3;
            return activeProfileLoader["switch"](request);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useActiveProfileSwitch() {
  var switchActiveProfile = useSwitchActiveProfileController();
  return useOperation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(profileId) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return switchActiveProfile({
              profileId: profileId
            });
          case 2:
            return _context.abrupt("return", success());
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

function asyncRelayReceipt(_x) {
  return _asyncRelayReceipt.apply(this, arguments);
}
function _asyncRelayReceipt() {
  _asyncRelayReceipt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(data.result.__typename === 'RelayError')) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
        case 2:
          return _context2.abrupt("return", success({
            indexingId: data.result.txId,
            txHash: data.result.txHash
          }));
        case 3:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _asyncRelayReceipt.apply(this, arguments);
}
var ProfileTransactionGateway = /*#__PURE__*/function () {
  function ProfileTransactionGateway(apolloClient, factory) {
    _classCallCheck(this, ProfileTransactionGateway);
    this.apolloClient = apolloClient;
    this.factory = factory;
  }
  _createClass(ProfileTransactionGateway, [{
    key: "createProfileTransaction",
    value: function () {
      var _createProfileTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var _yield$this$apolloCli, data, transaction;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateProfileDocument,
                variables: {
                  request: {
                    handle: request.handle
                  }
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context.next = 7;
                break;
              }
              if (!(data.result.reason === RelayErrorReasons.HandleTaken)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", failure(new DuplicatedHandleError(request.handle)));
            case 7:
              transaction = this.factory.createNativeTransaction({
                chainType: ChainType.POLYGON,
                request: request,
                id: v4(),
                asyncRelayReceipt: asyncRelayReceipt(data)
              });
              return _context.abrupt("return", success(transaction));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createProfileTransaction(_x2) {
        return _createProfileTransaction.apply(this, arguments);
      }
      return createProfileTransaction;
    }()
  }]);
  return ProfileTransactionGateway;
}();

function useCreateProfileController() {
  var _useSharedDependencie = useSharedDependencies(),
    apolloClient = _useSharedDependencie.apolloClient,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(handle) {
      var presenter, gateway, createProfile;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            gateway = new ProfileTransactionGateway(apolloClient, transactionFactory);
            createProfile = new CreateProfile(gateway, presenter, transactionQueue);
            _context.next = 5;
            return createProfile.create({
              handle: handle,
              kind: TransactionKind.CREATE_PROFILE
            });
          case 5:
            return _context.abrupt("return", presenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useCreateProfile() {
  var createProfile = useCreateProfileController();
  var waitUntilTransactionIsSettled = useWaitUntilTransactionSettled();
  return useOperation( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(handle) {
      var result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return createProfile(handle);
          case 3:
            result = _context.sent;
            if (!result.isSuccess()) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return waitUntilTransactionIsSettled(function (transaction) {
              return transaction.request.kind === TransactionKind.CREATE_PROFILE && transaction.request.handle === handle;
            });
          case 7:
            return _context.abrupt("return", result);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0 instanceof TransactionError)) {
              _context.next = 14;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 14:
            throw _context.t0;
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}

function useProfilesToFollow() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    observerId = _ref.observerId;
  return useReadResult(useProfilesToFollowQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      observerId: observerId
    })
  }))));
}

function useProfileFollowers(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId,
    profileId = _ref.profileId;
  return usePaginatedReadResult(useProfileFollowersQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      profileId: profileId,
      limit: limit,
      observerId: observerId
    })
  }))));
}

function useProfileFollowing(_ref) {
  var _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId,
    walletAddress = _ref.walletAddress;
  return usePaginatedReadResult(useProfileFollowingQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      walletAddress: walletAddress,
      limit: limit,
      observerId: observerId
    })
  }))));
}

var _excluded$5 = ["observerId"];
function useProfile(_ref) {
  var observerId = _ref.observerId,
    request = _objectWithoutProperties(_ref, _excluded$5);
  invariant(request.profileId === undefined || request.handle === undefined, "Only one of 'id' or 'handle' should be provided to 'useProfile' hook");
  var _useReadResult = useReadResult(useGetProfileQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
      variables: useSourcesFromConfig({
        request: request,
        observerId: observerId
      })
    })))),
    data = _useReadResult.data,
    error = _useReadResult.error,
    loading = _useReadResult.loading;
  if (loading) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: error,
      loading: false
    };
  }
  if (data === null) {
    return {
      data: undefined,
      error: new NotFoundError("Profile for ".concat(JSON.stringify(request))),
      loading: false
    };
  }
  return {
    data: data,
    error: undefined,
    loading: false
  };
}

function useExploreProfiles() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(useExploreProfilesQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      limit: limit,
      observerId: observerId
    })
  }))));
}

function useSearchProfiles(_ref) {
  var query = _ref.query,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    observerId = _ref.observerId;
  return usePaginatedReadResult(useSearchProfilesQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      query: query,
      limit: limit,
      observerId: observerId
    })
  }))));
}

function useCollectedPublications(_ref) {
  var walletAddress = _ref.walletAddress,
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(useWalletCollectedPublicationsQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      walletAddress: walletAddress,
      limit: limit,
      observerId: observerId
    })
  }))));
}

function useMutualFollowers(_ref) {
  var observerId = _ref.observerId,
    viewingProfileId = _ref.viewingProfileId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(useMutualFollowersProfilesQuery(useLensApolloClient({
    variables: useSourcesFromConfig({
      limit: limit,
      observerId: observerId,
      viewingProfileId: viewingProfileId
    })
  })));
}

var ProfileImageCallGateway = /*#__PURE__*/function () {
  function ProfileImageCallGateway(apolloClient, transactionFactory) {
    _classCallCheck(this, ProfileImageCallGateway);
    this.apolloClient = apolloClient;
    this.transactionFactory = transactionFactory;
  }
  _createClass(ProfileImageCallGateway, [{
    key: "createDelegatedTransaction",
    value: function () {
      var _createDelegatedTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.transactionFactory.createNativeTransaction({
                chainType: ChainType.POLYGON,
                id: v4(),
                request: request,
                asyncRelayReceipt: this.initiateProfileImageUpdate(this.resolveMutationRequest(request))
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createDelegatedTransaction(_x) {
        return _createDelegatedTransaction.apply(this, arguments);
      }
      return createDelegatedTransaction;
    }()
  }, {
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetProfileImageUriTypedDataDocument,
                variables: {
                  request: this.resolveMutationRequest(request),
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context2.sent;
              data = _yield$this$apolloCli.data;
              return _context2.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUnsignedProtocolCall(_x2, _x3) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }, {
    key: "initiateProfileImageUpdate",
    value: function () {
      var _initiateProfileImageUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestArgs) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetProfileImageUriViaDispatcherDocument,
                variables: {
                  request: requestArgs
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context3.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 6:
              return _context3.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initiateProfileImageUpdate(_x4) {
        return _initiateProfileImageUpdate.apply(this, arguments);
      }
      return initiateProfileImageUpdate;
    }()
  }, {
    key: "resolveMutationRequest",
    value: function resolveMutationRequest(request) {
      if ('signature' in request) {
        return {
          profileId: request.profileId,
          nftData: {
            id: request.signature.id,
            signature: request.signature.signature
          }
        };
      }
      return {
        profileId: request.profileId,
        url: request.url
      };
    }
  }]);
  return ProfileImageCallGateway;
}();

function useUpdateProfileImageController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    transactionGateway = _useSharedDependencie.transactionGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue,
    transactionFactory = _useSharedDependencie.transactionFactory;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var profileImageCallGateway, presenter, signedUpdateProfileImage, updateProfileImage;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            profileImageCallGateway = new ProfileImageCallGateway(apolloClient, transactionFactory);
            presenter = new PromiseResultPresenter();
            signedUpdateProfileImage = new ProtocolCallUseCase(activeWallet, transactionGateway, profileImageCallGateway, protocolCallRelayer, transactionQueue, presenter);
            updateProfileImage = new UpdateProfileImage(signedUpdateProfileImage, profileImageCallGateway, transactionQueue, presenter);
            _context.next = 6;
            return updateProfileImage.execute(request);
          case 6:
            return _context.abrupt("return", presenter.asResult());
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useUpdateProfileImage(_ref) {
  var profile = _ref.profile;
  var updateImage = useUpdateProfileImageController();
  return useOperation( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileUrl) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", updateImage({
              kind: TransactionKind.UPDATE_PROFILE_IMAGE,
              profileId: profile.id,
              url: fileUrl,
              delegate: profile.dispatcher !== null
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

function useProfilesOwnedBy(_ref) {
  var address = _ref.address,
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  return usePaginatedReadResult(useGetAllProfilesByOwnerAddressQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      address: address,
      observerId: observerId,
      limit: limit
    })
  }))));
}

function useProfilesOwnedByMe() {
  var _activeWallet$address;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit;
  var _useActiveWallet = useActiveWallet(),
    activeWallet = _useActiveWallet.data,
    bootstrapping = _useActiveWallet.loading;
  var recentProfiles = useRecentProfiles();
  var result = usePaginatedReadResult(useGetAllProfilesByOwnerAddressQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      address: bootstrapping ? constants.AddressZero : (_activeWallet$address = activeWallet === null || activeWallet === void 0 ? void 0 : activeWallet.address) !== null && _activeWallet$address !== void 0 ? _activeWallet$address : never("Cannot use 'useProfilesOwnedByMe' without being logged in. Use 'useWalletLogin' to log in first."),
      observerId: observerId,
      limit: limit
    }),
    skip: bootstrapping && activeWallet === null
  }))));
  return _objectSpread2(_objectSpread2({}, result), {}, {
    data: result.data ? [].concat(_toConsumableArray(result.data), _toConsumableArray(recentProfiles)) : result.data
  });
}

function useProfileFollowRevenue(_ref) {
  var profileId = _ref.profileId;
  var _useReadResult = useReadResult(useProfileFollowRevenueQuery(useLensApolloClient({
      variables: {
        profileId: profileId
      }
    }))),
    data = _useReadResult.data,
    error = _useReadResult.error,
    loading = _useReadResult.loading;
  if (loading) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: error,
      loading: false
    };
  }
  return {
    data: data.revenues,
    error: undefined,
    loading: false
  };
}

function usePublicationRevenue(_ref) {
  var publicationId = _ref.publicationId,
    observerId = _ref.observerId;
  var _useReadResult = useReadResult(usePublicationRevenueQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
      variables: useSourcesFromConfig({
        publicationId: publicationId,
        observerId: observerId
      })
    })))),
    data = _useReadResult.data,
    error = _useReadResult.error,
    loading = _useReadResult.loading;
  if (loading) {
    return {
      data: undefined,
      error: undefined,
      loading: true
    };
  }
  if (error) {
    return {
      data: undefined,
      error: error,
      loading: false
    };
  }
  if (data === null) {
    return {
      data: undefined,
      error: new NotFoundError("Publication with id: ".concat(publicationId)),
      loading: false
    };
  }
  return {
    data: data,
    error: undefined,
    loading: false
  };
}

function useProfilePublicationRevenue(_ref) {
  var profileId = _ref.profileId,
    observerId = _ref.observerId,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? DEFAULT_PAGINATED_QUERY_LIMIT : _ref$limit,
    publicationTypes = _ref.publicationTypes;
  return usePaginatedReadResult(useProfilePublicationRevenueQuery(useLensApolloClient(useActiveProfileAsDefaultObserver({
    variables: useSourcesFromConfig({
      limit: limit,
      publicationTypes: publicationTypes,
      observerId: observerId,
      profileId: profileId
    })
  }))));
}

var _transactionSpeedToPe;
var Eip1559GasPriceEstimate = /*#__PURE__*/function () {
  function Eip1559GasPriceEstimate(baseFee, maxPriorityFeePerGas) {
    _classCallCheck(this, Eip1559GasPriceEstimate);
    this.baseFee = baseFee;
    this.maxPriorityFeePerGas = maxPriorityFeePerGas;
  }
  _createClass(Eip1559GasPriceEstimate, [{
    key: "maxFeePerGas",
    get: function get() {
      // Heuristic logic based on https://www.blocknative.com/blog/eip-1559-fees
      // > maxFeePerGas = (2 * baseFee) + maxPriorityFeePerGas
      // Despite ethers.js uses an hardcoded value for maxPriorityFeePerGas they
      // use the same exact logic to compute maxFeePerGas.
      // see: https://github.com/ethers-io/ethers.js/blob/7175e2e99c2747e8d2314feb407bf0a0f9371ece/packages/abstract-provider/src.ts/index.ts#L247
      return this.baseFee.mul(2).add(this.maxPriorityFeePerGas);
    }
  }, {
    key: "estimatedGasPrice",
    get: function get() {
      return this.baseFee.add(this.maxPriorityFeePerGas);
    }
  }]);
  return Eip1559GasPriceEstimate;
}();
var TransactionExecutionSpeed;
(function (TransactionExecutionSpeed) {
  TransactionExecutionSpeed["FAST"] = "fast";
  TransactionExecutionSpeed["AVERAGE"] = "average";
  TransactionExecutionSpeed["SLOW"] = "slow";
})(TransactionExecutionSpeed || (TransactionExecutionSpeed = {}));
var BLOCK_COUNT = 20;
var LOWER_PERCENTILE = 1;
var MEAN_PERCENTILE = 50;
var HIGHER_PERCENTILE = 99;
var REWARD_PERCENTILES = [LOWER_PERCENTILE, MEAN_PERCENTILE, HIGHER_PERCENTILE];
var NEWEST_BLOCK = 'pending';
function computeFeeHistoryStats(result) {
  var _blocks;
  var oldestBlock = Number(result.oldestBlock);
  var blockNum = oldestBlock;
  var index = 0;
  var blocks = [];
  while (blockNum < oldestBlock + BLOCK_COUNT) {
    var _result$baseFeePerGas, _result$reward$index;
    blocks.push({
      number: blockNum,
      baseFeePerGas: BigDecimal.from((_result$baseFeePerGas = result.baseFeePerGas[index]) !== null && _result$baseFeePerGas !== void 0 ? _result$baseFeePerGas : never("Cannot find baseFeePerGas for block ".concat(blockNum))),
      priorityFeePerGas: ((_result$reward$index = result.reward[index]) !== null && _result$reward$index !== void 0 ? _result$reward$index : never("Cannot find reward for block ".concat(blockNum))).map(function (x) {
        return BigDecimal.from(x);
      })
    });
    blockNum += 1;
    index += 1;
  }
  return {
    blocks: blocks,
    baseFee: ((_blocks = blocks[blocks.length - 1]) !== null && _blocks !== void 0 ? _blocks : never('Cannot index last block')).baseFeePerGas
  };
}
var transactionSpeedToPercentileIndex = (_transactionSpeedToPe = {}, _defineProperty(_transactionSpeedToPe, TransactionExecutionSpeed.SLOW, REWARD_PERCENTILES.indexOf(LOWER_PERCENTILE)), _defineProperty(_transactionSpeedToPe, TransactionExecutionSpeed.AVERAGE, REWARD_PERCENTILES.indexOf(MEAN_PERCENTILE)), _defineProperty(_transactionSpeedToPe, TransactionExecutionSpeed.FAST, REWARD_PERCENTILES.indexOf(HIGHER_PERCENTILE)), _transactionSpeedToPe);
function computeMaxPriorityFeePerGas(blocks, speed) {
  // TODO: set min to 2 Gwei
  var index = transactionSpeedToPercentileIndex[speed];
  return BigDecimal.mean(blocks.map(function (b) {
    var _b$priorityFeePerGas$;
    return (_b$priorityFeePerGas$ = b.priorityFeePerGas[index]) !== null && _b$priorityFeePerGas$ !== void 0 ? _b$priorityFeePerGas$ : never('Cannot find priorityFeePerGas for the specified transactions execution speed');
  }));
}
var Eip1559GasPriceEstimator = /*#__PURE__*/function () {
  function Eip1559GasPriceEstimator(provider, createAmount) {
    _classCallCheck(this, Eip1559GasPriceEstimator);
    this.provider = provider;
    this.createAmount = createAmount;
  }
  _createClass(Eip1559GasPriceEstimator, [{
    key: "estimate",
    value: function () {
      var _estimate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(speed) {
        var _yield$this$fetchFeeH, blocks, baseFee, maxPriorityFeePerGas;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.fetchFeeHistoryStats();
            case 2:
              _yield$this$fetchFeeH = _context.sent;
              blocks = _yield$this$fetchFeeH.blocks;
              baseFee = _yield$this$fetchFeeH.baseFee;
              maxPriorityFeePerGas = computeMaxPriorityFeePerGas(blocks, speed);
              return _context.abrupt("return", new Eip1559GasPriceEstimate(this.createAmount(Denomination.wei(baseFee)), this.createAmount(Denomination.wei(maxPriorityFeePerGas))));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function estimate(_x) {
        return _estimate.apply(this, arguments);
      }
      return estimate;
    }()
  }, {
    key: "fetchFeeHistoryStats",
    value: function () {
      var _fetchFeeHistoryStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.provider.send('eth_feeHistory', [BLOCK_COUNT, NEWEST_BLOCK, REWARD_PERCENTILES]);
            case 2:
              response = _context2.sent;
              return _context2.abrupt("return", computeFeeHistoryStats(response));
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchFeeHistoryStats() {
        return _fetchFeeHistoryStats.apply(this, arguments);
      }
      return fetchFeeHistoryStats;
    }()
  }]);
  return Eip1559GasPriceEstimator;
}();

var UnsignedApproveTransaction = /*#__PURE__*/function (_ref) {
  _inherits(UnsignedApproveTransaction, _ref);
  var _super = _createSuper(UnsignedApproveTransaction);
  function UnsignedApproveTransaction(chainType, request, transactionRequest) {
    var _this;
    _classCallCheck(this, UnsignedApproveTransaction);
    _this = _super.call(this, getID(), chainType, request);
    _this.transactionRequest = transactionRequest;
    return _this;
  }
  return _createClass(UnsignedApproveTransaction);
}(UnsignedTransaction);
function createCryptoNativeAmountFactoryFor(asset) {
  switch (asset.chainType) {
    case ChainType.ETHEREUM:
      return function (value) {
        return Amount.ether(value);
      };
    case ChainType.POLYGON:
      return function (value) {
        return Amount.matic(value);
      };
  }
}
function resolveApproveAmount(request) {
  switch (request.limit) {
    case TokenAllowanceLimit.EXACT:
      return bigNumber(request.amount);
    case TokenAllowanceLimit.INFINITE:
      return constants.MaxUint256;
  }
}
var ApproveTransactionGateway = /*#__PURE__*/function () {
  function ApproveTransactionGateway(providerFactory) {
    _classCallCheck(this, ApproveTransactionGateway);
    this.providerFactory = providerFactory;
  }
  _createClass(ApproveTransactionGateway, [{
    key: "createApproveTransaction",
    value: function () {
      var _createApproveTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, wallet) {
        var provider, contract, amount, gasLimit, gasEstimator, gasPriceEstimate, transactionRequest;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.providerFactory.createProvider({
                chainType: request.amount.asset.chainType
              });
            case 2:
              provider = _context.sent;
              contract = erc20$1(request.amount.asset.address, provider);
              amount = resolveApproveAmount(request);
              _context.next = 7;
              return contract.estimateGas.approve(request.spender, amount, {
                from: wallet.address
              });
            case 7:
              gasLimit = _context.sent;
              gasEstimator = new Eip1559GasPriceEstimator(provider, createCryptoNativeAmountFactoryFor(request.amount.asset));
              _context.next = 11;
              return gasEstimator.estimate(TransactionExecutionSpeed.FAST);
            case 11:
              gasPriceEstimate = _context.sent;
              _context.next = 14;
              return contract.populateTransaction.approve(request.spender, amount, {
                from: wallet.address,
                gasLimit: gasLimit,
                maxFeePerGas: bigNumber(gasPriceEstimate.maxFeePerGas),
                maxPriorityFeePerGas: bigNumber(gasPriceEstimate.maxPriorityFeePerGas),
                type: 2 // EIP-1559
              });
            case 14:
              transactionRequest = _context.sent;
              return _context.abrupt("return", new UnsignedApproveTransaction(request.amount.asset.chainType, request, transactionRequest));
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createApproveTransaction(_x, _x2) {
        return _createApproveTransaction.apply(this, arguments);
      }
      return createApproveTransaction;
    }()
  }]);
  return ApproveTransactionGateway;
}();

function useApproveModuleController() {
  var _useSharedDependencie = useSharedDependencies(),
    providerFactory = _useSharedDependencie.providerFactory,
    activeWallet = _useSharedDependencie.activeWallet,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, approveTransactionGateway, tokenAllowance;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            approveTransactionGateway = new ApproveTransactionGateway(providerFactory);
            tokenAllowance = new TokenAllowance(activeWallet, approveTransactionGateway, presenter, transactionQueue);
            _context.next = 5;
            return tokenAllowance.increaseAllowance(request);
          case 5:
            return _context.abrupt("return", presenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useApproveModule() {
  var setAllowance = useApproveModuleController();
  var waitUntilTransactionIsSettled = useWaitUntilTransactionSettled();
  return useOperation( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref) {
      var amount, limit, spender, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            amount = _ref.amount, limit = _ref.limit, spender = _ref.spender;
            _context.next = 3;
            return setAllowance({
              amount: amount,
              kind: TransactionKind.APPROVE_MODULE,
              limit: limit,
              spender: spender
            });
          case 3:
            result = _context.sent;
            if (!result.isSuccess()) {
              _context.next = 7;
              break;
            }
            _context.next = 7;
            return waitUntilTransactionIsSettled(function (transaction) {
              return transaction.request.kind === TransactionKind.APPROVE_MODULE && transaction.request.spender === spender && transaction.request.amount.asset === amount.asset;
            });
          case 7:
            return _context.abrupt("return", result);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

var CollectProxyActionRelayer = /*#__PURE__*/function () {
  function CollectProxyActionRelayer(apolloClient, factory, logger) {
    _classCallCheck(this, CollectProxyActionRelayer);
    this.apolloClient = apolloClient;
    this.factory = factory;
    this.logger = logger;
  }
  _createClass(CollectProxyActionRelayer, [{
    key: "relaySignlessProtocolCall",
    value: function () {
      var _relaySignlessProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var relayProxyReceipt;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.broadcast(request);
            case 2:
              relayProxyReceipt = _context.sent;
              return _context.abrupt("return", this.factory.createProxyTransaction({
                chainType: ChainType.POLYGON,
                id: getID(),
                request: request,
                proxyId: relayProxyReceipt.proxyId
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function relaySignlessProtocolCall(_x) {
        return _relaySignlessProtocolCall.apply(this, arguments);
      }
      return relaySignlessProtocolCall;
    }()
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.executeBroadcast({
                collect: {
                  freeCollect: {
                    publicationId: request.publicationId
                  }
                }
              });
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              this.logger.error(_context2.t0, 'It was not possible to relay the transaction');
              throw new TransactionError(TransactionErrorReason.CANNOT_EXECUTE);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function broadcast(_x2) {
        return _broadcast.apply(this, arguments);
      }
      return broadcast;
    }()
  }, {
    key: "executeBroadcast",
    value: function () {
      var _executeBroadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(request) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: ProxyActionDocument,
                variables: {
                  request: request
                }
              });
            case 2:
              _yield$this$apolloCli = _context3.sent;
              data = _yield$this$apolloCli.data;
              return _context3.abrupt("return", {
                proxyId: data.result
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function executeBroadcast(_x3) {
        return _executeBroadcast.apply(this, arguments);
      }
      return executeBroadcast;
    }()
  }]);
  return CollectProxyActionRelayer;
}();

var CollectPublicationCallGateway = /*#__PURE__*/function () {
  function CollectPublicationCallGateway(apolloClient) {
    _classCallCheck(this, CollectPublicationCallGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(CollectPublicationCallGateway, [{
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateCollectTypedDataDocument,
                variables: {
                  request: {
                    publicationId: request.publicationId
                  },
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              invariant(data, 'Cannot generate typed data for collect');
              return _context.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createUnsignedProtocolCall(_x, _x2) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }]);
  return CollectPublicationCallGateway;
}();

function useCollectController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    logger = _useSharedDependencie.logger,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    tokenAvailability = _useSharedDependencie.tokenAvailability,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var collectPublicationCallGateway, presenter, signedFlow, collectProxyActionRelayer, signlessFlow, collectPublication;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            collectPublicationCallGateway = new CollectPublicationCallGateway(apolloClient);
            presenter = new PromiseResultPresenter();
            signedFlow = new ProtocolCallUseCase(activeWallet, transactionGateway, collectPublicationCallGateway, protocolCallRelayer, transactionQueue, presenter);
            collectProxyActionRelayer = new CollectProxyActionRelayer(apolloClient, transactionFactory, logger);
            signlessFlow = new SignlessProtocolCallUseCase(collectProxyActionRelayer, transactionQueue, presenter);
            collectPublication = new CollectPublication(tokenAvailability, signedFlow, signlessFlow, presenter);
            _context.next = 8;
            return collectPublication.execute(request);
          case 8:
            return _context.abrupt("return", presenter.asResult());
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useCollect(_ref) {
  var collector = _ref.collector,
    publication = _ref.publication;
  var collect = useCollectController();
  return useOperation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", collect(createCollectRequest(publication, collector)));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}

var FailedUploadError = /*#__PURE__*/function (_CausedError) {
  _inherits(FailedUploadError, _CausedError);
  var _super = _createSuper(FailedUploadError);
  function FailedUploadError() {
    var _this;
    _classCallCheck(this, FailedUploadError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'FailedUploadError');
    return _this;
  }
  return _createClass(FailedUploadError);
}(CausedError);

function resolveCollectModuleFeeParams(collect) {
  return {
    amount: {
      currency: collect.fee.asset.address,
      value: collect.fee.toSignificantDigits()
    },
    followerOnly: collect.followersOnly,
    recipient: collect.recipient,
    referralFee: collect.mirrorReward
  };
}
function resolveChargeCollectModule(collect) {
  if (collect.collectLimit && collect.timeLimited) {
    return {
      limitedTimedFeeCollectModule: _objectSpread2(_objectSpread2({}, resolveCollectModuleFeeParams(collect)), {}, {
        collectLimit: collect.collectLimit.toString()
      })
    };
  }
  if (collect.collectLimit) {
    return {
      limitedFeeCollectModule: _objectSpread2(_objectSpread2({}, resolveCollectModuleFeeParams(collect)), {}, {
        collectLimit: collect.collectLimit.toString()
      })
    };
  }
  if (collect.timeLimited) {
    return {
      timedFeeCollectModule: resolveCollectModuleFeeParams(collect)
    };
  }
  return {
    feeCollectModule: resolveCollectModuleFeeParams(collect)
  };
}
function resolveCollectModule(request) {
  switch (request.collect.type) {
    case CollectPolicyType.FREE:
      return {
        freeCollectModule: {
          followerOnly: request.collect.followersOnly
        }
      };
    case CollectPolicyType.NO_COLLECT:
      return {
        revertCollectModule: true
      };
    case CollectPolicyType.CHARGE:
      return resolveChargeCollectModule(request.collect);
  }
}
function resolveReferenceModule(request) {
  if (request.reference.type === ReferencePolicyType.FOLLOWERS_ONLY) {
    return {
      followerOnlyReferenceModule: true
    };
  }
  if (request.reference.type === ReferencePolicyType.DEGREES_OF_SEPARATION) {
    return {
      degreesOfSeparationReferenceModule: request.reference.params
    };
  }
  return undefined;
}

var CreateCommentCallGateway = /*#__PURE__*/function () {
  function CreateCommentCallGateway(apolloClient, transactionFactory, uploader) {
    _classCallCheck(this, CreateCommentCallGateway);
    this.apolloClient = apolloClient;
    this.transactionFactory = transactionFactory;
    this.uploader = uploader;
  }
  _createClass(CreateCommentCallGateway, [{
    key: "createDelegatedTransaction",
    value: function () {
      var _createDelegatedTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.transactionFactory;
              _context.t1 = ChainType.POLYGON;
              _context.t2 = v4();
              _context.t3 = request;
              _context.t4 = this;
              _context.next = 7;
              return this.resolveCreateCommentRequestArg(request);
            case 7:
              _context.t5 = _context.sent;
              _context.t6 = _context.t4.initiateCommentCreation.call(_context.t4, _context.t5);
              _context.t7 = {
                chainType: _context.t1,
                id: _context.t2,
                request: _context.t3,
                asyncRelayReceipt: _context.t6
              };
              return _context.abrupt("return", _context.t0.createNativeTransaction.call(_context.t0, _context.t7));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createDelegatedTransaction(_x) {
        return _createDelegatedTransaction.apply(this, arguments);
      }
      return createDelegatedTransaction;
    }()
  }, {
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this.apolloClient;
              _context2.t1 = CreateCommentTypedDataDocument;
              _context2.next = 4;
              return this.resolveCreateCommentRequestArg(request);
            case 4:
              _context2.t2 = _context2.sent;
              _context2.t3 = nonce ? {
                overrideSigNonce: nonce
              } : undefined;
              _context2.t4 = {
                request: _context2.t2,
                options: _context2.t3
              };
              _context2.t5 = {
                mutation: _context2.t1,
                variables: _context2.t4
              };
              _context2.next = 10;
              return _context2.t0.mutate.call(_context2.t0, _context2.t5);
            case 10:
              _yield$this$apolloCli = _context2.sent;
              data = _yield$this$apolloCli.data;
              return _context2.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUnsignedProtocolCall(_x2, _x3) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }, {
    key: "initiateCommentCreation",
    value: function () {
      var _initiateCommentCreation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestArg) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateCommentViaDispatcherDocument,
                variables: {
                  request: requestArg
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context3.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 6:
              return _context3.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initiateCommentCreation(_x4) {
        return _initiateCommentCreation.apply(this, arguments);
      }
      return initiateCommentCreation;
    }()
  }, {
    key: "resolveCreateCommentRequestArg",
    value: function () {
      var _resolveCreateCommentRequestArg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(request) {
        var contentURI;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.uploader.upload(request);
            case 2:
              contentURI = _context4.sent;
              return _context4.abrupt("return", {
                contentURI: contentURI,
                profileId: request.profileId,
                publicationId: request.publicationId,
                collectModule: resolveCollectModule(request),
                referenceModule: resolveReferenceModule(request)
              });
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function resolveCreateCommentRequestArg(_x5) {
        return _resolveCreateCommentRequestArg.apply(this, arguments);
      }
      return resolveCreateCommentRequestArg;
    }()
  }]);
  return CreateCommentCallGateway;
}();

var CreateCommentController = /*#__PURE__*/function () {
  function CreateCommentController(_ref) {
    var activeWallet = _ref.activeWallet,
      apolloClient = _ref.apolloClient,
      protocolCallRelayer = _ref.protocolCallRelayer,
      transactionFactory = _ref.transactionFactory,
      transactionGateway = _ref.transactionGateway,
      transactionQueue = _ref.transactionQueue,
      uploader = _ref.uploader;
    _classCallCheck(this, CreateCommentController);
    _defineProperty(this, "presenter", new PromiseResultPresenter());
    var gateway = new CreateCommentCallGateway(apolloClient, transactionFactory, uploader);
    var signedCreatePost = new ProtocolCallUseCase(activeWallet, transactionGateway, gateway, protocolCallRelayer, transactionQueue, this.presenter);
    this.createComment = new CreateComment(signedCreatePost, gateway, transactionQueue, this.presenter);
  }
  _createClass(CreateCommentController, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.createComment.execute(request);
            case 2:
              return _context.abrupt("return", this.presenter.asResult());
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return CreateCommentController;
}();

var _excluded$4 = ["displayType", "value"];
function mapMetaAttributes(attributes) {
  return attributes.map(function (_ref) {
    var displayType = _ref.displayType,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded$4);
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      value: value.toString(),
      displayType: PublicationMetadataDisplayTypes[displayType]
    });
  });
}
function mapMedia(media) {
  return {
    item: media.url,
    type: media.mimeType
  };
}
function createPublicationMetadata(request) {
  var _request$media;
  var sharedMetadata = _objectSpread2(_objectSpread2({
    version: '2.0.0',
    metadata_id: v4()
  }, request.appId && {
    appId: request.appId
  }), {}, {
    content: request.content,
    media: (_request$media = request.media) === null || _request$media === void 0 ? void 0 : _request$media.map(mapMedia),
    locale: request.locale,
    mainContentFocus: PublicationMainFocus[request.contentFocus]
  });
  switch (request.collect.type) {
    case CollectPolicyType.CHARGE:
    case CollectPolicyType.FREE:
      return _objectSpread2(_objectSpread2({}, sharedMetadata), {}, {
        attributes: mapMetaAttributes(request.collect.metadata.attributes),
        description: request.collect.metadata.description,
        name: request.collect.metadata.name
      });
    case CollectPolicyType.NO_COLLECT:
      return _objectSpread2(_objectSpread2({}, sharedMetadata), {}, {
        name: 'none',
        // although "name" is not needed when a publication is not collectable, Publication Metadata V2 schema requires it ¯\_(ツ)_/¯
        attributes: []
      });
  }
}

var PublicationMetadataUploader = /*#__PURE__*/function () {
  function PublicationMetadataUploader(handler) {
    _classCallCheck(this, PublicationMetadataUploader);
    this.handler = handler;
  }
  _createClass(PublicationMetadataUploader, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var metadata;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              metadata = createPublicationMetadata(request);
              _context.next = 4;
              return this.handler(metadata);
            case 4:
              return _context.abrupt("return", _context.sent);
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              assertError(_context.t0);
              throw new FailedUploadError('Cannot upload metadata', {
                cause: _context.t0
              });
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 7]]);
      }));
      function upload(_x) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }]);
  return PublicationMetadataUploader;
}();

var _excluded$3 = ["collect", "reference"];
function useCreateComment(_ref) {
  var publisher = _ref.publisher,
    upload = _ref.upload;
  var _useSharedDependencie = useSharedDependencies(),
    appId = _useSharedDependencie.appId,
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref2$collect, collect, _ref2$reference, reference, args, uploader, controller;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$collect = _ref2.collect, collect = _ref2$collect === void 0 ? {
              type: CollectPolicyType.NO_COLLECT
            } : _ref2$collect, _ref2$reference = _ref2.reference, reference = _ref2$reference === void 0 ? {
              type: ReferencePolicyType.ANYONE
            } : _ref2$reference, args = _objectWithoutProperties(_ref2, _excluded$3);
            uploader = new PublicationMetadataUploader(upload);
            controller = new CreateCommentController({
              activeWallet: activeWallet,
              apolloClient: apolloClient,
              protocolCallRelayer: protocolCallRelayer,
              transactionFactory: transactionFactory,
              transactionGateway: transactionGateway,
              transactionQueue: transactionQueue,
              uploader: uploader
            });
            _context.prev = 3;
            _context.next = 6;
            return controller.execute(_objectSpread2({
              kind: TransactionKind.CREATE_COMMENT,
              delegate: publisher.dispatcher !== null,
              collect: collect,
              profileId: publisher.id,
              reference: reference,
              appId: appId
            }, args));
          case 6:
            return _context.abrupt("return", _context.sent);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            if (!(_context.t0 instanceof FailedUploadError)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 13:
            throw _context.t0;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

var CreatePostCallGateway = /*#__PURE__*/function () {
  function CreatePostCallGateway(apolloClient, transactionFactory, metadataUploader) {
    _classCallCheck(this, CreatePostCallGateway);
    this.apolloClient = apolloClient;
    this.transactionFactory = transactionFactory;
    this.metadataUploader = metadataUploader;
  }
  _createClass(CreatePostCallGateway, [{
    key: "createDelegatedTransaction",
    value: function () {
      var _createDelegatedTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.transactionFactory;
              _context.t1 = ChainType.POLYGON;
              _context.t2 = v4();
              _context.t3 = request;
              _context.t4 = this;
              _context.next = 7;
              return this.resolveCreatePostRequestArg(request);
            case 7:
              _context.t5 = _context.sent;
              _context.t6 = _context.t4.initiatePostCreation.call(_context.t4, _context.t5);
              _context.t7 = {
                chainType: _context.t1,
                id: _context.t2,
                request: _context.t3,
                asyncRelayReceipt: _context.t6
              };
              return _context.abrupt("return", _context.t0.createNativeTransaction.call(_context.t0, _context.t7));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createDelegatedTransaction(_x) {
        return _createDelegatedTransaction.apply(this, arguments);
      }
      return createDelegatedTransaction;
    }()
  }, {
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this.apolloClient;
              _context2.t1 = CreatePostTypedDataDocument;
              _context2.next = 4;
              return this.resolveCreatePostRequestArg(request);
            case 4:
              _context2.t2 = _context2.sent;
              _context2.t3 = nonce ? {
                overrideSigNonce: nonce
              } : undefined;
              _context2.t4 = {
                request: _context2.t2,
                options: _context2.t3
              };
              _context2.t5 = {
                mutation: _context2.t1,
                variables: _context2.t4
              };
              _context2.next = 10;
              return _context2.t0.mutate.call(_context2.t0, _context2.t5);
            case 10:
              _yield$this$apolloCli = _context2.sent;
              data = _yield$this$apolloCli.data;
              return _context2.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUnsignedProtocolCall(_x2, _x3) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }, {
    key: "initiatePostCreation",
    value: function () {
      var _initiatePostCreation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestArgs) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: CreatePostViaDispatcherDocument,
                variables: {
                  request: requestArgs
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context3.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 6:
              return _context3.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initiatePostCreation(_x4) {
        return _initiatePostCreation.apply(this, arguments);
      }
      return initiatePostCreation;
    }()
  }, {
    key: "resolveCreatePostRequestArg",
    value: function () {
      var _resolveCreatePostRequestArg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(request) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.metadataUploader.upload(request);
            case 2:
              _context4.t0 = _context4.sent;
              _context4.t1 = request.profileId;
              _context4.t2 = resolveCollectModule(request);
              _context4.t3 = resolveReferenceModule(request);
              return _context4.abrupt("return", {
                contentURI: _context4.t0,
                profileId: _context4.t1,
                collectModule: _context4.t2,
                referenceModule: _context4.t3
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function resolveCreatePostRequestArg(_x5) {
        return _resolveCreatePostRequestArg.apply(this, arguments);
      }
      return resolveCreatePostRequestArg;
    }()
  }]);
  return CreatePostCallGateway;
}();

var CreatePostController = /*#__PURE__*/function () {
  function CreatePostController(_ref) {
    var activeWallet = _ref.activeWallet,
      apolloClient = _ref.apolloClient,
      protocolCallRelayer = _ref.protocolCallRelayer,
      transactionFactory = _ref.transactionFactory,
      transactionGateway = _ref.transactionGateway,
      transactionQueue = _ref.transactionQueue,
      uploader = _ref.uploader;
    _classCallCheck(this, CreatePostController);
    _defineProperty(this, "presenter", new PromiseResultPresenter());
    var gateway = new CreatePostCallGateway(apolloClient, transactionFactory, uploader);
    var signedCreatePost = new ProtocolCallUseCase(activeWallet, transactionGateway, gateway, protocolCallRelayer, transactionQueue, this.presenter);
    this.createPost = new CreatePost(signedCreatePost, gateway, transactionQueue, this.presenter);
  }
  _createClass(CreatePostController, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.createPost.execute(request);
            case 2:
              return _context.abrupt("return", this.presenter.asResult());
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute(_x) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
  return CreatePostController;
}();

function toContractType(contractType) {
  switch (contractType) {
    case NftContractType.Erc721:
      return ContractType.Erc721;
    case NftContractType.Erc1155:
      return ContractType.Erc1155;
  }
}
function toScalarOperator(operator) {
  switch (operator) {
    case Erc20ComparisonOperator.GreaterThan:
      return ScalarOperator.GreaterThan;
    case Erc20ComparisonOperator.GreaterThanOrEqual:
      return ScalarOperator.GreaterThanOrEqual;
    case Erc20ComparisonOperator.LessThan:
      return ScalarOperator.LessThan;
    case Erc20ComparisonOperator.LessThanOrEqual:
      return ScalarOperator.LessThanOrEqual;
    case Erc20ComparisonOperator.Equal:
      return ScalarOperator.Equal;
    case Erc20ComparisonOperator.NotEqual:
      return ScalarOperator.NotEqual;
  }
  // fail fast if type checking is bypassed (JS integration or brute-forced TS assertion)
  assertNever(operator, 'Unknown Erc20ComparisonOperator');
}
function or(_x) {
  return _or.apply(this, arguments);
}
function _or() {
  _or = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(criteria) {
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          invariant(criteria.length > 1, "\"".concat(DecryptionCriteriaType.OR, "\" criteria must have at least 2 elements"));
          invariant(criteria.length <= 5, "\"".concat(DecryptionCriteriaType.OR, "\" criteria must have at most 5 elements"));
          _context4.next = 4;
          return Promise.all(criteria);
        case 4:
          _context4.t0 = _context4.sent;
          _context4.t1 = {
            criteria: _context4.t0
          };
          return _context4.abrupt("return", {
            or: _context4.t1
          });
        case 7:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _or.apply(this, arguments);
}
function and(_x2) {
  return _and.apply(this, arguments);
}
function _and() {
  _and = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(criteria) {
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          invariant(criteria.length > 1, "\"".concat(DecryptionCriteriaType.AND, "\" criteria must have at least 2 elements"));
          invariant(criteria.length <= 5, "\"".concat(DecryptionCriteriaType.AND, "\" criteria must have at most 5 elements"));
          _context5.next = 4;
          return Promise.all(criteria);
        case 4:
          _context5.t0 = _context5.sent;
          _context5.t1 = {
            criteria: _context5.t0
          };
          return _context5.abrupt("return", {
            and: _context5.t1
          });
        case 7:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _and.apply(this, arguments);
}
var AccessConditionBuilder = /*#__PURE__*/function () {
  function AccessConditionBuilder(ownerId, chains, publicationIdPredictor) {
    _classCallCheck(this, AccessConditionBuilder);
    this.ownerId = ownerId;
    this.chains = chains;
    this.publicationIdPredictor = publicationIdPredictor;
  }
  _createClass(AccessConditionBuilder, [{
    key: "withDecryptionCriteria",
    value: function withDecryptionCriteria(decryptionCriteria) {
      var _this = this;
      return {
        build: function () {
          var _build = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.transformSimpleCriterion({
                    type: DecryptionCriteriaType.PROFILE_OWNERSHIP,
                    profileId: _this.ownerId
                  });
                case 2:
                  _context.t0 = _context.sent;
                  _context.next = 5;
                  return _this.transformAnyCriterion(decryptionCriteria);
                case 5:
                  _context.t1 = _context.sent;
                  _context.t2 = [_context.t0, _context.t1];
                  _context.t3 = {
                    criteria: _context.t2
                  };
                  return _context.abrupt("return", {
                    or: _context.t3
                  });
                case 9:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function build() {
            return _build.apply(this, arguments);
          }
          return build;
        }()
      };
    }
  }, {
    key: "transformAnyCriterion",
    value: function () {
      var _transformAnyCriterion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(criterion) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = criterion.type;
              _context2.next = _context2.t0 === DecryptionCriteriaType.AND ? 3 : _context2.t0 === DecryptionCriteriaType.OR ? 4 : 5;
              break;
            case 3:
              return _context2.abrupt("return", and(criterion.and.map(function (c) {
                return _this2.transformSimpleCriterion(c);
              })));
            case 4:
              return _context2.abrupt("return", or(criterion.or.map(function (c) {
                return _this2.transformSimpleCriterion(c);
              })));
            case 5:
              return _context2.abrupt("return", this.transformSimpleCriterion(criterion));
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function transformAnyCriterion(_x3) {
        return _transformAnyCriterion.apply(this, arguments);
      }
      return transformAnyCriterion;
    }()
  }, {
    key: "transformSimpleCriterion",
    value: function () {
      var _transformSimpleCriterion = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(criterion) {
        var _criterion$tokenIds;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.t0 = criterion.type;
              _context3.next = _context3.t0 === DecryptionCriteriaType.NFT_OWNERSHIP ? 3 : _context3.t0 === DecryptionCriteriaType.ERC20_OWNERSHIP ? 4 : _context3.t0 === DecryptionCriteriaType.ADDRESS_OWNERSHIP ? 5 : _context3.t0 === DecryptionCriteriaType.PROFILE_OWNERSHIP ? 6 : _context3.t0 === DecryptionCriteriaType.FOLLOW_PROFILE ? 7 : _context3.t0 === DecryptionCriteriaType.COLLECT_PUBLICATION ? 8 : _context3.t0 === DecryptionCriteriaType.COLLECT_THIS_PUBLICATION ? 9 : 14;
              break;
            case 3:
              return _context3.abrupt("return", {
                nft: {
                  chainID: criterion.chainId,
                  contractAddress: criterion.contractAddress,
                  contractType: toContractType(criterion.contractType),
                  tokenIds: (_criterion$tokenIds = criterion.tokenIds) !== null && _criterion$tokenIds !== void 0 ? _criterion$tokenIds : null
                }
              });
            case 4:
              return _context3.abrupt("return", {
                token: {
                  amount: criterion.amount.toBigDecimal().mul(Math.pow(10, criterion.amount.asset.decimals)).toFixed(),
                  chainID: this.chains[criterion.amount.asset.chainType].chainId,
                  contractAddress: criterion.amount.asset.address,
                  decimals: criterion.amount.asset.decimals,
                  condition: toScalarOperator(criterion.condition)
                }
              });
            case 5:
              return _context3.abrupt("return", {
                eoa: {
                  address: criterion.address
                }
              });
            case 6:
              return _context3.abrupt("return", {
                profile: {
                  profileId: criterion.profileId
                }
              });
            case 7:
              return _context3.abrupt("return", {
                follow: {
                  profileId: criterion.profileId
                }
              });
            case 8:
              return _context3.abrupt("return", {
                collect: {
                  publicationId: criterion.publicationId,
                  thisPublication: false
                }
              });
            case 9:
              _context3.next = 11;
              return this.publicationIdPredictor.predictNextPublicationIdFor(this.ownerId);
            case 11:
              _context3.t1 = _context3.sent;
              _context3.t2 = {
                publicationId: _context3.t1,
                thisPublication: true
              };
              return _context3.abrupt("return", {
                collect: _context3.t2
              });
            case 14:
              // fail fast if type checking is bypassed (JS integration or brute-forced TS assertion)
              assertNever(criterion, 'Unknown DecryptionCriteriaType');
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function transformSimpleCriterion(_x4) {
        return _transformSimpleCriterion.apply(this, arguments);
      }
      return transformSimpleCriterion;
    }()
  }]);
  return AccessConditionBuilder;
}();
var AccessConditionBuilderFactory = /*#__PURE__*/function () {
  function AccessConditionBuilderFactory(chains, publicationIdPredictor) {
    _classCallCheck(this, AccessConditionBuilderFactory);
    this.chains = chains;
    this.publicationIdPredictor = publicationIdPredictor;
  }
  _createClass(AccessConditionBuilderFactory, [{
    key: "createForPublicationBy",
    value: function createForPublicationBy(ownerId) {
      return new AccessConditionBuilder(ownerId, this.chains, this.publicationIdPredictor);
    }
  }]);
  return AccessConditionBuilderFactory;
}();

var EncryptedPublicationMetadataUploader = /*#__PURE__*/function () {
  function EncryptedPublicationMetadataUploader(client, accessConditionBuilderFactory, uploader) {
    _classCallCheck(this, EncryptedPublicationMetadataUploader);
    this.client = client;
    this.accessConditionBuilderFactory = accessConditionBuilderFactory;
    this.uploader = uploader;
  }
  _createClass(EncryptedPublicationMetadataUploader, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var accessCondition, metadata, result, encryptedMetadata;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.accessConditionBuilderFactory.createForPublicationBy(request.profileId).withDecryptionCriteria(request.decryptionCriteria).build();
            case 2:
              accessCondition = _context.sent;
              metadata = createPublicationMetadata(request);
              _context.next = 6;
              return this.client.encryptPublication(metadata, accessCondition);
            case 6:
              result = _context.sent;
              encryptedMetadata = result.unwrap();
              return _context.abrupt("return", this.uploader.upload(encryptedMetadata));
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function upload(_x) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }]);
  return EncryptedPublicationMetadataUploader;
}();

var MetadataUploaderErrorMiddleware = /*#__PURE__*/function () {
  function MetadataUploaderErrorMiddleware(handler) {
    _classCallCheck(this, MetadataUploaderErrorMiddleware);
    this.handler = handler;
  }
  _createClass(MetadataUploaderErrorMiddleware, [{
    key: "upload",
    value: function () {
      var _upload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(data) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.handler(data);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              assertError(_context.t0);
              throw new FailedUploadError('Cannot upload metadata', {
                cause: _context.t0
              });
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 6]]);
      }));
      function upload(_x) {
        return _upload.apply(this, arguments);
      }
      return upload;
    }()
  }]);
  return MetadataUploaderErrorMiddleware;
}();

function formatPublicationId(profileId, newSequentialId) {
  return "".concat(profileId, "-0x").concat(newSequentialId.toString(16));
}
var PublicationIdPredictor = /*#__PURE__*/function () {
  function PublicationIdPredictor(apolloClient, pendingTransactionGateway) {
    _classCallCheck(this, PublicationIdPredictor);
    this.apolloClient = apolloClient;
    this.pendingTransactionGateway = pendingTransactionGateway;
  }
  _createClass(PublicationIdPredictor, [{
    key: "predictNextPublicationIdFor",
    value: function () {
      var _predictNextPublicationIdFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(profileId) {
        var _yield$this$apolloCli, data, _id$split$pop, id, onchainId, last;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.query({
                query: PublicationsDocument,
                variables: {
                  profileId: profileId,
                  sources: [],
                  limit: 1
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              if (!hasAtLeastOne(data.result.items)) {
                _context.next = 14;
                break;
              }
              id = data.result.items[0].id;
              onchainId = (_id$split$pop = id.split('-').pop()) !== null && _id$split$pop !== void 0 ? _id$split$pop : never("Publication id is not in the expected \"<profile-id>-<sequential-id>\" format: ".concat(id));
              last = parseInt(onchainId, 16);
              _context.t0 = formatPublicationId;
              _context.t1 = profileId;
              _context.next = 12;
              return this.computeNextSequentialIdFor(last, profileId);
            case 12:
              _context.t2 = _context.sent;
              return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));
            case 14:
              _context.t3 = formatPublicationId;
              _context.t4 = profileId;
              _context.next = 18;
              return this.computeNextSequentialIdFor(0, profileId);
            case 18:
              _context.t5 = _context.sent;
              return _context.abrupt("return", (0, _context.t3)(_context.t4, _context.t5));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function predictNextPublicationIdFor(_x) {
        return _predictNextPublicationIdFor.apply(this, arguments);
      }
      return predictNextPublicationIdFor;
    }()
  }, {
    key: "computeNextSequentialIdFor",
    value: function () {
      var _computeNextSequentialIdFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(baseline, profileId) {
        var pendingPublicationTransactions;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.countPendingPublicationTransactionsFor(profileId);
            case 2:
              pendingPublicationTransactions = _context2.sent;
              return _context2.abrupt("return", baseline + pendingPublicationTransactions + 1);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function computeNextSequentialIdFor(_x2, _x3) {
        return _computeNextSequentialIdFor.apply(this, arguments);
      }
      return computeNextSequentialIdFor;
    }()
  }, {
    key: "countPendingPublicationTransactionsFor",
    value: function () {
      var _countPendingPublicationTransactionsFor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(profileId) {
        var allPendingTransactions, pendingPublicationTransactions;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.pendingTransactionGateway.getAll();
            case 2:
              allPendingTransactions = _context3.sent;
              pendingPublicationTransactions = allPendingTransactions.filter(function (transaction) {
                switch (transaction.request.kind) {
                  case TransactionKind.CREATE_COMMENT:
                  case TransactionKind.CREATE_POST:
                  case TransactionKind.MIRROR_PUBLICATION:
                    return transaction.request.profileId === profileId;
                }
                return false;
              });
              return _context3.abrupt("return", pendingPublicationTransactions.length);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function countPendingPublicationTransactionsFor(_x4) {
        return _countPendingPublicationTransactionsFor.apply(this, arguments);
      }
      return countPendingPublicationTransactionsFor;
    }()
  }]);
  return PublicationIdPredictor;
}();

var _excluded$2 = ["collect", "reference"];
function useCreateEncryptedPost(_ref) {
  var encryption = _ref.encryption,
    publisher = _ref.publisher,
    upload = _ref.upload;
  var _useSharedDependencie = useSharedDependencies(),
    appId = _useSharedDependencie.appId,
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue,
    environment = _useSharedDependencie.environment,
    storageProvider = _useSharedDependencie.storageProvider;
  var _useActiveWalletSigne = useActiveWalletSigner(),
    signer = _useActiveWalletSigne.data;
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref2$collect, collect, _ref2$reference, reference, args, client, publicationIdPredictor, accessConditionBuilderFactory, uploader, controller;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$collect = _ref2.collect, collect = _ref2$collect === void 0 ? {
              type: CollectPolicyType.NO_COLLECT
            } : _ref2$collect, _ref2$reference = _ref2.reference, reference = _ref2$reference === void 0 ? {
              type: ReferencePolicyType.ANYONE
            } : _ref2$reference, args = _objectWithoutProperties(_ref2, _excluded$2);
            invariant(signer, "Cannot find the Active Wallet Signer, did you login with ".concat(useWalletLogin.name, "?"));
            client = createGatedClient({
              config: encryption.authentication,
              signer: signer,
              encryptionProvider: encryption.provider,
              environment: environment,
              storageProvider: storageProvider
            });
            publicationIdPredictor = new PublicationIdPredictor(apolloClient, transactionGateway);
            accessConditionBuilderFactory = new AccessConditionBuilderFactory(environment.chains, publicationIdPredictor);
            uploader = new EncryptedPublicationMetadataUploader(client, accessConditionBuilderFactory, new MetadataUploaderErrorMiddleware(upload));
            controller = new CreatePostController({
              activeWallet: activeWallet,
              apolloClient: apolloClient,
              protocolCallRelayer: protocolCallRelayer,
              transactionFactory: transactionFactory,
              transactionGateway: transactionGateway,
              transactionQueue: transactionQueue,
              uploader: uploader
            });
            _context.prev = 7;
            _context.next = 10;
            return controller.execute(_objectSpread2({
              kind: TransactionKind.CREATE_POST,
              collect: collect,
              delegate: publisher.dispatcher !== null,
              profileId: publisher.id,
              reference: reference,
              appId: appId
            }, args));
          case 10:
            return _context.abrupt("return", _context.sent);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](7);
            if (!(_context.t0 instanceof FailedUploadError)) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 17:
            throw _context.t0;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 13]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

var _excluded$1 = ["collect", "reference"];
function useCreateEncryptedComment(_ref) {
  var encryption = _ref.encryption,
    publisher = _ref.publisher,
    upload = _ref.upload;
  var _useSharedDependencie = useSharedDependencies(),
    appId = _useSharedDependencie.appId,
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue,
    environment = _useSharedDependencie.environment,
    storageProvider = _useSharedDependencie.storageProvider;
  var _useActiveWalletSigne = useActiveWalletSigner(),
    signer = _useActiveWalletSigne.data;
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref2$collect, collect, _ref2$reference, reference, args, client, publicationIdPredictor, accessConditionBuilderFactory, uploader, controller;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$collect = _ref2.collect, collect = _ref2$collect === void 0 ? {
              type: CollectPolicyType.NO_COLLECT
            } : _ref2$collect, _ref2$reference = _ref2.reference, reference = _ref2$reference === void 0 ? {
              type: ReferencePolicyType.ANYONE
            } : _ref2$reference, args = _objectWithoutProperties(_ref2, _excluded$1);
            invariant(signer, "Cannot find the Active Wallet Signer, did you login with ".concat(useWalletLogin.name, "?"));
            client = createGatedClient({
              config: encryption.authentication,
              signer: signer,
              encryptionProvider: encryption.provider,
              environment: environment,
              storageProvider: storageProvider
            });
            publicationIdPredictor = new PublicationIdPredictor(apolloClient, transactionGateway);
            accessConditionBuilderFactory = new AccessConditionBuilderFactory(environment.chains, publicationIdPredictor);
            uploader = new EncryptedPublicationMetadataUploader(client, accessConditionBuilderFactory, new MetadataUploaderErrorMiddleware(upload));
            controller = new CreateCommentController({
              activeWallet: activeWallet,
              apolloClient: apolloClient,
              protocolCallRelayer: protocolCallRelayer,
              transactionFactory: transactionFactory,
              transactionGateway: transactionGateway,
              transactionQueue: transactionQueue,
              uploader: uploader
            });
            _context.prev = 7;
            _context.next = 10;
            return controller.execute(_objectSpread2({
              kind: TransactionKind.CREATE_COMMENT,
              collect: collect,
              delegate: publisher.dispatcher !== null,
              profileId: publisher.id,
              reference: reference,
              appId: appId
            }, args));
          case 10:
            return _context.abrupt("return", _context.sent);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](7);
            if (!(_context.t0 instanceof FailedUploadError)) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 17:
            throw _context.t0;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[7, 13]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

var CreateMirrorCallGateway = /*#__PURE__*/function () {
  function CreateMirrorCallGateway(apolloClient, transactionFactory) {
    _classCallCheck(this, CreateMirrorCallGateway);
    this.apolloClient = apolloClient;
    this.transactionFactory = transactionFactory;
  }
  _createClass(CreateMirrorCallGateway, [{
    key: "createDelegatedTransaction",
    value: function () {
      var _createDelegatedTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.transactionFactory;
              _context.t1 = ChainType.POLYGON;
              _context.t2 = v4();
              _context.t3 = request;
              _context.t4 = this;
              _context.next = 7;
              return this.resolveCreateMirrorRequestArg(request);
            case 7:
              _context.t5 = _context.sent;
              _context.t6 = _context.t4.initiateMirrorCreation.call(_context.t4, _context.t5);
              _context.t7 = {
                chainType: _context.t1,
                id: _context.t2,
                request: _context.t3,
                asyncRelayReceipt: _context.t6
              };
              return _context.abrupt("return", _context.t0.createNativeTransaction.call(_context.t0, _context.t7));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createDelegatedTransaction(_x) {
        return _createDelegatedTransaction.apply(this, arguments);
      }
      return createDelegatedTransaction;
    }()
  }, {
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this.apolloClient;
              _context2.t1 = CreateMirrorTypedDataDocument;
              _context2.next = 4;
              return this.resolveCreateMirrorRequestArg(request);
            case 4:
              _context2.t2 = _context2.sent;
              _context2.t3 = nonce ? {
                overrideSigNonce: nonce
              } : undefined;
              _context2.t4 = {
                request: _context2.t2,
                options: _context2.t3
              };
              _context2.t5 = {
                mutation: _context2.t1,
                variables: _context2.t4
              };
              _context2.next = 10;
              return _context2.t0.mutate.call(_context2.t0, _context2.t5);
            case 10:
              _yield$this$apolloCli = _context2.sent;
              data = _yield$this$apolloCli.data;
              return _context2.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUnsignedProtocolCall(_x2, _x3) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }, {
    key: "initiateMirrorCreation",
    value: function () {
      var _initiateMirrorCreation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(requestArgs) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateMirrorViaDispatcherDocument,
                variables: {
                  request: requestArgs
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context3.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context3.next = 6;
                break;
              }
              return _context3.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 6:
              return _context3.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initiateMirrorCreation(_x4) {
        return _initiateMirrorCreation.apply(this, arguments);
      }
      return initiateMirrorCreation;
    }()
  }, {
    key: "resolveCreateMirrorRequestArg",
    value: function () {
      var _resolveCreateMirrorRequestArg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(request) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", {
                profileId: request.profileId,
                publicationId: request.publicationId
              });
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function resolveCreateMirrorRequestArg(_x5) {
        return _resolveCreateMirrorRequestArg.apply(this, arguments);
      }
      return resolveCreateMirrorRequestArg;
    }()
  }]);
  return CreateMirrorCallGateway;
}();

function useCreateMirrorController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, mirrorCallGateway, signedCreatePost, createMirror;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            mirrorCallGateway = new CreateMirrorCallGateway(apolloClient, transactionFactory);
            signedCreatePost = new ProtocolCallUseCase(activeWallet, transactionGateway, mirrorCallGateway, protocolCallRelayer, transactionQueue, presenter);
            createMirror = new CreateMirror(signedCreatePost, mirrorCallGateway, transactionQueue, presenter);
            _context.next = 6;
            return createMirror.execute(request);
          case 6:
            return _context.abrupt("return", presenter.asResult());
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useCreateMirror(_ref) {
  var publisher = _ref.publisher;
  var createMirror = useCreateMirrorController();
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var publication;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            publication = _ref2.publication;
            return _context.abrupt("return", createMirror({
              kind: TransactionKind.MIRROR_PUBLICATION,
              publicationId: publication.id,
              profileId: publisher.id,
              delegate: publisher.dispatcher !== null
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

var _excluded = ["collect", "reference"];
function useCreatePost(_ref) {
  var publisher = _ref.publisher,
    upload = _ref.upload;
  var _useSharedDependencie = useSharedDependencies(),
    appId = _useSharedDependencie.appId,
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var _ref2$collect, collect, _ref2$reference, reference, args, uploader, controller;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _ref2$collect = _ref2.collect, collect = _ref2$collect === void 0 ? {
              type: CollectPolicyType.NO_COLLECT
            } : _ref2$collect, _ref2$reference = _ref2.reference, reference = _ref2$reference === void 0 ? {
              type: ReferencePolicyType.ANYONE
            } : _ref2$reference, args = _objectWithoutProperties(_ref2, _excluded);
            uploader = new PublicationMetadataUploader(upload);
            controller = new CreatePostController({
              activeWallet: activeWallet,
              apolloClient: apolloClient,
              protocolCallRelayer: protocolCallRelayer,
              transactionFactory: transactionFactory,
              transactionGateway: transactionGateway,
              transactionQueue: transactionQueue,
              uploader: uploader
            });
            _context.prev = 3;
            _context.next = 6;
            return controller.execute(_objectSpread2({
              kind: TransactionKind.CREATE_POST,
              collect: collect,
              delegate: publisher.dispatcher !== null,
              profileId: publisher.id,
              reference: reference,
              appId: appId
            }, args));
          case 6:
            return _context.abrupt("return", _context.sent);
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            if (!(_context.t0 instanceof FailedUploadError)) {
              _context.next = 13;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 13:
            throw _context.t0;
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

function resolveProfileFollow(request) {
  if (isPaidFollowRequest(request)) {
    return [{
      profile: request.profileId,
      followModule: {
        feeFollowModule: {
          amount: moduleFeeAmountParams({
            from: request.fee.amount
          })
        }
      }
    }];
  }
  if (isProfileOwnerFollowRequest(request)) {
    return [{
      profile: request.profileId,
      followModule: {
        profileFollowModule: {
          profileId: request.followerProfileId
        }
      }
    }];
  }
  return [{
    profile: request.profileId
  }];
}
var FollowProfilesCallGateway = /*#__PURE__*/function () {
  function FollowProfilesCallGateway(apolloClient) {
    _classCallCheck(this, FollowProfilesCallGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(FollowProfilesCallGateway, [{
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateFollowTypedDataDocument,
                variables: {
                  request: {
                    follow: resolveProfileFollow(request)
                  },
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              return _context.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createUnsignedProtocolCall(_x, _x2) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }]);
  return FollowProfilesCallGateway;
}();

var FollowProxyActionRelayer = /*#__PURE__*/function () {
  function FollowProxyActionRelayer(apolloClient, factory, logger) {
    _classCallCheck(this, FollowProxyActionRelayer);
    this.apolloClient = apolloClient;
    this.factory = factory;
    this.logger = logger;
  }
  _createClass(FollowProxyActionRelayer, [{
    key: "relaySignlessProtocolCall",
    value: function () {
      var _relaySignlessProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var relayProxyReceipt;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.broadcast(request);
            case 2:
              relayProxyReceipt = _context.sent;
              return _context.abrupt("return", this.factory.createProxyTransaction({
                chainType: ChainType.POLYGON,
                id: getID(),
                request: request,
                proxyId: relayProxyReceipt.proxyId
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function relaySignlessProtocolCall(_x) {
        return _relaySignlessProtocolCall.apply(this, arguments);
      }
      return relaySignlessProtocolCall;
    }()
  }, {
    key: "broadcast",
    value: function () {
      var _broadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.executeBroadcast({
                follow: {
                  freeFollow: {
                    profileId: request.profileId
                  }
                }
              });
            case 3:
              return _context2.abrupt("return", _context2.sent);
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              this.logger.error(_context2.t0, 'It was not possible to relay the transaction');
              throw new TransactionError(TransactionErrorReason.CANNOT_EXECUTE);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function broadcast(_x2) {
        return _broadcast.apply(this, arguments);
      }
      return broadcast;
    }()
  }, {
    key: "executeBroadcast",
    value: function () {
      var _executeBroadcast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(request) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: ProxyActionDocument,
                variables: {
                  request: request
                }
              });
            case 2:
              _yield$this$apolloCli = _context3.sent;
              data = _yield$this$apolloCli.data;
              return _context3.abrupt("return", {
                proxyId: data.result
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function executeBroadcast(_x3) {
        return _executeBroadcast.apply(this, arguments);
      }
      return executeBroadcast;
    }()
  }]);
  return FollowProxyActionRelayer;
}();

function useFollowController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    logger = _useSharedDependencie.logger,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    tokenAvailability = _useSharedDependencie.tokenAvailability,
    transactionFactory = _useSharedDependencie.transactionFactory,
    transactionGateway = _useSharedDependencie.transactionGateway,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, followProfilesCallGateway, signedFollow, followProxyActionRelayer, signlessFollow, followProfiles;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            followProfilesCallGateway = new FollowProfilesCallGateway(apolloClient);
            signedFollow = new ProtocolCallUseCase(activeWallet, transactionGateway, followProfilesCallGateway, protocolCallRelayer, transactionQueue, presenter);
            followProxyActionRelayer = new FollowProxyActionRelayer(apolloClient, transactionFactory, logger);
            signlessFollow = new SignlessProtocolCallUseCase(followProxyActionRelayer, transactionQueue, presenter);
            followProfiles = new FollowProfiles(tokenAvailability, signedFollow, signlessFollow, presenter);
            void followProfiles.execute(request);
            return _context.abrupt("return", presenter.asResult());
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

var PrematureFollowError = /*#__PURE__*/function (_Error) {
  _inherits(PrematureFollowError, _Error);
  var _super = _createSuper(PrematureFollowError);
  function PrematureFollowError() {
    var _this;
    _classCallCheck(this, PrematureFollowError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'PrematureFollowError');
    return _this;
  }
  return _createClass(PrematureFollowError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function createFollowRequest(followee, follower) {
  var followPolicy = followee.followPolicy;
  switch (followPolicy.type) {
    case FollowPolicyType.CHARGE:
      return {
        fee: {
          amount: followPolicy.amount,
          contractAddress: followPolicy.contractAddress,
          recipient: followPolicy.recipient
        },
        kind: TransactionKind.FOLLOW_PROFILES,
        profileId: followee.id,
        followerAddress: follower.ownedBy
      };
    case FollowPolicyType.ONLY_PROFILE_OWNERS:
      return {
        kind: TransactionKind.FOLLOW_PROFILES,
        profileId: followee.id,
        followerAddress: follower.ownedBy,
        followerProfileId: follower.id
      };
    case FollowPolicyType.ANYONE:
      return {
        kind: TransactionKind.FOLLOW_PROFILES,
        profileId: followee.id,
        followerAddress: follower.ownedBy
      };
    case FollowPolicyType.NO_ONE:
      throw new InvariantError("The profile is configured so that nobody can follow it. Check 'profile.followPolicy.type' beforehand.");
    case FollowPolicyType.UNKNOWN:
      throw new InvariantError("The profile is configured with an unknown follow module. Check 'profile.followPolicy.type' beforehand.");
  }
}
function useFollow(_ref) {
  var followee = _ref.followee,
    follower = _ref.follower;
  var follow = useFollowController();
  var hasPendingUnfollowTx = useHasPendingTransaction(isUnfollowTransactionFor({
    profileId: followee.id
  }));
  return useOperation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var request;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!hasPendingUnfollowTx) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", failure(new PrematureFollowError("Your unfollow request for ".concat(followee.handle, " is still pending."))));
        case 2:
          request = createFollowRequest(followee, follower);
          return _context.abrupt("return", follow(request));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}

function useRecentPosts() {
  return useReactiveVar(recentPosts);
}

function useRecentTransactions() {
  var _useSharedDependencie = useSharedDependencies(),
    transactionQueue = _useSharedDependencie.transactionQueue;
  var transactions = useRecentTransactionsVar();
  return {
    clearCompleted: function clearCompleted() {
      transactionQueue.clearRecent();
    },
    transactions: transactions
  };
}

var UnsignedUnfollowCall = /*#__PURE__*/function (_UnsignedLensProtocol) {
  _inherits(UnsignedUnfollowCall, _UnsignedLensProtocol);
  var _super = _createSuper(UnsignedUnfollowCall);
  function UnsignedUnfollowCall(data) {
    _classCallCheck(this, UnsignedUnfollowCall);
    return _super.call(this, data.id, data.request, data.typedData);
  }
  return _createClass(UnsignedUnfollowCall);
}(UnsignedLensProtocolCall);
var UnfollowProfileCallGateway = /*#__PURE__*/function () {
  function UnfollowProfileCallGateway(apolloClient) {
    _classCallCheck(this, UnfollowProfileCallGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(UnfollowProfileCallGateway, [{
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateUnfollowTypedDataDocument,
                variables: {
                  request: {
                    profile: request.profileId
                  }
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              return _context.abrupt("return", new UnsignedUnfollowCall({
                id: data.result.id,
                request: request,
                typedData: omitTypename(data.result.typedData)
              }));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createUnsignedProtocolCall(_x) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }]);
  return UnfollowProfileCallGateway;
}();

function useUnfollowController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    transactionGateway = _useSharedDependencie.transactionGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, unfollowProfileCallGateway, unfollowProfiles;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            unfollowProfileCallGateway = new UnfollowProfileCallGateway(apolloClient);
            unfollowProfiles = new UnfollowProfile(activeWallet, transactionGateway, unfollowProfileCallGateway, protocolCallRelayer, transactionQueue, presenter);
            _context.next = 5;
            return unfollowProfiles.execute(request);
          case 5:
            return _context.abrupt("return", presenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

var PrematureUnfollowError = /*#__PURE__*/function (_Error) {
  _inherits(PrematureUnfollowError, _Error);
  var _super = _createSuper(PrematureUnfollowError);
  function PrematureUnfollowError() {
    var _this;
    _classCallCheck(this, PrematureUnfollowError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'PrematureUnfollowError');
    return _this;
  }
  return _createClass(PrematureUnfollowError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
function useUnfollow(_ref) {
  var followee = _ref.followee,
    follower = _ref.follower;
  var unfollow = useUnfollowController();
  var hasPendingFollowTx = useHasPendingTransaction(isFollowTransactionFor({
    profileId: followee.id,
    followerAddress: follower.ownedBy
  }));
  return useOperation( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!hasPendingFollowTx) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", failure(new PrematureUnfollowError("Your follow request for ".concat(followee.handle, " is still pending."))));
        case 2:
          return _context.abrupt("return", unfollow({
            kind: TransactionKind.UNFOLLOW_PROFILE,
            profileId: followee.id
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
}

var DispatcherConfigCallGateway = /*#__PURE__*/function () {
  function DispatcherConfigCallGateway(apolloClient) {
    _classCallCheck(this, DispatcherConfigCallGateway);
    this.apolloClient = apolloClient;
  }
  _createClass(DispatcherConfigCallGateway, [{
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetDispatcherTypedDataDocument,
                variables: {
                  request: {
                    profileId: request.profileId,
                    enable: request.enabled
                  },
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context.sent;
              data = _yield$this$apolloCli.data;
              return _context.abrupt("return", new UnsignedLensProtocolCall(data.result.id, request, omitTypename(data.result.typedData)));
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createUnsignedProtocolCall(_x, _x2) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }]);
  return DispatcherConfigCallGateway;
}();

function useUpdateDispatcherConfigController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    transactionGateway = _useSharedDependencie.transactionGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue,
    apolloClient = _useSharedDependencie.apolloClient;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var presenter, gateway, updateDispatcherConfig;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            gateway = new DispatcherConfigCallGateway(apolloClient);
            updateDispatcherConfig = new UpdateDispatcherConfig(activeWallet, transactionGateway, gateway, protocolCallRelayer, transactionQueue, presenter);
            _context.next = 5;
            return updateDispatcherConfig.execute(_objectSpread2(_objectSpread2({}, request), {}, {
              kind: TransactionKind.UPDATE_DISPATCHER_CONFIG
            }));
          case 5:
            return _context.abrupt("return", presenter.asResult());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useUpdateDispatcherConfig(_ref) {
  var profile = _ref.profile;
  // note: this is one of the hooks for which we need to wait for the corresponding tx to be mined
  // as it's affecting the way we would handle all tx after this one is done.
  var hasPendingUpdateTransaction = useHasPendingTransaction(function (tx) {
    return tx.request.kind === TransactionKind.UPDATE_DISPATCHER_CONFIG && tx.request.profileId === profile.id;
  });
  var update = useUpdateDispatcherConfigController();
  var _useOperation = useOperation( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var enabled;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              enabled = _ref2.enabled;
              return _context.abrupt("return", update({
                enabled: enabled,
                profileId: profile.id
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }()),
    execute = _useOperation.execute,
    error = _useOperation.error,
    isPending = _useOperation.isPending;
  return {
    execute: execute,
    error: error,
    isPending: isPending || hasPendingUpdateTransaction
  };
}

function useUpdateFollowPolicyController() {
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    transactionGateway = _useSharedDependencie.transactionGateway,
    followPolicyCallGateway = _useSharedDependencie.followPolicyCallGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(args) {
      var presenter, updateFollowPolicy;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            presenter = new PromiseResultPresenter();
            updateFollowPolicy = new UpdateFollowPolicy(activeWallet, transactionGateway, followPolicyCallGateway, protocolCallRelayer, transactionQueue, presenter);
            _context.next = 4;
            return updateFollowPolicy.execute(args);
          case 4:
            return _context.abrupt("return", presenter.asResult());
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function useUpdateFollowPolicy(_ref) {
  var profile = _ref.profile;
  var updateFollowPolicy = useUpdateFollowPolicyController();
  return useOperation( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var followPolicy;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            followPolicy = _ref2.followPolicy;
            return _context.abrupt("return", updateFollowPolicy({
              profileId: profile.id,
              policy: followPolicy,
              kind: TransactionKind.UPDATE_FOLLOW_POLICY
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }());
}

function newAttribute(key, value) {
  if (value instanceof Date) {
    return {
      key: key,
      value: value.toISOString(),
      displayType: 'date'
    };
  }
  return {
    key: key,
    value: value.toString(),
    displayType: _typeof(value)
  };
}
function extractCoverImageUrl(existingProfile) {
  var _existingProfile$cove;
  return ((_existingProfile$cove = existingProfile.coverPicture) === null || _existingProfile$cove === void 0 ? void 0 : _existingProfile$cove.__typename) === 'MediaSet' ? existingProfile.coverPicture.original.url : null;
}
function coalesce(lhs, rhs) {
  return lhs !== undefined ? lhs : rhs;
}
function isProfileAttributeValue(value) {
  return value !== null;
}
function resolveAttributes(attributes) {
  var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var remainder = _objectSpread2({}, update);
  var updated = attributes.reduce(function (acc, attribute) {
    var value = update[attribute.key];
    if (value === undefined) {
      acc.push(attribute);
      return acc;
    }
    delete remainder[attribute.key];
    if (value !== null) {
      acc.push(newAttribute(attribute.key, value));
    }
    return acc;
  }, []);
  return [].concat(_toConsumableArray(updated), _toConsumableArray(Object.entries(remainder).filter(function (entry) {
    return isProfileAttributeValue(entry[1]);
  }).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return newAttribute(key, value);
  })));
}
function createProfileMetadata(existingProfile, request) {
  var _existingProfile$__at;
  return {
    version: '1.0.0',
    metadata_id: v4(),
    attributes: resolveAttributes((_existingProfile$__at = existingProfile.__attributes) !== null && _existingProfile$__at !== void 0 ? _existingProfile$__at : [], request.attributes),
    bio: coalesce(request.bio, existingProfile.bio),
    cover_picture: coalesce(request.coverPicture, extractCoverImageUrl(existingProfile)),
    name: request.name
  };
}

var ProfileMetadataCallGateway = /*#__PURE__*/function () {
  function ProfileMetadataCallGateway(apolloClient, transactionFactory, uploader) {
    _classCallCheck(this, ProfileMetadataCallGateway);
    this.apolloClient = apolloClient;
    this.transactionFactory = transactionFactory;
    this.uploader = uploader;
  }
  _createClass(ProfileMetadataCallGateway, [{
    key: "createDelegatedTransaction",
    value: function () {
      var _createDelegatedTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = this.transactionFactory;
              _context.t1 = ChainType.POLYGON;
              _context.t2 = v4();
              _context.t3 = request;
              _context.t4 = this;
              _context.next = 7;
              return this.resolveCreateSetProfileMetadataUriRequest(request);
            case 7:
              _context.t5 = _context.sent;
              _context.t6 = _context.t4.initiateProfileUpdate.call(_context.t4, _context.t5);
              _context.t7 = {
                chainType: _context.t1,
                id: _context.t2,
                request: _context.t3,
                asyncRelayReceipt: _context.t6
              };
              return _context.abrupt("return", _context.t0.createNativeTransaction.call(_context.t0, _context.t7));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createDelegatedTransaction(_x) {
        return _createDelegatedTransaction.apply(this, arguments);
      }
      return createDelegatedTransaction;
    }()
  }, {
    key: "createUnsignedProtocolCall",
    value: function () {
      var _createUnsignedProtocolCall = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(request, nonce) {
        var result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = this;
              _context2.next = 3;
              return this.resolveCreateSetProfileMetadataUriRequest(request);
            case 3:
              _context2.t1 = _context2.sent;
              _context2.t2 = nonce;
              _context2.next = 7;
              return _context2.t0.createSetProfileMetadataTypedData.call(_context2.t0, _context2.t1, _context2.t2);
            case 7:
              result = _context2.sent;
              return _context2.abrupt("return", new UnsignedLensProtocolCall(result.id, request, omitTypename(result.typedData)));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createUnsignedProtocolCall(_x2, _x3) {
        return _createUnsignedProtocolCall.apply(this, arguments);
      }
      return createUnsignedProtocolCall;
    }()
  }, {
    key: "createSetProfileMetadataTypedData",
    value: function () {
      var _createSetProfileMetadataTypedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(request, nonce) {
        var _yield$this$apolloCli, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetProfileMetadataTypedDataDocument,
                variables: {
                  request: request,
                  options: nonce ? {
                    overrideSigNonce: nonce
                  } : undefined
                }
              });
            case 2:
              _yield$this$apolloCli = _context3.sent;
              data = _yield$this$apolloCli.data;
              return _context3.abrupt("return", data.result);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function createSetProfileMetadataTypedData(_x4, _x5) {
        return _createSetProfileMetadataTypedData.apply(this, arguments);
      }
      return createSetProfileMetadataTypedData;
    }()
  }, {
    key: "initiateProfileUpdate",
    value: function () {
      var _initiateProfileUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(request) {
        var _yield$this$apolloCli2, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.apolloClient.mutate({
                mutation: CreateSetProfileMetadataViaDispatcherDocument,
                variables: {
                  request: request
                }
              });
            case 2:
              _yield$this$apolloCli2 = _context4.sent;
              data = _yield$this$apolloCli2.data;
              if (!(data.result.__typename === 'RelayError')) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return", failure(new TransactionError(TransactionErrorReason.REJECTED)));
            case 6:
              return _context4.abrupt("return", success({
                indexingId: data.result.txId,
                txHash: data.result.txHash
              }));
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function initiateProfileUpdate(_x6) {
        return _initiateProfileUpdate.apply(this, arguments);
      }
      return initiateProfileUpdate;
    }()
  }, {
    key: "resolveCreateSetProfileMetadataUriRequest",
    value: function () {
      var _resolveCreateSetProfileMetadataUriRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(request) {
        var existingProfile, metadataURI;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.retrieveProfileDetails(request.profileId);
            case 2:
              existingProfile = _context5.sent;
              _context5.next = 5;
              return this.uploader.upload(createProfileMetadata(existingProfile, request));
            case 5:
              metadataURI = _context5.sent;
              return _context5.abrupt("return", {
                profileId: request.profileId,
                metadata: metadataURI
              });
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function resolveCreateSetProfileMetadataUriRequest(_x7) {
        return _resolveCreateSetProfileMetadataUriRequest.apply(this, arguments);
      }
      return resolveCreateSetProfileMetadataUriRequest;
    }()
  }, {
    key: "retrieveProfileDetails",
    value: function () {
      var _retrieveProfileDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(profileId) {
        var _data$result;
        var _yield$this$apolloCli3, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.apolloClient.query({
                fetchPolicy: 'cache-first',
                query: GetProfileDocument,
                variables: {
                  // 'sources' and 'observerId' is not need as profile metadata is independent from observer profile and sources
                  request: {
                    profileId: profileId
                  }
                }
              });
            case 2:
              _yield$this$apolloCli3 = _context6.sent;
              data = _yield$this$apolloCli3.data;
              return _context6.abrupt("return", (_data$result = data.result) !== null && _data$result !== void 0 ? _data$result : never("Cannot update profile \"".concat(profileId, ": profile not found")));
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function retrieveProfileDetails(_x8) {
        return _retrieveProfileDetails.apply(this, arguments);
      }
      return retrieveProfileDetails;
    }()
  }]);
  return ProfileMetadataCallGateway;
}();

function useUpdateProfileDetailsController(_ref) {
  var upload = _ref.upload;
  var _useSharedDependencie = useSharedDependencies(),
    activeWallet = _useSharedDependencie.activeWallet,
    apolloClient = _useSharedDependencie.apolloClient,
    transactionGateway = _useSharedDependencie.transactionGateway,
    protocolCallRelayer = _useSharedDependencie.protocolCallRelayer,
    transactionQueue = _useSharedDependencie.transactionQueue,
    transactionFactory = _useSharedDependencie.transactionFactory;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(request) {
      var uploader, gateway, presenter, signedUpdateProfiles, updateProfileDetails;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            uploader = new MetadataUploaderErrorMiddleware(upload);
            gateway = new ProfileMetadataCallGateway(apolloClient, transactionFactory, uploader);
            presenter = new PromiseResultPresenter();
            signedUpdateProfiles = new ProtocolCallUseCase(activeWallet, transactionGateway, gateway, protocolCallRelayer, transactionQueue, presenter);
            updateProfileDetails = new UpdateProfileDetails(signedUpdateProfiles, gateway, transactionQueue, presenter);
            _context.next = 7;
            return updateProfileDetails.execute(request);
          case 7:
            return _context.abrupt("return", presenter.asResult());
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function useUpdateProfileDetails(_ref) {
  var profile = _ref.profile,
    upload = _ref.upload;
  var update = useUpdateProfileDetailsController({
    upload: upload
  });
  return useOperation( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(details) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return update(_objectSpread2({
              kind: TransactionKind.UPDATE_PROFILE_DETAILS,
              delegate: profile.dispatcher !== null,
              profileId: profile.id
            }, details));
          case 3:
            return _context.abrupt("return", _context.sent);
          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            if (!(_context.t0 instanceof FailedUploadError)) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", failure(_context.t0));
          case 10:
            throw _context.t0;
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 6]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

function useUnreadNotificationCount(_ref) {
  var profileId = _ref.profileId;
  var _useSharedDependencie = useSharedDependencies(),
    notificationStorage = _useSharedDependencie.notificationStorage;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    unreadNotificationCount = _useState2[0],
    setUnreadNotificationCount = _useState2[1];
  var _useUnreadNotificatio = useUnreadNotificationCountQuery(useLensApolloClient({
      variables: {
        profileId: profileId
      },
      // no cache is required to always have up-to-date information
      // and to not affect notifications cache
      fetchPolicy: 'no-cache'
    })),
    loading = _useUnreadNotificatio.loading,
    data = _useUnreadNotificatio.data;
  useEffect(function () {
    function calculate() {
      return _calculate.apply(this, arguments);
    }
    function _calculate() {
      _calculate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$notificationSt;
        var readTotalCount, currentTotalCount;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!loading) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              invariant(data === null || data === void 0 ? void 0 : data.result.pageInfo.totalCount, 'Expected total notification count to be defined');
              _context.next = 5;
              return notificationStorage.get();
            case 5:
              _context.t1 = _yield$notificationSt = _context.sent;
              _context.t0 = _context.t1 === null;
              if (_context.t0) {
                _context.next = 9;
                break;
              }
              _context.t0 = _yield$notificationSt === void 0;
            case 9:
              if (!_context.t0) {
                _context.next = 13;
                break;
              }
              _context.t2 = void 0;
              _context.next = 14;
              break;
            case 13:
              _context.t2 = _yield$notificationSt.totalReadNotificationsCount;
            case 14:
              readTotalCount = _context.t2;
              if (!readTotalCount) {
                _context.next = 20;
                break;
              }
              currentTotalCount = data.result.pageInfo.totalCount;
              setUnreadNotificationCount(currentTotalCount - readTotalCount);
              _context.next = 23;
              break;
            case 20:
              _context.next = 22;
              return notificationStorage.set({
                totalReadNotificationsCount: data.result.pageInfo.totalCount
              });
            case 22:
              setUnreadNotificationCount(0);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _calculate.apply(this, arguments);
    }
    void calculate();
  }, [data, loading, notificationStorage]);
  if (loading) {
    return {
      loading: true
    };
  }
  if (unreadNotificationCount === 0) {
    return {
      loading: false,
      unreadNotificationCount: unreadNotificationCount,
      clear: function clear() {
        return Promise.resolve();
      }
    };
  }
  return {
    loading: false,
    unreadNotificationCount: unreadNotificationCount,
    clear: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              invariant(data === null || data === void 0 ? void 0 : data.result.pageInfo.totalCount, 'Expected total notification count to be defined');
              _context2.next = 3;
              return notificationStorage.set({
                totalReadNotificationsCount: data.result.pageInfo.totalCount
              });
            case 3:
              setUnreadNotificationCount(0);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function clear() {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
  };
}

function useNotifications(_ref) {
  var notificationTypes = _ref.notificationTypes,
    profileId = _ref.profileId,
    limit = _ref.limit;
  return usePaginatedReadResult(useNotificationsQuery(useLensApolloClient({
    variables: useSourcesFromConfig({
      observerId: profileId,
      limit: limit !== null && limit !== void 0 ? limit : 10,
      notificationTypes: notificationTypes
    })
  })));
}

function useApolloClient() {
  var _useSharedDependencie = useSharedDependencies(),
    apolloClient = _useSharedDependencie.apolloClient;
  return apolloClient;
}

export { DEFAULT_PAGINATED_QUERY_LIMIT, DecryptionError, FailedUploadError, FeedEventItemType, LensProvider, PrematureFollowError, PrematureUnfollowError, appId, createPublicationMetadataFilters, production, sources, staging, useActiveProfile, useActiveProfileSwitch, useActiveWallet, useActiveWalletSigner, useApolloClient, useApproveModule, useCollect, useCollectedPublications, useComments, useCreateComment, useCreateEncryptedComment, useCreateEncryptedPost, useCreateMirror, useCreatePost, useCreateProfile, useCurrencies, useEnabledModules, useEncryptedPublication, useExploreProfiles, useExplorePublications, useFeed, useFollow, useHidePublication, useMutualFollowers, useNotifications, useProfile, useProfileFollowRevenue, useProfileFollowers, useProfileFollowing, useProfilePublicationRevenue, useProfilePublicationsForSale, useProfilesOwnedBy, useProfilesOwnedByMe, useProfilesToFollow, usePublication, usePublicationRevenue, usePublications, useReaction, useRecentPosts, useRecentTransactions, useReportPublication, useSearchProfiles, useSearchPublications, useUnfollow, useUnreadNotificationCount, useUpdateDispatcherConfig, useUpdateFollowPolicy, useUpdateProfileDetails, useUpdateProfileImage, useWalletLogin, useWalletLogout, useWhoCollectedPublication, useWhoMirroredPublication, useWhoReacted, validateConfig };
